// Generated by AvenyModelEditor

import { IClientSubSystemModel } from '../../Types/ClientModelTypes';
import { TEDSelectionOperator as T} from '../../globalQueryTypes';

const KR: IClientSubSystemModel = {
  Code: 'KR',
  DisplayLabel: 'Kundreskontra',
  BusinessModels: {
    KRAndrahand: {
      CollectionName: 'KRAndrahand',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Andrahandskund',
        Abstract: false,
        SOLabel: 'Andrahandskund',
        SOGLabel: 'Andrahandskund',
        SBLabel: 'Andrahandskunden',
        SBGLabel: 'Andrahandskunden',
        POLabel: 'Andrahandskunder',
        POGLabel: 'Andrahandskunder',
        PBLabel: 'Andrahandskunderna',
        PBGLabel: 'Andrahandskunderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Andrahandskunden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Andrahandskunden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Andrahandskunden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Andrahandskunden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KUND_ID: {
          AttributeName: 'KUND_ID',
          DisplayLabel: 'Kundens ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KNAMN: {
          AttributeName: 'KNAMN',
          DisplayLabel: 'Namn, extra företag',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        KNR: {
          AttributeName: 'KNR',
          DisplayLabel: 'Kundnummer, extra företag',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        NIVA: {
          AttributeName: 'NIVA',
          DisplayLabel: 'Typ av extra företag',
          Hint: 'Stiftelse/Servicebyrå utan tittamöjlighet/Servicebyrå med tittamöjlighet/Full drift',
          DataType: 'Enum',
          EnumValues: new Map([['STIFTELSE', 'Stiftelse'], ['SERVICEBYRA_UTAN_TITTAMOJLIGHET', 'Servicebyrå utan tittamöjlighet'], ['SERVICEBYRA_MED_TITTAMOJLIGHET', 'Servicebyrå med tittamöjlighet'], ['FULL_DRIFT', 'Full drift']]),
          EnumSortValues: new Map([['STIFTELSE', '0'], ['SERVICEBYRA_UTAN_TITTAMOJLIGHET', '1'], ['SERVICEBYRA_MED_TITTAMOJLIGHET', '2'], ['FULL_DRIFT', '3']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="STIFTELSE=Stiftelse;SERVICEBYRA_UTAN_TITTAMOJLIGHET=Servicebyrå utan tittamöjlighet;SERVICEBYRA_MED_TITTAMOJLIGHET=Servicebyrå med tittamöjlighet;FULL_DRIFT=Full drift"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        LEVERANTOR: {
          AttributeName: 'LEVERANTOR',
          DisplayLabel: 'Program',
          Hint: 'Aveny/Meny-Spar/Hogia/Karta',
          DataType: 'Enum',
          EnumValues: new Map([['AVENY', 'Aveny'], ['MENY_SPAR', 'Meny-Spar'], ['HOGIA', 'Hogia'], ['KARTA', 'Karta']]),
          EnumSortValues: new Map([['AVENY', 'A'], ['MENY_SPAR', 'M'], ['HOGIA', 'H'], ['KARTA', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="AVENY=Aveny;MENY_SPAR=Meny-Spar;HOGIA=Hogia;KARTA=Karta"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        KDATABAS: {
          AttributeName: 'KDATABAS',
          DisplayLabel: 'Databas, extra företag',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        UPPLAGGNINGSDATUM: {
          AttributeName: 'UPPLAGGNINGSDATUM',
          DisplayLabel: 'Uppläggningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        GAS: {
          AttributeName: 'GAS',
          DisplayLabel: 'GAS',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KOR_FLER: {
          AttributeName: 'KOR_FLER',
          DisplayLabel: 'Kör fler Aveny-program',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANMARKNINGAR: {
          AttributeName: 'ANMARKNINGAR',
          DisplayLabel: 'Anmärkningar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        HANTERAR_EKONOMI: {
          AttributeName: 'HANTERAR_EKONOMI',
          DisplayLabel: 'Hanterar ekonomi',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        HANTERAR_GRAV: {
          AttributeName: 'HANTERAR_GRAV',
          DisplayLabel: 'Hanterar grav',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        HANTERAR_BOKNING: {
          AttributeName: 'HANTERAR_BOKNING',
          DisplayLabel: 'Hanterar bokning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        HANTERAR_STIFTELSE: {
          AttributeName: 'HANTERAR_STIFTELSE',
          DisplayLabel: 'Hanterar stiftelse',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        HANTERAR_KYRKNARA_BOLAG: {
          AttributeName: 'HANTERAR_KYRKNARA_BOLAG',
          DisplayLabel: 'Hanterar kyrknära bolag',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    KRAnslutning: {
      CollectionName: 'KRAnslutning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Anslutning',
        Abstract: false,
        SOLabel: 'Anslutning',
        SOGLabel: 'Anslutnings',
        SBLabel: 'Anslutningen',
        SBGLabel: 'Anslutningens',
        POLabel: 'Anslutningar',
        POGLabel: 'Anslutningars',
        PBLabel: 'Anslutningarna',
        PBGLabel: 'Anslutningarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Anslutningens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Anslutningens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Anslutningens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Anslutningens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UPPKOPPL_STEG_1: {
          AttributeName: 'UPPKOPPL_STEG_1',
          DisplayLabel: 'Steg 1, Uppkoppling',
          Hint: 'Kyrknät/VPN/Advance',
          DataType: 'Enum',
          EnumValues: new Map([['KYRKNAT', 'Kyrknät'], ['VPN', 'VPN'], ['ADVANCE', 'Advance']]),
          EnumSortValues: new Map([['KYRKNAT', 'K'], ['VPN', 'V'], ['ADVANCE', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KYRKNAT=Kyrknät;VPN=VPN;ADVANCE=Advance"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        UPPKOPPL_STEG_2: {
          AttributeName: 'UPPKOPPL_STEG_2',
          DisplayLabel: 'Steg 2, Uppkoppling',
          Hint: 'Remote Desktop',
          DataType: 'Enum',
          EnumValues: new Map([['REMOTE_DESKTOP', 'Remote Desktop']]),
          EnumSortValues: new Map([['REMOTE_DESKTOP', 'R']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="REMOTE_DESKTOP=Remote Desktop"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DATORTYP: {
          AttributeName: 'DATORTYP',
          DisplayLabel: 'Datortyp',
          Hint: 'Applikationsserver/SQL Server/Terminal/Webserver/Annat',
          DataType: 'Enum',
          EnumValues: new Map([['APPLIKATIONSSERVER', 'Applikationsserver'], ['SQL_SERVER', 'SQL Server'], ['TERMINAL', 'Terminal'], ['WEBSERVER', 'Webserver'], ['ANNAT', 'Annat']]),
          EnumSortValues: new Map([['APPLIKATIONSSERVER', 'A'], ['SQL_SERVER', 'S'], ['TERMINAL', 'T'], ['WEBSERVER', 'W'], ['ANNAT', 'Ö']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="APPLIKATIONSSERVER=Applikationsserver;SQL_SERVER=SQL Server;TERMINAL=Terminal;WEBSERVER=Webserver;ANNAT=Annat"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        DATORNAMN: {
          AttributeName: 'DATORNAMN',
          DisplayLabel: 'Datornamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IP_ADDRESS: {
          AttributeName: 'IP_ADDRESS',
          DisplayLabel: 'Ip address',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 15,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANVANDARNAMN: {
          AttributeName: 'ANVANDARNAMN',
          DisplayLabel: 'Användarnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LOSENORD: {
          AttributeName: 'LOSENORD',
          DisplayLabel: 'Lösenord',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        SENAST_ANDRAD: {
          AttributeName: 'SENAST_ANDRAD',
          DisplayLabel: 'Senast andrad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Fungerar inte/Fungerar',
          DataType: 'Enum',
          EnumValues: new Map([['FUNGERAR_INTE', 'Fungerar inte'], ['FUNGERAR', 'Fungerar']]),
          EnumSortValues: new Map([['FUNGERAR_INTE', 'I'], ['FUNGERAR', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FUNGERAR_INTE=Fungerar inte;FUNGERAR=Fungerar"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANSLUTNA_KUNDER: {
          AttributeName: 'ANSLUTNA_KUNDER',
          DisplayLabel: 'Anslutna kunder',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        SQLSERVERINSTANS: {
          AttributeName: 'SQLSERVERINSTANS',
          DisplayLabel: 'SQLServer-instans',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SA_LOSENORD: {
          AttributeName: 'SA_LOSENORD',
          DisplayLabel: 'sa-lösenord',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DATABASER: {
          AttributeName: 'DATABASER',
          DisplayLabel: 'Databaser',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kund: {
          AssociationName: 'Kund',
          DisplayLabel: 'Kund',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    KRKundkategoriGravAvtalArtikel: {
      CollectionName: 'KRKundkategoriGravAvtalArtikel',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KundkategoriGravAvtalArtikel',
        Abstract: false,
        SOLabel: 'Artikel',
        SOGLabel: 'Artikels',
        SBLabel: 'Artikeln',
        SBGLabel: 'Artikelns',
        POLabel: 'Artiklar',
        POGLabel: 'Artiklars',
        PBLabel: 'Artiklarna',
        PBGLabel: 'Artiklarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Artikelns primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Artikelns versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Artikelns id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Artikelns fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KUNDKATEGORI_ID: {
          AttributeName: 'KUNDKATEGORI_ID',
          DisplayLabel: 'Kundkategori-ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARTIKEL_ID: {
          AttributeName: 'ARTIKEL_ID',
          DisplayLabel: 'Artikel-ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kundkategori: {
          AssociationName: 'Kundkategori',
          DisplayLabel: 'Kundkategori',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRKundkategori',
          AssociatedComponentName: 'KundKategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Artikel: {
          AssociationName: 'Artikel',
          DisplayLabel: 'Artikel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Artikel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
        },
      },
    },
    KRKundkategoriUtgSkotSparrArtikel: {
      CollectionName: 'KRKundkategoriUtgSkotSparrArtikel',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KundkategoriUtgSkotSparrArtikel',
        Abstract: false,
        SOLabel: 'Artikel',
        SOGLabel: 'Artikels',
        SBLabel: 'Artikeln',
        SBGLabel: 'Artikelns',
        POLabel: 'Artiklar',
        POGLabel: 'Artiklars',
        PBLabel: 'Artiklarna',
        PBGLabel: 'Artiklarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Artikelns primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Artikelns versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Artikelns id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Artikelns fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KUNDKATEGORI_ID: {
          AttributeName: 'KUNDKATEGORI_ID',
          DisplayLabel: 'Kundkategori-ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARTIKEL_ID: {
          AttributeName: 'ARTIKEL_ID',
          DisplayLabel: 'Artikel-ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kundkategori: {
          AssociationName: 'Kundkategori',
          DisplayLabel: 'Kundkategori',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRKundkategori',
          AssociatedComponentName: 'KundKategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Artikel: {
          AssociationName: 'Artikel',
          DisplayLabel: 'Artikel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Artikel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
        },
      },
    },
    KRBetfilAvsnitt: {
      CollectionName: 'KRBetfilAvsnitt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BetfilAvsnitt',
        Abstract: false,
        SOLabel: 'Avsnitt',
        SOGLabel: 'Avsnitts',
        SBLabel: 'Avsnittet',
        SBGLabel: 'Avsnittets',
        POLabel: 'Avsnitt',
        POGLabel: 'Avsnitts',
        PBLabel: 'Avsnitten',
        PBGLabel: 'Avsnittens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Avsnittets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Avsnittets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Avsnittets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BGI_INL_TRANSKOD: {
          AttributeName: 'BGI_INL_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BGI_INL_MOTTAGAR_BANKGIRONR: {
          AttributeName: 'BGI_INL_MOTTAGAR_BANKGIRONR',
          DisplayLabel: 'Bankgironummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 10,
        },
        BGI_INL_MOTTAGAR_PLUSGIRONR: {
          AttributeName: 'BGI_INL_MOTTAGAR_PLUSGIRONR',
          DisplayLabel: 'Plusgironummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 10,
        },
        BGI_INL_VALUTA: {
          AttributeName: 'BGI_INL_VALUTA',
          DisplayLabel: 'Valuta',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 3,
        },
        BGI_AVS_TRANSKOD: {
          AttributeName: 'BGI_AVS_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BGI_AVS_MOTTAGAR_BANKGIRONR: {
          AttributeName: 'BGI_AVS_MOTTAGAR_BANKGIRONR',
          DisplayLabel: 'Bankgironummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        BGI_AVS_BETDAG: {
          AttributeName: 'BGI_AVS_BETDAG',
          DisplayLabel: 'Betalningsdag',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        BGI_AVS_LOPNR: {
          AttributeName: 'BGI_AVS_LOPNR',
          DisplayLabel: 'Insättningslöpnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 5,
        },
        BGI_AVS_BELOPP: {
          AttributeName: 'BGI_AVS_BELOPP',
          DisplayLabel: 'Insättningsbelopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 18,
        },
        BGI_AVS_VALUTA: {
          AttributeName: 'BGI_AVS_VALUTA',
          DisplayLabel: 'Valuta',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 3,
        },
        BGI_AVS_ANTALBET: {
          AttributeName: 'BGI_AVS_ANTALBET',
          DisplayLabel: 'Antal betalningar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        BGI_AVS_TYP: {
          AttributeName: 'BGI_AVS_TYP',
          DisplayLabel: 'Typ av insättning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        TI_INL_MOTTAGAR_PLUSGIRONR: {
          AttributeName: 'TI_INL_MOTTAGAR_PLUSGIRONR',
          DisplayLabel: 'Plusgironummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 36,
        },
        TI_INL_BOKFDATUM: {
          AttributeName: 'TI_INL_BOKFDATUM',
          DisplayLabel: 'Bokföringsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        TI_AVS_TOTBELOPP: {
          AttributeName: 'TI_AVS_TOTBELOPP',
          DisplayLabel: 'Totalt belopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 17,
        },
        TI_AVS_REF: {
          AttributeName: 'TI_AVS_REF',
          DisplayLabel: 'Kontoutdragsreferens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 11,
        },
        TI_INL_POSTTYP: {
          AttributeName: 'TI_INL_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TI_INL_VALUTA: {
          AttributeName: 'TI_INL_VALUTA',
          DisplayLabel: 'Valuta',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 3,
        },
        TI_AVS_POSTTYP: {
          AttributeName: 'TI_AVS_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TI_AVS_ANTALTRANS: {
          AttributeName: 'TI_AVS_ANTALTRANS',
          DisplayLabel: 'Antal transaktioner',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        MottagarKonto: {
          AttributeName: 'MottagarKonto',
          DisplayLabel: 'Mottagarkonto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Betalningsdag: {
          AttributeName: 'Betalningsdag',
          DisplayLabel: 'Betalningsdag',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Valuta: {
          AttributeName: 'Valuta',
          DisplayLabel: 'Valuta',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals, T.notequals],
          DefaultCondOperator: T.equals,
        },
        AvsnittIdentifikation: {
          AttributeName: 'AvsnittIdentifikation',
          DisplayLabel: 'AvsnittIdentifikation',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ISO_MOTTAGARKONTO: {
          AttributeName: 'ISO_MOTTAGARKONTO',
          DisplayLabel: 'Mottagarkonto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_BETALNINGSDATUM: {
          AttributeName: 'ISO_BETALNINGSDATUM',
          DisplayLabel: 'Betalningsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_VALUTA: {
          AttributeName: 'ISO_VALUTA',
          DisplayLabel: 'Valuta',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_MOTTAGARKONTO_IBAN: {
          AttributeName: 'ISO_MOTTAGARKONTO_IBAN',
          DisplayLabel: 'IBAN',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Betalningsfil: {
          AssociationName: 'Betalningsfil',
          DisplayLabel: 'Betalningsfil',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRBetalningsfil',
          AssociatedComponentName: 'Betalningsfil',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Transaktioner: {
          AssociationName: 'Transaktioner',
          DisplayLabel: 'Transaktioner',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRBetfilTrans',
          AssociatedComponentName: 'BetfilTrans',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    KRBetalningsfil: {
      CollectionName: 'KRBetalningsfil',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Betalningsfil',
        Abstract: false,
        SOLabel: 'Betalningsfil',
        SOGLabel: 'Betalningsfils',
        SBLabel: 'Betalningsfilen',
        SBGLabel: 'Betalningsfilens',
        POLabel: 'Betalningsfiler',
        POGLabel: 'Betalningsfilers',
        PBLabel: 'Betalningsfilerna',
        PBGLabel: 'Betalningsfilernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Betalningsfilens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Betalningsfilens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Betalningsfilens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BGI_INL_TRANSKOD: {
          AttributeName: 'BGI_INL_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BGI_INL_LAYOUTNAMN: {
          AttributeName: 'BGI_INL_LAYOUTNAMN',
          DisplayLabel: 'Layout',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        BGI_INL_VERSION: {
          AttributeName: 'BGI_INL_VERSION',
          DisplayLabel: 'Version',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 2,
        },
        BGI_INL_TIDSSTAMPEL: {
          AttributeName: 'BGI_INL_TIDSSTAMPEL',
          DisplayLabel: 'Tidsstämpel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        BGI_INL_TESTMARKERING: {
          AttributeName: 'BGI_INL_TESTMARKERING',
          DisplayLabel: 'Testmarkering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        BGI_AVS_TRANSKOD: {
          AttributeName: 'BGI_AVS_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BGI_AVS_ANTALBETPOSTER: {
          AttributeName: 'BGI_AVS_ANTALBETPOSTER',
          DisplayLabel: 'Antal betalningsposter',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        BGI_AVS_ANTALAVDRAGSPOSTER: {
          AttributeName: 'BGI_AVS_ANTALAVDRAGSPOSTER',
          DisplayLabel: 'Antal avdragsposter',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        BGI_AVS_ANTALREFPOSTER: {
          AttributeName: 'BGI_AVS_ANTALREFPOSTER',
          DisplayLabel: 'Antal extra referensposter',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        BGI_AVS_ANTALINSPOSTER: {
          AttributeName: 'BGI_AVS_ANTALINSPOSTER',
          DisplayLabel: 'Antal insättningsposter',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        TI_INL_INID: {
          AttributeName: 'TI_INL_INID',
          DisplayLabel: 'Total IN-ID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TI_INL_LEVERANS: {
          AttributeName: 'TI_INL_LEVERANS',
          DisplayLabel: 'Leverans',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 2,
        },
        TI_INL_FILTYP: {
          AttributeName: 'TI_INL_FILTYP',
          DisplayLabel: 'Filtyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 3,
        },
        TI_INL_FILTYPNAMN: {
          AttributeName: 'TI_INL_FILTYPNAMN',
          DisplayLabel: 'Namn på filtyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 10,
        },
        TI_AVS_ANTALRADER: {
          AttributeName: 'TI_AVS_ANTALRADER',
          DisplayLabel: 'Antal rader',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 15,
        },
        TI_INL_TIDSSTAMPEL: {
          AttributeName: 'TI_INL_TIDSSTAMPEL',
          DisplayLabel: 'Tidsstämpel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        TI_INL_POSTTYP: {
          AttributeName: 'TI_INL_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TI_AVS_POSTTYP: {
          AttributeName: 'TI_AVS_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Bankgiro Inbetalningar/Total-IN/ISO20022',
          DataType: 'Enum',
          EnumValues: new Map([['BANKGIRO_INBETALNINGAR', 'Bankgiro Inbetalningar'], ['TOTAL_IN', 'Total-IN'], ['ISO20022', 'ISO20022']]),
          EnumSortValues: new Map([['BANKGIRO_INBETALNINGAR', 'B'], ['TOTAL_IN', 'P'], ['ISO20022', 'I']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BANKGIRO_INBETALNINGAR=Bankgiro Inbetalningar;TOTAL_IN=Total-IN;ISO20022=ISO20022"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Fildatum: {
          AttributeName: 'Fildatum',
          DisplayLabel: 'Skapad datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FIL_ID: {
          AttributeName: 'FIL_ID',
          DisplayLabel: 'Fil',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Totalbelopp: {
          AttributeName: 'Totalbelopp',
          DisplayLabel: 'Totalt belopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        AntalBet: {
          AttributeName: 'AntalBet',
          DisplayLabel: 'Antal transaktioner',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        HANTERAD: {
          AttributeName: 'HANTERAD',
          DisplayLabel: 'Hanterad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        HANTERAD_DATUM: {
          AttributeName: 'HANTERAD_DATUM',
          DisplayLabel: 'Hanterad, datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        HANTERAD_SIGN: {
          AttributeName: 'HANTERAD_SIGN',
          DisplayLabel: 'Hanterad, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Hanterad_Text: {
          AttributeName: 'Hanterad_Text',
          DisplayLabel: 'Hanterad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        INBETVAG_ID: {
          AttributeName: 'INBETVAG_ID',
          DisplayLabel: 'Id, inbetalningsväg',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ISO_GRPHDR_CREDTTM: {
          AttributeName: 'ISO_GRPHDR_CREDTTM',
          DisplayLabel: 'ISO_GRPHDR_CREDTTM',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ISO_ACCT_ID: {
          AttributeName: 'ISO_ACCT_ID',
          DisplayLabel: 'Acct_Id_Othr_Id',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_ACCT_SCHMENM_CD: {
          AttributeName: 'ISO_ACCT_SCHMENM_CD',
          DisplayLabel: 'Acct_Id_Othr_SchmeNm_Cd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_ACCT_CCY: {
          AttributeName: 'ISO_ACCT_CCY',
          DisplayLabel: 'Acct_Ccy',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_ACCT_OWNR_NM: {
          AttributeName: 'ISO_ACCT_OWNR_NM',
          DisplayLabel: 'Acct_Ownr_Nm',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_ACCT_OWNR_ID: {
          AttributeName: 'ISO_ACCT_OWNR_ID',
          DisplayLabel: 'Acct_Ownr_Id_OrgId_Othr_Id',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_ACCT_OWNR_CD: {
          AttributeName: 'ISO_ACCT_OWNR_CD',
          DisplayLabel: 'Acct_Ownr_Id_OrgId_Othr_SchmeNm_Cd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_SVCR_BIC: {
          AttributeName: 'ISO_SVCR_BIC',
          DisplayLabel: 'Acct_Svcr_FinInstnId_BIC',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_NBOFNTRIES: {
          AttributeName: 'ISO_NBOFNTRIES',
          DisplayLabel: 'Ntfctn_NbOfNtries',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_SUM: {
          AttributeName: 'ISO_SUM',
          DisplayLabel: 'Ntfctn_Sum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_MSGRCPT_ID: {
          AttributeName: 'ISO_MSGRCPT_ID',
          DisplayLabel: 'MsgRcpt_Id_OrgId_Othr_Id',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_MSGRCPT_CD: {
          AttributeName: 'ISO_MSGRCPT_CD',
          DisplayLabel: 'MsgRcpt_Id_OrgId_Othr_SchmeNm_Cd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_GRPHDR_ADDTLINF: {
          AttributeName: 'ISO_GRPHDR_ADDTLINF',
          DisplayLabel: 'GrpHdr_AddtlInf',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_ACCT_SCHMENM_PRTRY: {
          AttributeName: 'ISO_ACCT_SCHMENM_PRTRY',
          DisplayLabel: 'Acct_Id_Othr_SchmeNm_Prtry',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Totalbelopp_ISO: {
          AttributeName: 'Totalbelopp_ISO',
          DisplayLabel: 'Totalbelopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ISO_ACCT_IBAN: {
          AttributeName: 'ISO_ACCT_IBAN',
          DisplayLabel: 'Acct_Id_IBAN',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kommunikationsfil: {
          AssociationName: 'Kommunikationsfil',
          DisplayLabel: 'Kommunikationsfil',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSKommunikationsfil',
          AssociatedComponentName: 'Kommunikationsfil',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
          Required: true,
        },
        Inbetalningsvag: {
          AssociationName: 'Inbetalningsvag',
          DisplayLabel: 'Inbetalningsväg',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRInbetalningsvag',
          AssociatedComponentName: 'Inbetalningsvag',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Avsnitt: {
          AssociationName: 'Avsnitt',
          DisplayLabel: 'Avsnitt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRBetfilAvsnitt',
          AssociatedComponentName: 'BetfilAvsnitt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Transaktion: {
          AssociationName: 'Transaktion',
          DisplayLabel: 'Transaktion',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRBetfilTrans',
          AssociatedComponentName: 'BetfilTrans',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    KRBetalningsorder: {
      CollectionName: 'KRBetalningsorder',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Betalningsorder',
        Abstract: false,
        SOLabel: 'Betalningsorder',
        SOGLabel: 'Betalningsorder',
        SBLabel: 'Betalningsordern',
        SBGLabel: 'Betalningsordern',
        POLabel: 'Betalningsordrar',
        POGLabel: 'Betalningsordrar',
        PBLabel: 'Betalningsordrarna',
        PBGLabel: 'Betalningsordrarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Betalningsordern primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Betalningsordern versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Betalningsordern id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Betalningsordern fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AUTOGIRO_VAG: {
          AttributeName: 'AUTOGIRO_VAG',
          DisplayLabel: 'Autogiro, skickas till',
          Hint: 'Bankgirot/Postgirot',
          DataType: 'Enum',
          EnumValues: new Map([['BANKGIROT', 'Bankgirot'], ['POSTGIROT', 'Postgirot']]),
          EnumSortValues: new Map([['BANKGIROT', 'B'], ['POSTGIROT', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BANKGIROT=Bankgirot;POSTGIROT=Postgirot"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        REG_DATUM: {
          AttributeName: 'REG_DATUM',
          DisplayLabel: 'Skapad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        REG_ANV_ID: {
          AttributeName: 'REG_ANV_ID',
          DisplayLabel: 'Skapad av',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        FIL_PRODNUMMER: {
          AttributeName: 'FIL_PRODNUMMER',
          DisplayLabel: 'Filens produktionsnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FIL_PRODDATUM: {
          AttributeName: 'FIL_PRODDATUM',
          DisplayLabel: 'Filens produktionsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        REDOVISA_PER_GRUPP: {
          AttributeName: 'REDOVISA_PER_GRUPP',
          DisplayLabel: 'Återredovisning per grupp',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Skapad/Backad',
          DataType: 'Enum',
          EnumValues: new Map([['SKAPAD', 'Skapad'], ['BACKAD', 'Backad']]),
          EnumSortValues: new Map([['SKAPAD', 'S'], ['BACKAD', 'B']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKAPAD=Skapad;BACKAD=Backad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        SummaBetalningar: {
          AttributeName: 'SummaBetalningar',
          DisplayLabel: 'Summa betalningar',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        SkapadFil: {
          AttributeName: 'SkapadFil',
          DisplayLabel: 'Skapad fil',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Betalningar: {
          AssociationName: 'Betalningar',
          DisplayLabel: 'Betalningar',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRFakturabetalning',
          AssociatedComponentName: 'FakturaBetalning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    KRFakturabetalning: {
      CollectionName: 'KRFakturabetalning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'FakturaBetalning',
        Abstract: false,
        SOLabel: 'Betalningsplan',
        SOGLabel: 'Betalningsplan',
        SBLabel: 'Betalningsplanen',
        SBGLabel: 'Betalningsplanen',
        POLabel: 'Betalningsplaner',
        POGLabel: 'Betalningsplaner',
        PBLabel: 'Betalningsplanerna',
        PBGLabel: 'Betalningsplanerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Betalningsplanen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Betalningsplanen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Betalningsplanen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Betalningsplanen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Aviseringstyp',
          Hint: 'Betalning/Betald/Makulering/Felaktig/Makulerad/Underkänd',
          DataType: 'Enum',
          EnumValues: new Map([['BETALNING', 'Betalning'], ['BETALD', 'Betald'], ['MAKULERING', 'Makulering'], ['FELAKTIG', 'Felaktig'], ['MAKULERAD', 'Makulerad'], ['UNDERKAND', 'Underkänd']]),
          EnumSortValues: new Map([['BETALNING', 'S'], ['BETALD', 'B'], ['MAKULERING', 'M'], ['FELAKTIG', 'F'], ['MAKULERAD', 'A'], ['UNDERKAND', 'U']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BETALNING=Betalning;BETALD=Betald;MAKULERING=Makulering;FELAKTIG=Felaktig;MAKULERAD=Makulerad;UNDERKAND=Underkänd"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        BETALNINGSDATUM: {
          AttributeName: 'BETALNINGSDATUM',
          DisplayLabel: 'Betalningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BELOPP: {
          AttributeName: 'BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ANTECKNING: {
          AttributeName: 'ANTECKNING',
          DisplayLabel: 'Anteckning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        FEL_KOD: {
          AttributeName: 'FEL_KOD',
          DisplayLabel: 'Felkod',
          Hint: 'Uppdraget ej utfört/Uppdraget ej utfört, betalarkonto är avslutat/Uppdraget ej utfört, men går till omförsök/Täckning saknas/Kontot avslutat eller makulerat av betalaren/Förnyad täckning',
          DataType: 'Enum',
          EnumValues: new Map([['UPPDRAGET_EJ_UTFORT', 'Uppdraget ej utfört'], ['UPPDRAGET_EJ_UTFORT__BETALARKONTO_AR_AVSLUTAT', 'Uppdraget ej utfört, betalarkonto är avslutat'], ['UPPDRAGET_EJ_UTFORT__MEN_GAR_TILL_OMFORSOK', 'Uppdraget ej utfört, men går till omförsök'], ['TACKNING_SAKNAS', 'Täckning saknas'], ['KONTOT_AVSLUTAT_ELLER_MAKULERAT_AV_BETALAREN', 'Kontot avslutat eller makulerat av betalaren'], ['FORNYAD_TACKNING', 'Förnyad täckning']]),
          EnumSortValues: new Map([['UPPDRAGET_EJ_UTFORT', '10'], ['UPPDRAGET_EJ_UTFORT__BETALARKONTO_AR_AVSLUTAT', '12'], ['UPPDRAGET_EJ_UTFORT__MEN_GAR_TILL_OMFORSOK', '13'], ['TACKNING_SAKNAS', '1'], ['KONTOT_AVSLUTAT_ELLER_MAKULERAT_AV_BETALAREN', '2'], ['FORNYAD_TACKNING', '9']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="UPPDRAGET_EJ_UTFORT=Uppdraget ej utfört;UPPDRAGET_EJ_UTFORT__BETALARKONTO_AR_AVSLUTAT=Uppdraget ej utfört, betalarkonto är avslutat;UPPDRAGET_EJ_UTFORT__MEN_GAR_TILL_OMFORSOK=Uppdraget ej utfört, men går till omförsök;TACKNING_SAKNAS=Täckning saknas;KONTOT_AVSLUTAT_ELLER_MAKULERAT_AV_BETALAREN=Kontot avslutat eller makulerat av betalaren;FORNYAD_TACKNING=Förnyad täckning"',
        },
        BETALNINGSORDER_ID: {
          AttributeName: 'BETALNINGSORDER_ID',
          DisplayLabel: 'Betalningsorder',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FOREG_BETALNINGSORDER_ID: {
          AttributeName: 'FOREG_BETALNINGSORDER_ID',
          DisplayLabel: 'Föreg betalningsorder id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Fakturanr: {
          AttributeName: 'Fakturanr',
          DisplayLabel: 'Fakturanr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KundNamn: {
          AttributeName: 'KundNamn',
          DisplayLabel: 'Kundens namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kundnr: {
          AttributeName: 'Kundnr',
          DisplayLabel: 'Kundnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Skickaddatum: {
          AttributeName: 'Skickaddatum',
          DisplayLabel: 'Skickad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Clearingnr: {
          AttributeName: 'Clearingnr',
          DisplayLabel: 'Clearingnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontonr: {
          AttributeName: 'Kontonr',
          DisplayLabel: 'Kontonr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Betalarnr: {
          AttributeName: 'Betalarnr',
          DisplayLabel: 'Betalarnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Autogirovag: {
          AttributeName: 'Autogirovag',
          DisplayLabel: 'Autogiroväg',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        HANDELSE_BOKF_GRUPP_ID: {
          AttributeName: 'HANDELSE_BOKF_GRUPP_ID',
          DisplayLabel: 'Bokf.grupp, betalningshändelse',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HANDELSE_ID: {
          AttributeName: 'HANDELSE_ID',
          DisplayLabel: 'Id, betalningshändelse',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Faktura: {
          AssociationName: 'Faktura',
          DisplayLabel: 'Faktura',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRFaktura',
          AssociatedComponentName: 'Faktura',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Betalningsorder: {
          AssociationName: 'Betalningsorder',
          DisplayLabel: 'Betalningsorder',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRBetalningsorder',
          AssociatedComponentName: 'Betalningsorder',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    KRExternprintbliaga: {
      CollectionName: 'KRExternprintbliaga',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Externprintbliaga',
        Abstract: false,
        SOLabel: 'Externprintbliaga',
        SOGLabel: 'Externprintbliaga',
        SBLabel: 'Externprintbliaga',
        SBGLabel: 'Externprintbliaga',
        POLabel: 'Externprintbliaga',
        POGLabel: 'Externprintbliaga',
        PBLabel: 'Externprintbliaga',
        PBGLabel: 'Externprintbliaga',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Externprintbliaga primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Externprintbliaga versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Externprintbliaga fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        WEBSERVICE_ID: {
          AttributeName: 'WEBSERVICE_ID',
          DisplayLabel: 'Webservice ID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SKICKAD: {
          AttributeName: 'SKICKAD',
          DisplayLabel: 'Skickad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BILAGA: {
          AttributeName: 'BILAGA',
          DisplayLabel: 'Bilaga',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        SIGN: {
          AttributeName: 'SIGN',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SOKVAG: {
          AttributeName: 'SOKVAG',
          DisplayLabel: 'Sökväg',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FELMEDDELANDE: {
          AttributeName: 'FELMEDDELANDE',
          DisplayLabel: 'Felmeddelande från överföring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BILAGA_BLOB: {
          AttributeName: 'BILAGA_BLOB',
          DisplayLabel: 'Bilaga',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    KRBetfilExtraRef: {
      CollectionName: 'KRBetfilExtraRef',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BetfilExtraRef',
        Abstract: false,
        SOLabel: 'Extra referens',
        SOGLabel: 'Extra referens',
        SBLabel: 'Extra referensen',
        SBGLabel: 'Extra referensens',
        POLabel: 'Extra referenser',
        POGLabel: 'Extra referensers',
        PBLabel: 'Extra referenserna',
        PBGLabel: 'Extra referensernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Extra referensens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Extra referensens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Extra referensens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BGI_TRANSKOD: {
          AttributeName: 'BGI_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BGI_AVSANDAR_BANKGIRONR: {
          AttributeName: 'BGI_AVSANDAR_BANKGIRONR',
          DisplayLabel: 'Betalarens bankgironummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 10,
        },
        BGI_REFERENS: {
          AttributeName: 'BGI_REFERENS',
          DisplayLabel: 'Referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 25,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BGI_BELOPP: {
          AttributeName: 'BGI_BELOPP',
          DisplayLabel: 'Betalningsbelopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 18,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BGI_REFERENSKOD: {
          AttributeName: 'BGI_REFERENSKOD',
          DisplayLabel: 'Referenskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        BGI_KANALKOD: {
          AttributeName: 'BGI_KANALKOD',
          DisplayLabel: 'Betalningskanalkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="1=Elektronisk betalning från bank;2=Betalning från Leverantörsbetalningar;3=Blankettbetalning;4=Betalning från Autogiro"',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        BGI_BGC_LOPNR: {
          AttributeName: 'BGI_BGC_LOPNR',
          DisplayLabel: 'BGC-löpnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 12,
        },
        BGI_AVBILDSMARKERING: {
          AttributeName: 'BGI_AVBILDSMARKERING',
          DisplayLabel: 'Avi-bild finns',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="1=Ja;0=Nej"',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TI_POSTTYP: {
          AttributeName: 'TI_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TI_REFNR1: {
          AttributeName: 'TI_REFNR1',
          DisplayLabel: 'Referensnummer 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        TI_REFNR2: {
          AttributeName: 'TI_REFNR2',
          DisplayLabel: 'Referensnummer 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        ExtraRefNummer: {
          AttributeName: 'ExtraRefNummer',
          DisplayLabel: 'Extra referensnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Belopp: {
          AttributeName: 'Belopp',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Transaktion: {
          AssociationName: 'Transaktion',
          DisplayLabel: 'Transaktion',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRBetfilTrans',
          AssociatedComponentName: 'BetfilTrans',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    KRFakturaBild: {
      CollectionName: 'KRFakturaBild',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'FakturaBild',
        Abstract: false,
        SOLabel: 'Fakturabild',
        SOGLabel: 'Fakturabilds',
        SBLabel: 'Fakturabilden',
        SBGLabel: 'Fakturabildens',
        POLabel: 'Fakturabilder',
        POGLabel: 'Fakturabilders',
        PBLabel: 'Fakturabilderna',
        PBGLabel: 'Fakturabildernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Fakturabildens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Fakturabildens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Fakturabildens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KIVRA_FAKTURABILD: {
          AttributeName: 'KIVRA_FAKTURABILD',
          DisplayLabel: 'Fakturabild (Kivra)',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    KRFakturarad: {
      CollectionName: 'KRFakturarad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Fakturarad',
        Abstract: false,
        SOLabel: 'Fakturarad',
        SOGLabel: 'Fakturarad',
        SBLabel: 'Fakturaraden',
        SBGLabel: 'Fakturaraden',
        POLabel: 'Fakturarader',
        POGLabel: 'Fakturarader',
        PBLabel: 'Fakturaraderna',
        PBGLabel: 'Fakturaraderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Fakturaraden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Fakturaraden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Fakturaraden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Fakturaraden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDER_ID: {
          AttributeName: 'ORDER_ID',
          DisplayLabel: 'OrderID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDER_RAD: {
          AttributeName: 'ORDER_RAD',
          DisplayLabel: 'Orderrad',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Artikelrad utan antal/Artikelrad med antal/Artikelrad (ej med vid endast fakturatotal)/Textrad/Delsumma/Delsumma samlingsfaktura/F',
          DataType: 'Enum',
          EnumValues: new Map([['ARTIKELRAD_UTAN_ANTAL', 'Artikelrad utan antal'], ['ARTIKELRAD_MED_ANTAL', 'Artikelrad med antal'], ['ARTIKELRAD__EJ_MED_VID_ENDAST_FAKTURATOTAL_', 'Artikelrad (ej med vid endast fakturatotal)'], ['TEXTRAD', 'Textrad'], ['DELSUMMA', 'Delsumma'], ['DELSUMMA_SAMLINGSFAKTURA', 'Delsumma samlingsfaktura'], ['F', 'F']]),
          EnumSortValues: new Map([['ARTIKELRAD_UTAN_ANTAL', 'A'], ['ARTIKELRAD_MED_ANTAL', 'V'], ['ARTIKELRAD__EJ_MED_VID_ENDAST_FAKTURATOTAL_', 'M'], ['TEXTRAD', 'T'], ['DELSUMMA', 'D'], ['DELSUMMA_SAMLINGSFAKTURA', 'S'], ['F', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ARTIKELRAD_UTAN_ANTAL=Artikelrad utan antal;ARTIKELRAD_MED_ANTAL=Artikelrad med antal;ARTIKELRAD__EJ_MED_VID_ENDAST_FAKTURATOTAL_=Artikelrad (ej med vid endast fakturatotal);TEXTRAD=Textrad;DELSUMMA=Delsumma;DELSUMMA_SAMLINGSFAKTURA=Delsumma samlingsfaktura;F=F"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        BELOPP: {
          AttributeName: 'BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ANTAL: {
          AttributeName: 'ANTAL',
          DisplayLabel: 'Antal',
          DataType: 'Float',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ANTAL_FRANORDERRAD: {
          AttributeName: 'ANTAL_FRANORDERRAD',
          DisplayLabel: 'Antal från orderrad',
          DataType: 'Float',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatFloat',
        },
        MOMS_ID: {
          AttributeName: 'MOMS_ID',
          DisplayLabel: 'MomsID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        ARTIKELNR: {
          AttributeName: 'ARTIKELNR',
          DisplayLabel: 'Artikelnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ENHET: {
          AttributeName: 'ENHET',
          DisplayLabel: 'Enhet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        APRIS: {
          AttributeName: 'APRIS',
          DisplayLabel: 'À-pris',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ENHET_ANTALDEC: {
          AttributeName: 'ENHET_ANTALDEC',
          DisplayLabel: 'Enhetens antal decimaler',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RABATT: {
          AttributeName: 'RABATT',
          DisplayLabel: 'Rabatt',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          FormatterDisplayParams: 'Decimals="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        FROM_DATUM: {
          AttributeName: 'FROM_DATUM',
          DisplayLabel: 'Fr o m datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        TOM_DATUM: {
          AttributeName: 'TOM_DATUM',
          DisplayLabel: 'T o m datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        BENAMNING2: {
          AttributeName: 'BENAMNING2',
          DisplayLabel: 'Benamning 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DOLJ_BELOPP: {
          AttributeName: 'DOLJ_BELOPP',
          DisplayLabel: 'Dölj belopp',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        DOLJ_RAD: {
          AttributeName: 'DOLJ_RAD',
          DisplayLabel: 'Dölj rad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        UNDERTYP: {
          AttributeName: 'UNDERTYP',
          DisplayLabel: 'Undertyp',
          Hint: 'Orderrad/Moms/Avrundning/Administrationsavgift/Orderrabatt',
          DataType: 'Enum',
          EnumValues: new Map([['ORDERRAD', 'Orderrad'], ['MOMS', 'Moms'], ['AVRUNDNING', 'Avrundning'], ['ADMINISTRATIONSAVGIFT', 'Administrationsavgift'], ['ORDERRABATT', 'Orderrabatt']]),
          EnumSortValues: new Map([['ORDERRAD', 'O'], ['MOMS', 'M'], ['AVRUNDNING', 'A'], ['ADMINISTRATIONSAVGIFT', 'D'], ['ORDERRABATT', 'R']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ORDERRAD=Orderrad;MOMS=Moms;AVRUNDNING=Avrundning;ADMINISTRATIONSAVGIFT=Administrationsavgift;ORDERRABATT=Orderrabatt"',
          GUIEditable: true,
        },
        OrderNr: {
          AttributeName: 'OrderNr',
          DisplayLabel: 'Ordernummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AntalEnhet: {
          AttributeName: 'AntalEnhet',
          DisplayLabel: 'Antal',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        LevAntal: {
          AttributeName: 'LevAntal',
          DisplayLabel: 'Levererat antal',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BestAntal: {
          AttributeName: 'BestAntal',
          DisplayLabel: 'Beställt antal',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Kreditorder: {
          AttributeName: 'Kreditorder',
          DisplayLabel: 'Kreditorder',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BenamningShort: {
          AttributeName: 'BenamningShort',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        moms: {
          AttributeName: 'moms',
          DisplayLabel: 'Moms',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsPercent',
        },
        MOMSBELAGT_BELOPP: {
          AttributeName: 'MOMSBELAGT_BELOPP',
          DisplayLabel: 'Momsbelagt belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FAKTURATEXT: {
          AttributeName: 'FAKTURATEXT',
          DisplayLabel: 'Fakturatext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        Belopp2: {
          AttributeName: 'Belopp2',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Faktura: {
          AssociationName: 'Faktura',
          DisplayLabel: 'Faktura',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRFaktura',
          AssociatedComponentName: 'Faktura',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Orderrad: {
          AssociationName: 'Orderrad',
          DisplayLabel: 'Orderrad',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OFOrderrad',
          AssociatedComponentName: 'Orderrad',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Ordern: {
          AssociationName: 'Ordern',
          DisplayLabel: 'Order',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OFOrder',
          AssociatedComponentName: 'Order',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Moms: {
          AssociationName: 'Moms',
          DisplayLabel: 'Moms',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSMoms',
          AssociatedComponentName: 'Moms',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    KRFaktura: {
      CollectionName: 'KRFaktura',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['GroupAssociation', 'Faktureringsgrupp'], ['USER_DEF_REPORT_ROUTINE', '6019']]),
      RootType: {
        TypeValue: 'Faktura',
        Abstract: true,
        SOLabel: 'Faktura',
        SOGLabel: 'Faktura',
        SBLabel: 'Fakturan',
        SBGLabel: 'Fakturan',
        POLabel: 'Fakturor',
        POGLabel: 'Fakturor',
        PBLabel: 'Fakturorna',
        PBGLabel: 'Fakturorna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'DebetFaktura',
            Abstract: false,
            SOLabel: 'Debetfaktura',
            SOGLabel: 'Debetfaktura',
            SBLabel: 'Debetfakturan',
            SBGLabel: 'Debetfakturan',
            POLabel: 'Debetfakturor',
            POGLabel: 'Debetfakturor',
            PBLabel: 'Debetfakturorna',
            PBGLabel: 'Debetfakturorna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'KreditFaktura',
            Abstract: false,
            SOLabel: 'Kreditfaktura',
            SOGLabel: 'Kreditfaktura',
            SBLabel: 'Kreditfakturan',
            SBGLabel: 'Kreditfakturan',
            POLabel: 'Kreditfakturor',
            POGLabel: 'Kreditfakturor',
            PBLabel: 'Kreditfakturorna',
            PBGLabel: 'Kreditfakturorna',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Fakturan primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Fakturan versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['DEBETFAKTURA', 'Debetfaktura'], ['KREDITFAKTURA', 'Kreditfaktura']]),
          EnumSortValues: new Map([['DEBETFAKTURA', 'D'], ['KREDITFAKTURA', 'K']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="DEBETFAKTURA=Debetfaktura;KREDITFAKTURA=Kreditfaktura"',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Fakturan id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Fakturan fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDER_ID: {
          AttributeName: 'ORDER_ID',
          DisplayLabel: 'OrderID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SLUTBETALD: {
          AttributeName: 'SLUTBETALD',
          DisplayLabel: 'Slutbetald',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        FAKTURA_NR: {
          AttributeName: 'FAKTURA_NR',
          DisplayLabel: 'Fakturanr',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KUND_ID: {
          AttributeName: 'KUND_ID',
          DisplayLabel: 'KundID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Kundnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 82,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Kunduppgifter',
        },
        CO: {
          AttributeName: 'CO',
          DisplayLabel: 'Kundens CO',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Kunduppgifter',
        },
        ADRESS: {
          AttributeName: 'ADRESS',
          DisplayLabel: 'Kundens adress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Kunduppgifter',
        },
        POSTNR: {
          AttributeName: 'POSTNR',
          DisplayLabel: 'Kundens postnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatPostNr',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Kunduppgifter',
        },
        ORT: {
          AttributeName: 'ORT',
          DisplayLabel: 'Kundens ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Kunduppgifter',
        },
        KUNDREFERENS: {
          AttributeName: 'KUNDREFERENS',
          DisplayLabel: 'Kundreferens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Kunduppgifter',
        },
        VARREFERENS: {
          AttributeName: 'VARREFERENS',
          DisplayLabel: 'Vår referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FAKTURARUBRIK: {
          AttributeName: 'FAKTURARUBRIK',
          DisplayLabel: 'Fakturarubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FAKTURATOTAL: {
          AttributeName: 'FAKTURATOTAL',
          DisplayLabel: 'Fakturatotal',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
        },
        ORDERDATUM: {
          AttributeName: 'ORDERDATUM',
          DisplayLabel: 'Orderdatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        ORDERNR: {
          AttributeName: 'ORDERNR',
          DisplayLabel: 'Ordernummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        MOMS: {
          AttributeName: 'MOMS',
          DisplayLabel: 'Moms',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          Required: true,
        },
        LAND_ID: {
          AttributeName: 'LAND_ID',
          DisplayLabel: 'LandID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BETALARE_ID: {
          AttributeName: 'BETALARE_ID',
          DisplayLabel: 'BetalareID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DROJ_RANTEFAKTURERAS: {
          AttributeName: 'DROJ_RANTEFAKTURERAS',
          DisplayLabel: 'Räntefaktureras',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
          Required: true,
        },
        Drojsmalsrantefakturerad: {
          AttributeName: 'Drojsmalsrantefakturerad',
          DisplayLabel: 'Dröjsmålsräntefakturerad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          AttributeGroup: 'Övrigt',
        },
        DROJ_RANTE_ORDER_ID: {
          AttributeName: 'DROJ_RANTE_ORDER_ID',
          DisplayLabel: 'RänteorderID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DROJ_RANTE_ORDER_RAD: {
          AttributeName: 'DROJ_RANTE_ORDER_RAD',
          DisplayLabel: 'Ränteorder rad',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KRAVUTSKRIFT: {
          AttributeName: 'KRAVUTSKRIFT',
          DisplayLabel: 'Skicka krav',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Krav',
        },
        ORDERTYP: {
          AttributeName: 'ORDERTYP',
          DisplayLabel: 'Typ av order',
          Hint: 'Direktorder/Erbjudande/Beställningsorder/Fasttidsavtalsorder/Periodorder/Avräkningsavtalsorder/Före detta erbjudande',
          DataType: 'Enum',
          EnumValues: new Map([['DIREKTORDER', 'Direktorder'], ['ERBJUDANDE', 'Erbjudande'], ['BESTALLNINGSORDER', 'Beställningsorder'], ['FASTTIDSAVTALSORDER', 'Fasttidsavtalsorder'], ['PERIODORDER', 'Periodorder'], ['AVRAKNINGSAVTALSORDER', 'Avräkningsavtalsorder'], ['FORE_DETTA_ERBJUDANDE', 'Före detta erbjudande']]),
          EnumSortValues: new Map([['DIREKTORDER', 'D'], ['ERBJUDANDE', 'E'], ['BESTALLNINGSORDER', 'R'], ['FASTTIDSAVTALSORDER', 'V'], ['PERIODORDER', 'P'], ['AVRAKNINGSAVTALSORDER', 'A'], ['FORE_DETTA_ERBJUDANDE', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="DIREKTORDER=Direktorder;ERBJUDANDE=Erbjudande;BESTALLNINGSORDER=Beställningsorder;FASTTIDSAVTALSORDER=Fasttidsavtalsorder;PERIODORDER=Periodorder;AVRAKNINGSAVTALSORDER=Avräkningsavtalsorder;FORE_DETTA_ERBJUDANDE=Före detta erbjudande"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        FAKTURADATUM: {
          AttributeName: 'FAKTURADATUM',
          DisplayLabel: 'Fakturadatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Datum',
        },
        FAKTURERINGSSATT: {
          AttributeName: 'FAKTURERINGSSATT',
          DisplayLabel: 'Faktureringssätt',
          Hint: 'Faktura/Kontofaktura/Bankkonto/Avräkning från konto/Autogiro/KOB faktura',
          DataType: 'Enum',
          EnumValues: new Map([['FAKTURA', 'Faktura'], ['KONTOFAKTURA', 'Kontofaktura'], ['BANKKONTO', 'Bankkonto'], ['AVRAKNING_FRAN_KONTO', 'Avräkning från konto'], ['AUTOGIRO', 'Autogiro'], ['KOB_FAKTURA', 'KOB faktura']]),
          EnumSortValues: new Map([['FAKTURA', 'F'], ['KONTOFAKTURA', 'K'], ['BANKKONTO', 'B'], ['AVRAKNING_FRAN_KONTO', 'A'], ['AUTOGIRO', 'U'], ['KOB_FAKTURA', 'O']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAKTURA=Faktura;KONTOFAKTURA=Kontofaktura;BANKKONTO=Bankkonto;AVRAKNING_FRAN_KONTO=Avräkning från konto;AUTOGIRO=Autogiro;KOB_FAKTURA=KOB faktura"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        HANDELSE_ID: {
          AttributeName: 'HANDELSE_ID',
          DisplayLabel: 'HändelseID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUMMA_ATT_BETALA: {
          AttributeName: 'SUMMA_ATT_BETALA',
          DisplayLabel: 'Summa att betala',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        LEVNAMN: {
          AttributeName: 'LEVNAMN',
          DisplayLabel: 'Leverans,namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Leverans',
        },
        LEVADRESS: {
          AttributeName: 'LEVADRESS',
          DisplayLabel: 'Leverans,adress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Leverans',
        },
        LEVCO: {
          AttributeName: 'LEVCO',
          DisplayLabel: 'Leverans,CO',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Leverans',
        },
        LEVPOSTNR: {
          AttributeName: 'LEVPOSTNR',
          DisplayLabel: 'Leverans,postnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatPostNr',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Leverans',
        },
        LEVORT: {
          AttributeName: 'LEVORT',
          DisplayLabel: 'Leverans,ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Leverans',
        },
        LEVLAND_ID: {
          AttributeName: 'LEVLAND_ID',
          DisplayLabel: 'LeveranslandID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Leverans',
        },
        AUTOGIRO_VAG: {
          AttributeName: 'AUTOGIRO_VAG',
          DisplayLabel: 'Autogiro, skickas till',
          Hint: 'Bankgirot/PlusGirot',
          DataType: 'Enum',
          EnumValues: new Map([['BANKGIROT', 'Bankgirot'], ['PLUSGIROT', 'PlusGirot']]),
          EnumSortValues: new Map([['BANKGIROT', 'B'], ['PLUSGIROT', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BANKGIROT=Bankgirot;PLUSGIROT=PlusGirot"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_ANTAL_DELBET: {
          AttributeName: 'AUTOGIRO_ANTAL_DELBET',
          DisplayLabel: 'Autogiro, antal delbetalningar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MaxValue="20"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_PERIODICITET: {
          AttributeName: 'AUTOGIRO_PERIODICITET',
          DisplayLabel: 'Autogiro, periodicitet',
          Hint: 'Varje månad/Varannan månad/Var tredje månad/Var fjärde månad/Var sjätte månad/Varje år',
          DataType: 'Enum',
          EnumValues: new Map([['VARJE_MANAD', 'Varje månad'], ['VARANNAN_MANAD', 'Varannan månad'], ['VAR_TREDJE_MANAD', 'Var tredje månad'], ['VAR_FJARDE_MANAD', 'Var fjärde månad'], ['VAR_SJATTE_MANAD', 'Var sjätte månad'], ['VARJE_AR', 'Varje år']]),
          EnumSortValues: new Map([['VARJE_MANAD', '1'], ['VARANNAN_MANAD', '2'], ['VAR_TREDJE_MANAD', '3'], ['VAR_FJARDE_MANAD', '4'], ['VAR_SJATTE_MANAD', '6'], ['VARJE_AR', '12']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="VARJE_MANAD=Varje månad;VARANNAN_MANAD=Varannan månad;VAR_TREDJE_MANAD=Var tredje månad;VAR_FJARDE_MANAD=Var fjärde månad;VAR_SJATTE_MANAD=Var sjätte månad;VARJE_AR=Varje år"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_BETALNINGSDAG: {
          AttributeName: 'AUTOGIRO_BETALNINGSDAG',
          DisplayLabel: 'Autogiro, betalningsdag',
          Hint: 'Sista bankdag/1/2/3/4/5/6/7/8/9/10/11/12/13/14/15/16/17/18/19/20/21/22/23/24/25/26/27/28/29/30/31',
          DataType: 'Enum',
          EnumValues: new Map([['ASISTA_BANKDAG', 'Sista bankdag'], ['A1', '1'], ['A2', '2'], ['A3', '3'], ['A4', '4'], ['A5', '5'], ['A6', '6'], ['A7', '7'], ['A8', '8'], ['A9', '9'], ['A10', '10'], ['A11', '11'], ['A12', '12'], ['A13', '13'], ['A14', '14'], ['A15', '15'], ['A16', '16'], ['A17', '17'], ['A18', '18'], ['A19', '19'], ['A20', '20'], ['A21', '21'], ['A22', '22'], ['A23', '23'], ['A24', '24'], ['A25', '25'], ['A26', '26'], ['A27', '27'], ['A28', '28'], ['A29', '29'], ['A30', '30'], ['A31', '31']]),
          EnumSortValues: new Map([['ASISTA_BANKDAG', '0'], ['A1', '1'], ['A2', '2'], ['A3', '3'], ['A4', '4'], ['A5', '5'], ['A6', '6'], ['A7', '7'], ['A8', '8'], ['A9', '9'], ['A10', '10'], ['A11', '11'], ['A12', '12'], ['A13', '13'], ['A14', '14'], ['A15', '15'], ['A16', '16'], ['A17', '17'], ['A18', '18'], ['A19', '19'], ['A20', '20'], ['A21', '21'], ['A22', '22'], ['A23', '23'], ['A24', '24'], ['A25', '25'], ['A26', '26'], ['A27', '27'], ['A28', '28'], ['A29', '29'], ['A30', '30'], ['A31', '31']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ASISTA_BANKDAG=Sista bankdag;A1=1;A2=2;A3=3;A4=4;A5=5;A6=6;A7=7;A8=8;A9=9;A10=10;A11=11;A12=12;A13=13;A14=14;A15=15;A16=16;A17=17;A18=18;A19=19;A20=20;A21=21;A22=22;A23=23;A24=24;A25=25;A26=26;A27=27;A28=28;A29=29;A30=30;A31=31"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_SLUTBETALAS: {
          AttributeName: 'AUTOGIRO_SLUTBETALAS',
          DisplayLabel: 'Autogiro, slutbetald innev. år',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_CLEARINGNR: {
          AttributeName: 'AUTOGIRO_CLEARINGNR',
          DisplayLabel: 'Autogiro, clearingnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_KONTONR: {
          AttributeName: 'AUTOGIRO_KONTONR',
          DisplayLabel: 'Autogiro, kontonr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 15,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Autogiro',
        },
        SAMFAKTURERAD: {
          AttributeName: 'SAMFAKTURERAD',
          DisplayLabel: 'Samfakturerad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        RABATT: {
          AttributeName: 'RABATT',
          DisplayLabel: 'Rabatt',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        AUTOGIRO_BETMANAD_1: {
          AttributeName: 'AUTOGIRO_BETMANAD_1',
          DisplayLabel: 'Autogiro, dragning januari',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        AUTOGIRO_BETMANAD_2: {
          AttributeName: 'AUTOGIRO_BETMANAD_2',
          DisplayLabel: 'Autogiro, dragning februari',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        AUTOGIRO_BETMANAD_3: {
          AttributeName: 'AUTOGIRO_BETMANAD_3',
          DisplayLabel: 'Autogiro, dragning mars',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        AUTOGIRO_BETMANAD_4: {
          AttributeName: 'AUTOGIRO_BETMANAD_4',
          DisplayLabel: 'Autogiro, dragning april',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        AUTOGIRO_BETMANAD_5: {
          AttributeName: 'AUTOGIRO_BETMANAD_5',
          DisplayLabel: 'Autogiro, dragning maj',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        AUTOGIRO_BETMANAD_6: {
          AttributeName: 'AUTOGIRO_BETMANAD_6',
          DisplayLabel: 'Autogiro, dragning juni',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        AUTOGIRO_BETMANAD_7: {
          AttributeName: 'AUTOGIRO_BETMANAD_7',
          DisplayLabel: 'Autogiro, dragning juli',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        AUTOGIRO_BETMANAD_8: {
          AttributeName: 'AUTOGIRO_BETMANAD_8',
          DisplayLabel: 'Autogiro, dragning augusti',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        AUTOGIRO_BETMANAD_9: {
          AttributeName: 'AUTOGIRO_BETMANAD_9',
          DisplayLabel: 'Autogiro, dragning september',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        AUTOGIRO_BETMANAD_10: {
          AttributeName: 'AUTOGIRO_BETMANAD_10',
          DisplayLabel: 'Autogiro, dragning oktober',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        AUTOGIRO_BETMANAD_11: {
          AttributeName: 'AUTOGIRO_BETMANAD_11',
          DisplayLabel: 'Autogiro, dragning november',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        AUTOGIRO_BETMANAD_12: {
          AttributeName: 'AUTOGIRO_BETMANAD_12',
          DisplayLabel: 'Autogiro, dragning december',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        AUTOGIRO_BETALARNR: {
          AttributeName: 'AUTOGIRO_BETALARNR',
          DisplayLabel: 'Autogiro, betalarnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Autogiro',
        },
        OSAKER: {
          AttributeName: 'OSAKER',
          DisplayLabel: 'Osäker fordran',
          Hint: 'Osäker/Säker',
          DataType: 'Enum',
          EnumValues: new Map([['OSAKER', 'Osäker'], ['SAKER', 'Säker']]),
          EnumSortValues: new Map([['OSAKER', 'Y'], ['SAKER', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="OSAKER=Osäker;SAKER=Säker"',
          InterfaceType: 'ifBoolean',
        },
        RANTEORDER_ID: {
          AttributeName: 'RANTEORDER_ID',
          DisplayLabel: 'Ränteorder, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS_ELEKTRONISKFAKTURA: {
          AttributeName: 'STATUS_ELEKTRONISKFAKTURA',
          DisplayLabel: 'Status',
          Hint: 'Ej skickad/Skickad/Mottagen/Betald/Felaktig/Parkerad/Spärrad/Påminnelse skickad/Obetald faktura reverserad',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_SKICKAD', 'Ej skickad'], ['SKICKAD', 'Skickad'], ['MOTTAGEN', 'Mottagen'], ['BETALD', 'Betald'], ['FELAKTIG', 'Felaktig'], ['PARKERAD', 'Parkerad'], ['SPARRAD', 'Spärrad'], ['PAMINNELSE_SKICKAD', 'Påminnelse skickad'], ['OBETALD_FAKTURA_REVERSERAD', 'Obetald faktura reverserad']]),
          EnumSortValues: new Map([['EJ_SKICKAD', 'E'], ['SKICKAD', 'S'], ['MOTTAGEN', 'M'], ['BETALD', 'B'], ['FELAKTIG', 'F'], ['PARKERAD', 'P'], ['SPARRAD', 'Ä'], ['PAMINNELSE_SKICKAD', 'Å'], ['OBETALD_FAKTURA_REVERSERAD', 'O']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_SKICKAD=Ej skickad;SKICKAD=Skickad;MOTTAGEN=Mottagen;BETALD=Betald;FELAKTIG=Felaktig;PARKERAD=Parkerad;SPARRAD=Spärrad;PAMINNELSE_SKICKAD=Påminnelse skickad;OBETALD_FAKTURA_REVERSERAD=Obetald faktura reverserad"',
          GUIEditable: true,
          AttributeGroup: 'Övrigt',
        },
        FELTEXT: {
          AttributeName: 'FELTEXT',
          DisplayLabel: 'Feltext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
          AttributeGroup: 'Övrigt',
        },
        BUNT_ID: {
          AttributeName: 'BUNT_ID',
          DisplayLabel: 'BuntID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundNr: {
          AttributeName: 'KundNr',
          DisplayLabel: 'Kundnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundNamnAdress: {
          AttributeName: 'KundNamnAdress',
          DisplayLabel: 'Kundens namn och adress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SenasteBetalnDatum: {
          AttributeName: 'SenasteBetalnDatum',
          DisplayLabel: 'Senaste betalningsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Datum',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        SenasteKredDatum: {
          AttributeName: 'SenasteKredDatum',
          DisplayLabel: 'Senaste krediteringsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Datum',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        SenasteBetKredDatum: {
          AttributeName: 'SenasteBetKredDatum',
          DisplayLabel: 'SenasteBetKredDatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        BetKredStatus: {
          AttributeName: 'BetKredStatus',
          DisplayLabel: 'Betald/Krediterad datum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Datum',
        },
        KundTYP: {
          AttributeName: 'KundTYP',
          DisplayLabel: 'KundTYP',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundTelefon: {
          AttributeName: 'KundTelefon',
          DisplayLabel: 'Kundens telefonnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundBankNamn: {
          AttributeName: 'KundBankNamn',
          DisplayLabel: 'Kundens bank',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KundBankkontoNr: {
          AttributeName: 'KundBankkontoNr',
          DisplayLabel: 'Kundens bankkontonummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KundBankkontoNrTot: {
          AttributeName: 'KundBankkontoNrTot',
          DisplayLabel: 'Kundens bankkontonr (inkl clearingnr)',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KundFAKTUTSKRIFT_KONTOFAKTURA: {
          AttributeName: 'KundFAKTUTSKRIFT_KONTOFAKTURA',
          DisplayLabel: 'KundFAKTUTSKRIFT_KONTOFAKTURA',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundFAKTUTSKRIFT_BANKKONTO: {
          AttributeName: 'KundFAKTUTSKRIFT_BANKKONTO',
          DisplayLabel: 'KundFAKTUTSKRIFT_BANKKONTO',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RegVernr: {
          AttributeName: 'RegVernr',
          DisplayLabel: 'Verifikationsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          AttributeGroup: 'Övrigt',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        JournalID: {
          AttributeName: 'JournalID',
          DisplayLabel: 'JournalID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RegVerdatum: {
          AttributeName: 'RegVerdatum',
          DisplayLabel: 'Bokföringsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Datum',
        },
        BetalareNamn: {
          AttributeName: 'BetalareNamn',
          DisplayLabel: 'Betalarens namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Betalaruppgifter',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        BetalareNamnAdress: {
          AttributeName: 'BetalareNamnAdress',
          DisplayLabel: 'Betalarens namn och adress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Betalaruppgifter',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        BetalareCO: {
          AttributeName: 'BetalareCO',
          DisplayLabel: 'Betalarens CO',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Betalaruppgifter',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        BetalareGatuadress: {
          AttributeName: 'BetalareGatuadress',
          DisplayLabel: 'Betalarens gatuadress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Betalaruppgifter',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        BetalarePostNr: {
          AttributeName: 'BetalarePostNr',
          DisplayLabel: 'Betalarens postnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatPostNr',
          AttributeGroup: 'Betalaruppgifter',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        BetalareOrt: {
          AttributeName: 'BetalareOrt',
          DisplayLabel: 'Betalarens ort',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Betalaruppgifter',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        BetalareBanknamn: {
          AttributeName: 'BetalareBanknamn',
          DisplayLabel: 'Betalarens bank',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Betalaruppgifter',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        BetalareBankkontoNr: {
          AttributeName: 'BetalareBankkontoNr',
          DisplayLabel: 'Betalarens bankkontonummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Betalaruppgifter',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        BetalareBankkontoNrTot: {
          AttributeName: 'BetalareBankkontoNrTot',
          DisplayLabel: 'Betalarens bankkontonr (inkl clearingnr)',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Betalaruppgifter',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        FakturaAdress: {
          AttributeName: 'FakturaAdress',
          DisplayLabel: 'Fakturaadress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Faktureringsgrupp: {
          AttributeName: 'Faktureringsgrupp',
          DisplayLabel: 'Faktureringsgrupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Land: {
          AttributeName: 'Land',
          DisplayLabel: 'Land',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        PostnrPrefix: {
          AttributeName: 'PostnrPrefix',
          DisplayLabel: 'Postnummerprefix (land)',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FakturaSaldo: {
          AttributeName: 'FakturaSaldo',
          DisplayLabel: 'Saldo',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Fakturabelopp: {
          AttributeName: 'Fakturabelopp',
          DisplayLabel: 'Fakturabelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        SaldoPerDatum: {
          AttributeName: 'SaldoPerDatum',
          DisplayLabel: 'Saldo per datum',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeParams: {'spd_datum': {type: 'Date', defaultValue: ''}},
        },
        KundNamn: {
          AttributeName: 'KundNamn',
          DisplayLabel: 'Kundens namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KundAdressRad: {
          AttributeName: 'KundAdressRad',
          DisplayLabel: 'Kundens adress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AntalInkasso: {
          AttributeName: 'AntalInkasso',
          DisplayLabel: 'AntalInkasso',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LeveransAdress: {
          AttributeName: 'LeveransAdress',
          DisplayLabel: 'Leveransadress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Leverans',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        LevLand: {
          AttributeName: 'LevLand',
          DisplayLabel: 'Leveransland',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Leverans',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        OrderForfallodatum: {
          AttributeName: 'OrderForfallodatum',
          DisplayLabel: 'Orderns förfallodatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Betalningsplansaldo: {
          AttributeName: 'Betalningsplansaldo',
          DisplayLabel: 'Betalningsplansaldo',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        OrderIntern: {
          AttributeName: 'OrderIntern',
          DisplayLabel: 'Intern order',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundAutogiroStatus: {
          AttributeName: 'KundAutogiroStatus',
          DisplayLabel: 'Autogiro, status',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundAutogiroFromDatum: {
          AttributeName: 'KundAutogiroFromDatum',
          DisplayLabel: 'KundAutogiroFromDatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        kundKategoriBen: {
          AttributeName: 'kundKategoriBen',
          DisplayLabel: 'Kundkategori',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Gravfaktura: {
          AttributeName: 'Gravfaktura',
          DisplayLabel: 'Gravfaktura',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        KundNrNamn: {
          AttributeName: 'KundNrNamn',
          DisplayLabel: 'Kund',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OrderRubrik: {
          AttributeName: 'OrderRubrik',
          DisplayLabel: 'Intern rubrik',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Krediterad: {
          AttributeName: 'Krediterad',
          DisplayLabel: 'Krediterad',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        DebFaktFaktNr: {
          AttributeName: 'DebFaktFaktNr',
          DisplayLabel: 'Debetfakturans fakturanummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BetalaFaktura: {
          AttributeName: 'BetalaFaktura',
          DisplayLabel: 'Betala faktura',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Övrigt',
        },
        Orderns_fakturarubrik: {
          AttributeName: 'Orderns_fakturarubrik',
          DisplayLabel: 'Orderns fakturarubrik',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AntalKrav: {
          AttributeName: 'AntalKrav',
          DisplayLabel: 'AntalKrav',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Krav',
        },
        calcRantefakturerad: {
          AttributeName: 'calcRantefakturerad',
          DisplayLabel: 'Dröjsmålsränta beräknad',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        DgrEfterFdatum: {
          AttributeName: 'DgrEfterFdatum',
          DisplayLabel: 'Antag dgr efter förfallodatum',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          AttributeParams: {'def_datum': {type: 'Date', defaultValue: ''}},
        },
        xml: {
          AttributeName: 'xml',
          DisplayLabel: 'xml',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        clearing: {
          AttributeName: 'clearing',
          DisplayLabel: 'Clearing',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORFALLODATUM_FLAGGA: {
          AttributeName: 'FORFALLODATUM_FLAGGA',
          DisplayLabel: 'Förfallodatum, flagga',
          Hint: 'Angivet',
          DataType: 'Enum',
          EnumValues: new Map([['ANGIVET', 'Angivet']]),
          EnumSortValues: new Map([['ANGIVET', 'A']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANGIVET=Angivet"',
        },
        VisaBetalningsvillkor: {
          AttributeName: 'VisaBetalningsvillkor',
          DisplayLabel: 'Visa betalningsvillkor på faktura',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
        },
        BESTALLARE_ID: {
          AttributeName: 'BESTALLARE_ID',
          DisplayLabel: 'BeställareID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['DebetFaktura'],
        },
        FORFALLO_DATUM: {
          AttributeName: 'FORFALLO_DATUM',
          DisplayLabel: 'Förfallodatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['DebetFaktura'],
          AttributeGroup: 'Datum',
        },
        FROM_DATUM: {
          AttributeName: 'FROM_DATUM',
          DisplayLabel: 'Fr o m  datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          ValidInComps: ['DebetFaktura'],
          AttributeGroup: 'Datum',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        TOM_DATUM: {
          AttributeName: 'TOM_DATUM',
          DisplayLabel: 'T o m datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          ValidInComps: ['DebetFaktura'],
          AttributeGroup: 'Datum',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        BETALNINGSVILLKOR_ID: {
          AttributeName: 'BETALNINGSVILLKOR_ID',
          DisplayLabel: 'BetalningsvillkorID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['DebetFaktura'],
        },
        BetalningsvillkorANTALDAGAR: {
          AttributeName: 'BetalningsvillkorANTALDAGAR',
          DisplayLabel: 'Antal dagar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['DebetFaktura'],
        },
        BetalningsvillkorKod: {
          AttributeName: 'BetalningsvillkorKod',
          DisplayLabel: 'Betalningsvillkor',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['DebetFaktura'],
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        BetalningsvillkorText: {
          AttributeName: 'BetalningsvillkorText',
          DisplayLabel: 'BetalningsvillkorText',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['DebetFaktura'],
        },
        Kravrutin: {
          AttributeName: 'Kravrutin',
          DisplayLabel: 'Kravrutin',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['DebetFaktura'],
          AttributeGroup: 'Krav',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Sprak: {
          AttributeName: 'Sprak',
          DisplayLabel: 'SpråkID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['DebetFaktura'],
        },
        Kravnummer: {
          AttributeName: 'Kravnummer',
          DisplayLabel: 'Kravnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['DebetFaktura'],
          AttributeGroup: 'Krav',
        },
        FaktDrojsmalsranta: {
          AttributeName: 'FaktDrojsmalsranta',
          DisplayLabel: 'Fakturerad dröjsmålsränta',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['DebetFaktura'],
          AttributeGroup: 'Övrigt',
        },
        EFAKTURA_EXPORTERAD: {
          AttributeName: 'EFAKTURA_EXPORTERAD',
          DisplayLabel: 'E-faktura exporterad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Övrigt',
        },
        SprakID: {
          AttributeName: 'SprakID',
          DisplayLabel: 'Språk id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTNR_OCR: {
          AttributeName: 'FAKTNR_OCR',
          DisplayLabel: 'Faktura OCR',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        FAKTNAMN: {
          AttributeName: 'FAKTNAMN',
          DisplayLabel: 'Särskild fakt.adress, namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Faktureringsadress',
        },
        FAKTADRESS: {
          AttributeName: 'FAKTADRESS',
          DisplayLabel: 'Särskild fakt.adress, gatuadress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Faktureringsadress',
        },
        FAKTCO: {
          AttributeName: 'FAKTCO',
          DisplayLabel: 'Särskild fakt.adress, CO',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Faktureringsadress',
        },
        FAKTPOSTNR: {
          AttributeName: 'FAKTPOSTNR',
          DisplayLabel: 'Särskild fakt.adress, postnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatPostNr',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Faktureringsadress',
        },
        FAKTORT: {
          AttributeName: 'FAKTORT',
          DisplayLabel: 'Särskild fakt.adress, ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Faktureringsadress',
        },
        FAKTLAND_ID: {
          AttributeName: 'FAKTLAND_ID',
          DisplayLabel: 'Särskild fakt.adress, land',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Faktureringsadress',
        },
        IFaktNamn: {
          AttributeName: 'IFaktNamn',
          DisplayLabel: 'IFaktNamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IFaktCO: {
          AttributeName: 'IFaktCO',
          DisplayLabel: 'IFaktCO',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IFaktAdress: {
          AttributeName: 'IFaktAdress',
          DisplayLabel: 'IFaktAdress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IFaktPostnr: {
          AttributeName: 'IFaktPostnr',
          DisplayLabel: 'IFaktPostnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatPostNr',
        },
        IFaktOrt: {
          AttributeName: 'IFaktOrt',
          DisplayLabel: 'IFaktOrt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IFaktLandKod: {
          AttributeName: 'IFaktLandKod',
          DisplayLabel: 'IFaktLandKod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IFaktLand: {
          AttributeName: 'IFaktLand',
          DisplayLabel: 'IFaktLand',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IFaktLandId: {
          AttributeName: 'IFaktLandId',
          DisplayLabel: 'IFaktLandId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HarSarskildFaktureringsadress: {
          AttributeName: 'HarSarskildFaktureringsadress',
          DisplayLabel: 'HarSarskildFaktureringsadress',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SarskildFakturaAdress: {
          AttributeName: 'SarskildFakturaAdress',
          DisplayLabel: 'Faktureringsadress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Faktureringsadress',
        },
        Faktureringsland: {
          AttributeName: 'Faktureringsland',
          DisplayLabel: 'Faktureringsland',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Faktureringsadress',
        },
        ForfallodatumDagManad: {
          AttributeName: 'ForfallodatumDagManad',
          DisplayLabel: 'Förfallodatum med dag och månad',
          Hint: 'Exempel 1 april',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Datum',
        },
        PRINTSATT: {
          AttributeName: 'PRINTSATT',
          DisplayLabel: 'Printsätt',
          Hint: 'Svenska Kyrkans Fakturaväxel/Egen utskrift/Export till Agresso/XML/Digital brevlåda (Kivra)/E-post/Dynamics',
          DataType: 'Enum',
          EnumValues: new Map([['SVENSKA_KYRKANS_FAKTURAVAXEL', 'Svenska Kyrkans Fakturaväxel'], ['EGEN_UTSKRIFT', 'Egen utskrift'], ['EXPORT_TILL_AGRESSO', 'Export till Agresso'], ['XML', 'XML'], ['DIGITAL_BREVLADA__KIVRA_', 'Digital brevlåda (Kivra)'], ['E_POST', 'E-post'], ['DYNAMICS', 'Dynamics']]),
          EnumSortValues: new Map([['SVENSKA_KYRKANS_FAKTURAVAXEL', 'P'], ['EGEN_UTSKRIFT', 'U'], ['EXPORT_TILL_AGRESSO', 'A'], ['XML', 'X'], ['DIGITAL_BREVLADA__KIVRA_', 'K'], ['E_POST', 'E'], ['DYNAMICS', 'D']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SVENSKA_KYRKANS_FAKTURAVAXEL=Svenska Kyrkans Fakturaväxel;EGEN_UTSKRIFT=Egen utskrift;EXPORT_TILL_AGRESSO=Export till Agresso;XML=XML;DIGITAL_BREVLADA__KIVRA_=Digital brevlåda (Kivra);E_POST=E-post;DYNAMICS=Dynamics"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DISTRIBUTIONSSATT: {
          AttributeName: 'DISTRIBUTIONSSATT',
          DisplayLabel: 'Distributionssätt',
          Hint: 'Central utskrift/E-faktura privat/E-faktura företag/Peppol',
          DataType: 'Enum',
          EnumValues: new Map([['CENTRAL_UTSKRIFT', 'Central utskrift'], ['E_FAKTURA_PRIVAT', 'E-faktura privat'], ['E_FAKTURA_FORETAG', 'E-faktura företag'], ['PEPPOL', 'Peppol']]),
          EnumSortValues: new Map([['CENTRAL_UTSKRIFT', 'T'], ['E_FAKTURA_PRIVAT', 'P'], ['E_FAKTURA_FORETAG', 'C'], ['PEPPOL', 'L']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="CENTRAL_UTSKRIFT=Central utskrift;E_FAKTURA_PRIVAT=E-faktura privat;E_FAKTURA_FORETAG=E-faktura företag;PEPPOL=Peppol"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PRINTLAYOUT: {
          AttributeName: 'PRINTLAYOUT',
          DisplayLabel: 'Printlayout',
          Hint: 'Faktura/Erbjudande',
          DataType: 'Enum',
          EnumValues: new Map([['FAKTURA', 'Faktura'], ['ERBJUDANDE', 'Erbjudande']]),
          EnumSortValues: new Map([['FAKTURA', 'F'], ['ERBJUDANDE', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAKTURA=Faktura;ERBJUDANDE=Erbjudande"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AVITYP: {
          AttributeName: 'AVITYP',
          DisplayLabel: 'Avityp',
          Hint: 'Utan avi/Utan avi OCR/Plusgiro OCR/Bankgiro/Bankgiro OCR',
          DataType: 'Enum',
          EnumValues: new Map([['UTAN_AVI', 'Utan avi'], ['UTAN_AVI_OCR', 'Utan avi OCR'], ['PLUSGIRO_OCR', 'Plusgiro OCR'], ['BANKGIRO', 'Bankgiro'], ['BANKGIRO_OCR', 'Bankgiro OCR']]),
          EnumSortValues: new Map([['UTAN_AVI', 'N'], ['UTAN_AVI_OCR', 'O'], ['PLUSGIRO_OCR', 'Q'], ['BANKGIRO', 'B'], ['BANKGIRO_OCR', 'C']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="UTAN_AVI=Utan avi;UTAN_AVI_OCR=Utan avi OCR;PLUSGIRO_OCR=Plusgiro OCR;BANKGIRO=Bankgiro;BANKGIRO_OCR=Bankgiro OCR"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        harBilagor: {
          AttributeName: 'harBilagor',
          DisplayLabel: 'Har bilagor',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        Makulerad: {
          AttributeName: 'Makulerad',
          DisplayLabel: 'Makulerad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        EXTERNT_FAKTURANR: {
          AttributeName: 'EXTERNT_FAKTURANR',
          DisplayLabel: 'Externt fakturanr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Agresso',
        },
        EXTERNT_VERNR: {
          AttributeName: 'EXTERNT_VERNR',
          DisplayLabel: 'Externt vernr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Agresso',
        },
        EXTERNT_ORDERNR: {
          AttributeName: 'EXTERNT_ORDERNR',
          DisplayLabel: 'Externt ordernr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Agresso',
        },
        EXTERN_PAMINNELSENIVA: {
          AttributeName: 'EXTERN_PAMINNELSENIVA',
          DisplayLabel: 'Extern påminnelsenivå',
          Hint: 'Första påminnelse skickad/Andra påminnelse skickad/Sänd till inkasso/Efterbevakning hos inkasso/Återkallats från inkasso',
          DataType: 'Enum',
          EnumValues: new Map([['FORSTA_PAMINNELSE_SKICKAD', 'Första påminnelse skickad'], ['ANDRA_PAMINNELSE_SKICKAD', 'Andra påminnelse skickad'], ['SAND_TILL_INKASSO', 'Sänd till inkasso'], ['EFTERBEVAKNING_HOS_INKASSO', 'Efterbevakning hos inkasso'], ['ATERKALLATS_FRAN_INKASSO', 'Återkallats från inkasso']]),
          EnumSortValues: new Map([['FORSTA_PAMINNELSE_SKICKAD', '1'], ['ANDRA_PAMINNELSE_SKICKAD', '2'], ['SAND_TILL_INKASSO', 'I'], ['EFTERBEVAKNING_HOS_INKASSO', '9'], ['ATERKALLATS_FRAN_INKASSO', '8']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FORSTA_PAMINNELSE_SKICKAD=Första påminnelse skickad;ANDRA_PAMINNELSE_SKICKAD=Andra påminnelse skickad;SAND_TILL_INKASSO=Sänd till inkasso;EFTERBEVAKNING_HOS_INKASSO=Efterbevakning hos inkasso;ATERKALLATS_FRAN_INKASSO=Återkallats från inkasso"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Agresso',
        },
        EXTERNT_PAMINNELSEDATUM: {
          AttributeName: 'EXTERNT_PAMINNELSEDATUM',
          DisplayLabel: 'Externt påminnelsedatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Agresso',
        },
        EXTERN_KRAVSTATUS: {
          AttributeName: 'EXTERN_KRAVSTATUS',
          DisplayLabel: 'Extern kravstatus',
          Hint: 'På ett kravförslag/Sänd till inkasso/Betald till bolaget och borttagen hos inkasso/Betald till inkassobolaget/Avslutad, ej indriven/Bokförd som kundförlust/Felaktigt sänd till inkasso',
          DataType: 'Enum',
          EnumValues: new Map([['PA_ETT_KRAVFORSLAG', 'På ett kravförslag'], ['SAND_TILL_INKASSO', 'Sänd till inkasso'], ['BETALD_TILL_BOLAGET_OCH_BORTTAGEN_HOS_INKASSO', 'Betald till bolaget och borttagen hos inkasso'], ['BETALD_TILL_INKASSOBOLAGET', 'Betald till inkassobolaget'], ['AVSLUTAD__EJ_INDRIVEN', 'Avslutad, ej indriven'], ['BOKFORD_SOM_KUNDFORLUST', 'Bokförd som kundförlust'], ['FELAKTIGT_SAND_TILL_INKASSO', 'Felaktigt sänd till inkasso']]),
          EnumSortValues: new Map([['PA_ETT_KRAVFORSLAG', 'R'], ['SAND_TILL_INKASSO', 'C'], ['BETALD_TILL_BOLAGET_OCH_BORTTAGEN_HOS_INKASSO', 'D'], ['BETALD_TILL_INKASSOBOLAGET', 'I'], ['AVSLUTAD__EJ_INDRIVEN', 'T'], ['BOKFORD_SOM_KUNDFORLUST', 'W'], ['FELAKTIGT_SAND_TILL_INKASSO', 'M']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PA_ETT_KRAVFORSLAG=På ett kravförslag;SAND_TILL_INKASSO=Sänd till inkasso;BETALD_TILL_BOLAGET_OCH_BORTTAGEN_HOS_INKASSO=Betald till bolaget och borttagen hos inkasso;BETALD_TILL_INKASSOBOLAGET=Betald till inkassobolaget;AVSLUTAD__EJ_INDRIVEN=Avslutad, ej indriven;BOKFORD_SOM_KUNDFORLUST=Bokförd som kundförlust;FELAKTIGT_SAND_TILL_INKASSO=Felaktigt sänd till inkasso"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Agresso',
        },
        AgressoForfdat: {
          AttributeName: 'AgressoForfdat',
          DisplayLabel: 'Förfallodatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Agresso',
        },
        AgressoFaktdat: {
          AttributeName: 'AgressoFaktdat',
          DisplayLabel: 'Fakturadatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Agresso',
        },
        MakuleradGrav: {
          AttributeName: 'MakuleradGrav',
          DisplayLabel: 'Makulerad från Grav',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifNone',
        },
        StatusBenAgresso: {
          AttributeName: 'StatusBenAgresso',
          DisplayLabel: 'Status elektronisk faktura',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Övrigt',
        },
        FaktnrSomOCR: {
          AttributeName: 'FaktnrSomOCR',
          DisplayLabel: 'Fakturanr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MotkontoKontodel: {
          AttributeName: 'MotkontoKontodel',
          DisplayLabel: 'Anv intern av arkivering för att hämta kundreskontra konto (anv ej för erbjudande)',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SLUTBETALD_AV_TILLGODO: {
          AttributeName: 'SLUTBETALD_AV_TILLGODO',
          DisplayLabel: 'Slutbetald av tillgodohavande',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        CalcDrojsmalsranta: {
          AttributeName: 'CalcDrojsmalsranta',
          DisplayLabel: 'Dröjsmålsränta',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CalcPaminnelseavgift: {
          AttributeName: 'CalcPaminnelseavgift',
          DisplayLabel: 'Påminnelseavgift',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVSER_KGF: {
          AttributeName: 'AVSER_KGF',
          DisplayLabel: 'Avser kgf',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LokaltUtskriven: {
          AttributeName: 'LokaltUtskriven',
          DisplayLabel: 'Faktura, lokalt utskriven',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        SenasteKravnr: {
          AttributeName: 'SenasteKravnr',
          DisplayLabel: 'Senaste kravnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKICKAD_MED_POSTTYP: {
          AttributeName: 'SKICKAD_MED_POSTTYP',
          DisplayLabel: 'Skickad med posttyp',
          Hint: 'A-post/B-post',
          DataType: 'Enum',
          EnumValues: new Map([['A_POST', 'A-post'], ['B_POST', 'B-post']]),
          EnumSortValues: new Map([['A_POST', 'A'], ['B_POST', 'B']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="A_POST=A-post;B_POST=B-post"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SenasteKravnrInklInkasso: {
          AttributeName: 'SenasteKravnrInklInkasso',
          DisplayLabel: 'Senaste kravnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEVAKNING_KVITTERAD: {
          AttributeName: 'BEVAKNING_KVITTERAD',
          DisplayLabel: 'Kvitterad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bevakning och kvittering',
        },
        BEVAKNING_KVITTERAD_DATUM: {
          AttributeName: 'BEVAKNING_KVITTERAD_DATUM',
          DisplayLabel: 'Kvitterad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Bevakning och kvittering',
        },
        BEVAKNING_KVITTERAD_SIGN: {
          AttributeName: 'BEVAKNING_KVITTERAD_SIGN',
          DisplayLabel: 'Kvitterad signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Bevakning och kvittering',
        },
        OrderBevakad: {
          AttributeName: 'OrderBevakad',
          DisplayLabel: 'Bevakad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Bevakning och kvittering',
        },
        SkickasVia: {
          AttributeName: 'SkickasVia',
          DisplayLabel: 'Skickas via',
          Hint: 'KOB/Svenska kyrkans fakturaväxel/Agresso/Digital brevlåda (Kivra)/Eniac xml/E-post/Dynamics',
          DataType: 'Enum',
          EnumValues: new Map([['KOB', 'KOB'], ['SVENSKA_KYRKANS_FAKTURAVAXEL', 'Svenska kyrkans fakturaväxel'], ['AGRESSO', 'Agresso'], ['DIGITAL_BREVLADA__KIVRA_', 'Digital brevlåda (Kivra)'], ['ENIAC_XML', 'Eniac xml'], ['E_POST', 'E-post'], ['DYNAMICS', 'Dynamics']]),
          EnumSortValues: new Map([['KOB', 'O'], ['SVENSKA_KYRKANS_FAKTURAVAXEL', 'F'], ['AGRESSO', 'A'], ['DIGITAL_BREVLADA__KIVRA_', 'K'], ['ENIAC_XML', 'X'], ['E_POST', 'E'], ['DYNAMICS', 'D']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KOB=KOB;SVENSKA_KYRKANS_FAKTURAVAXEL=Svenska kyrkans fakturaväxel;AGRESSO=Agresso;DIGITAL_BREVLADA__KIVRA_=Digital brevlåda (Kivra);ENIAC_XML=Eniac xml;E_POST=E-post;DYNAMICS=Dynamics"',
          InterfaceType: 'ifChecklist',
        },
        DISTRIBUTIONSSATT_KIVRA: {
          AttributeName: 'DISTRIBUTIONSSATT_KIVRA',
          DisplayLabel: 'Distributionssätt, Kivra',
          Hint: 'Brev/Faktura',
          DataType: 'Enum',
          EnumValues: new Map([['BREV', 'Brev'], ['FAKTURA', 'Faktura']]),
          EnumSortValues: new Map([['BREV', 'B'], ['FAKTURA', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BREV=Brev;FAKTURA=Faktura"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FaktInsBelopp: {
          AttributeName: 'FaktInsBelopp',
          DisplayLabel: 'Fakturerat avtalsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Avtal',
        },
        FaktInsInsatt: {
          AttributeName: 'FaktInsInsatt',
          DisplayLabel: 'Insatt avtalsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Avtal',
        },
        FaktInsSaldo: {
          AttributeName: 'FaktInsSaldo',
          DisplayLabel: 'Saldo fakturerat avtalsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Avtal',
        },
        SenHandelsedatum: {
          AttributeName: 'SenHandelsedatum',
          DisplayLabel: 'Senaste händelsedatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        FaktInsKredRenFaktura: {
          AttributeName: 'FaktInsKredRenFaktura',
          DisplayLabel: 'Krediterat avtalsbelopp, enkel faktura',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNone',
          AttributeGroup: 'Avtal',
        },
        FaktInsKredBlandadFaktura: {
          AttributeName: 'FaktInsKredBlandadFaktura',
          DisplayLabel: 'Krediterat avtalsbelopp, blandad faktura',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNone',
          AttributeGroup: 'Avtal',
        },
        FaktInsKred: {
          AttributeName: 'FaktInsKred',
          DisplayLabel: 'Krediterat avtalsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Avtal',
        },
        FaktInsInsattKred: {
          AttributeName: 'FaktInsInsattKred',
          DisplayLabel: 'Insatt-/krediterat avtalsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Avtal',
        },
        EPOST_MOTTAGARADRESS: {
          AttributeName: 'EPOST_MOTTAGARADRESS',
          DisplayLabel: 'Epost, mottagaradress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FAKTURERA_DODSBO: {
          AttributeName: 'FAKTURERA_DODSBO',
          DisplayLabel: 'Fakturera dödsbo',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          DefaultCondOperator: T.contains,
        },
        OMSTYRD_PGA_FAKTADRESS: {
          AttributeName: 'OMSTYRD_PGA_FAKTADRESS',
          DisplayLabel: 'Omstyrd pga faktureringsadress',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        Kund: {
          AssociationName: 'Kund',
          DisplayLabel: 'Kund',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['KUND_NOCOMBINE', 'True'], ['NOT_ATAGANDE', 'True']]),
        },
        Faktureringsgrupp: {
          AssociationName: 'Faktureringsgrupp',
          DisplayLabel: 'Faktureringsgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'BokfgruppFakt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Fakturaregistrering: {
          AssociationName: 'Fakturaregistrering',
          DisplayLabel: 'Fakturaregistrering',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKFakturahandelse',
          AssociatedComponentName: 'BokfHandelse',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Ordern: {
          AssociationName: 'Ordern',
          DisplayLabel: 'Order',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OFOrder',
          AssociatedComponentName: 'Order',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Betalare: {
          AssociationName: 'Betalare',
          DisplayLabel: 'Betalare',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['KUND_NOCOMBINE', 'True'], ['NOT_ATAGANDE', 'True']]),
        },
        Land: {
          AssociationName: 'Land',
          DisplayLabel: 'Kundens land',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSLand',
          AssociatedComponentName: 'Land',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Levland: {
          AssociationName: 'Levland',
          DisplayLabel: 'Leveransland',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSLand',
          AssociatedComponentName: 'Land',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bestallare: {
          AssociationName: 'Bestallare',
          DisplayLabel: 'Beställare',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: true,
          ValidInComps: ['DebetFaktura'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['KUND_NOCOMBINE', 'True'], ['NOT_ATAGANDE', 'True']]),
        },
        Betalningsvillkor: {
          AssociationName: 'Betalningsvillkor',
          DisplayLabel: 'Betalningsvillkor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSBetalningsvillkor',
          AssociatedComponentName: 'Betalningsvillkor',
          JoinAssociation: true,
          ValidInComps: ['DebetFaktura'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FaktureringsLand: {
          AssociationName: 'FaktureringsLand',
          DisplayLabel: 'Faktureringsland',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSLand',
          AssociatedComponentName: 'Land',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bunt: {
          AssociationName: 'Bunt',
          DisplayLabel: 'Bunt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKundfakturabunt',
          AssociatedComponentName: 'Kundfakturabunt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRFakturaBild',
          AssociatedComponentName: 'FakturaBild',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        Fakturarader: {
          AssociationName: 'Fakturarader',
          DisplayLabel: 'Fakturarader',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRFakturarad',
          AssociatedComponentName: 'Fakturarad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturahandelser: {
          AssociationName: 'Fakturahandelser',
          DisplayLabel: 'Fakturahändelser',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKFakturahandelse',
          AssociatedComponentName: 'Fakturahandelse',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Betalningar: {
          AssociationName: 'Betalningar',
          DisplayLabel: 'Betalningsplan',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRFakturabetalning',
          AssociatedComponentName: 'FakturaBetalning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    KRInbetalningsvag: {
      CollectionName: 'KRInbetalningsvag',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Inbetalningsvag',
        Abstract: false,
        SOLabel: 'Inbetalningsväg',
        SOGLabel: 'Inbetalningsvägs',
        SBLabel: 'Inbetalningsvägen',
        SBGLabel: 'Inbetalningsvägens',
        POLabel: 'Inbetalningsvägar',
        POGLabel: 'Inbetalningsvägars',
        PBLabel: 'Inbetalningsvägarna',
        PBGLabel: 'Inbetalningsvägarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Inbetalningsvägens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Inbetalningsvägens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Inbetalningsvägens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Inbetalningsvägens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'Id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Filtyp',
          Hint: 'Bankgiro Inbetalningar/Plusgiro Total-IN/ISO20022',
          DataType: 'Enum',
          EnumValues: new Map([['BANKGIRO_INBETALNINGAR', 'Bankgiro Inbetalningar'], ['PLUSGIRO_TOTAL_IN', 'Plusgiro Total-IN'], ['ISO20022', 'ISO20022']]),
          EnumSortValues: new Map([['BANKGIRO_INBETALNINGAR', 'B'], ['PLUSGIRO_TOTAL_IN', 'P'], ['ISO20022', 'I']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BANKGIRO_INBETALNINGAR=Bankgiro Inbetalningar;PLUSGIRO_TOTAL_IN=Plusgiro Total-IN;ISO20022=ISO20022"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        KATALOG: {
          AttributeName: 'KATALOG',
          DisplayLabel: 'Katalog',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BOKF_GRUPP_ID: {
          AttributeName: 'BOKF_GRUPP_ID',
          DisplayLabel: 'Bokföringsgrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REF_SOKNING: {
          AttributeName: 'REF_SOKNING',
          DisplayLabel: 'Referenssökning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'Id-kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        KalkKatalog: {
          AttributeName: 'KalkKatalog',
          DisplayLabel: 'Katalog',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        LAS_IN_ALLT: {
          AttributeName: 'LAS_IN_ALLT',
          DisplayLabel: 'Läs in allt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        bokforingsgrupp: {
          AssociationName: 'bokforingsgrupp',
          DisplayLabel: 'Bokföringsgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'Grupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    KRBetfilInfo: {
      CollectionName: 'KRBetfilInfo',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BetfilInfo',
        Abstract: false,
        SOLabel: 'Informationspost',
        SOGLabel: 'Informationsposts',
        SBLabel: 'Informationsposten',
        SBGLabel: 'Informationspostens',
        POLabel: 'Informationsposter',
        POGLabel: 'Informationsposters',
        PBLabel: 'Informationsposterna',
        PBGLabel: 'Informationsposternas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Informationspostens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Informationspostens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Informationspostens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BGI_TRANSKOD: {
          AttributeName: 'BGI_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BGI_INFOTEXT: {
          AttributeName: 'BGI_INFOTEXT',
          DisplayLabel: 'Informationstext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.contains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TI_POSTTYP: {
          AttributeName: 'TI_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TI_MEDDELANDE1: {
          AttributeName: 'TI_MEDDELANDE1',
          DisplayLabel: 'Meddelande 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        TI_MEDDELANDE2: {
          AttributeName: 'TI_MEDDELANDE2',
          DisplayLabel: 'Meddelande 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        Text: {
          AttributeName: 'Text',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Avsnitt: {
          AssociationName: 'Avsnitt',
          DisplayLabel: 'Avsnitt',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRBetfilAvsnitt',
          AssociatedComponentName: 'BetfilAvsnitt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    KRKravOmgang: {
      CollectionName: 'KRKravOmgang',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['GroupAssociation', 'Faktureringsgrupp']]),
      RootType: {
        TypeValue: 'Kravomgang',
        Abstract: false,
        SOLabel: 'Kravomgång',
        SOGLabel: 'Kravomgång',
        SBLabel: 'Kravomgången',
        SBGLabel: 'Kravomgången',
        POLabel: 'Kravomgångar',
        POGLabel: 'Kravomgångar',
        PBLabel: 'Kravomgångarna',
        PBGLabel: 'Kravomgångarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kravomgången primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kravomgången versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kravomgången id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kravomgången fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_GRUPP_ID: {
          AttributeName: 'BOKF_GRUPP_ID',
          DisplayLabel: 'Bokföringsgrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KRAVOMGANG_NR: {
          AttributeName: 'KRAVOMGANG_NR',
          DisplayLabel: 'Kravomgångsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TID: {
          AttributeName: 'TID',
          DisplayLabel: 'Tid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SIGNATUR: {
          AttributeName: 'SIGNATUR',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        AntalKrav: {
          AttributeName: 'AntalKrav',
          DisplayLabel: 'Antal krav',
          Hint: 'Antal krav på denna kravomgång',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Faktureringsgrupp: {
          AssociationName: 'Faktureringsgrupp',
          DisplayLabel: 'Faktureringsgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'BokfgruppFakt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Kravhandelse: {
          AssociationName: 'Kravhandelse',
          DisplayLabel: 'Kravhändelse',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKFakturahandelse',
          AssociatedComponentName: 'Krav',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    KRKund: {
      CollectionName: 'KRKund',
      UDAEnabled: true,
      UDNEnabled: true,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '6006'], ['AllowSelection', '15006']]),
      RootType: {
        TypeValue: 'Kund',
        Abstract: true,
        SOLabel: 'Kund',
        SOGLabel: 'Kunds',
        SBLabel: 'Kunden',
        SBGLabel: 'Kundens',
        POLabel: 'Kunder',
        POGLabel: 'Kunders',
        PBLabel: 'Kunderna',
        PBGLabel: 'Kundernas',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'FakturaKund',
            Abstract: false,
            SOLabel: 'Fakturakund',
            SOGLabel: 'Fakturakund',
            SBLabel: 'Fakturakunden',
            SBGLabel: 'Fakturakunden',
            POLabel: 'Fakturakunder',
            POGLabel: 'Fakturakunder',
            PBLabel: 'Fakturakunderna',
            PBGLabel: 'Fakturakunderna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'Avtal',
            Abstract: true,
            SOLabel: 'Avtal',
            SOGLabel: 'Avtal',
            SBLabel: 'Avtal',
            SBGLabel: 'Avtal',
            POLabel: 'Avtal',
            POGLabel: 'Avtal',
            PBLabel: 'Avtal',
            PBGLabel: 'Avtal',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'KontoKund',
                Abstract: false,
                SOLabel: 'Avräkningsavtal',
                SOGLabel: 'Avräkningsavtal',
                SBLabel: 'Avräkningsavtalet',
                SBGLabel: 'Avräkningsavtalet',
                POLabel: 'Avräkningsavtal',
                POGLabel: 'Avräkningsavtal',
                PBLabel: 'Avräkningsavtalen',
                PBGLabel: 'Avräkningsavtalen',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'AvtalKund',
                Abstract: false,
                SOLabel: 'Fasttidsavtal',
                SOGLabel: 'Fasttidsavtal',
                SBLabel: 'Fasttidsavtalet',
                SBGLabel: 'Fasttidsavtalet',
                POLabel: 'Fasttidsavtal',
                POGLabel: 'Fasttidsavtal',
                PBLabel: 'Fasttidsavtalen',
                PBGLabel: 'Fasttidsavtalen',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kundens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kundens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Kundtyp',
          DataType: 'Enum',
          EnumValues: new Map([['FAKTURAKUND', 'Fakturakund'], ['KONTOKUND', 'Avräkningsavtal'], ['AVTALKUND', 'Fasttidsavtal']]),
          EnumSortValues: new Map([['FAKTURAKUND', 'F'], ['KONTOKUND', 'K'], ['AVTALKUND', 'A']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAKTURAKUND=Fakturakund;KONTOKUND=Avräkningsavtal;AVTALKUND=Fasttidsavtal"',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kundens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kundens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KUNDNR_KONTONR: {
          AttributeName: 'KUNDNR_KONTONR',
          DisplayLabel: 'Kundnr/Avtalsnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        MALLKUND: {
          AttributeName: 'MALLKUND',
          DisplayLabel: 'Mallkund (J/N)',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        KUNDKATEGORI_ID: {
          AttributeName: 'KUNDKATEGORI_ID',
          DisplayLabel: 'Kundkategori',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OP_ID: {
          AttributeName: 'OP_ID',
          DisplayLabel: 'Organisation / Person',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOMS: {
          AttributeName: 'MOMS',
          DisplayLabel: 'Moms',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        REGDATUM: {
          AttributeName: 'REGDATUM',
          DisplayLabel: 'Registreringsdatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Övrigt',
        },
        VALUTA_ID: {
          AttributeName: 'VALUTA_ID',
          DisplayLabel: 'Valuta',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PRISLISTA_ID: {
          AttributeName: 'PRISLISTA_ID',
          DisplayLabel: 'Prislista',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KUNDRABATT: {
          AttributeName: 'KUNDRABATT',
          DisplayLabel: 'Rabatt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          FormatterValidateParams: 'MinValue="0";MaxValue="100"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.greater,
          AttributeGroup: 'Övrigt',
        },
        LEVERANSVILLKOR_ID: {
          AttributeName: 'LEVERANSVILLKOR_ID',
          DisplayLabel: 'Leveransvillkor',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SPARRDATUM: {
          AttributeName: 'SPARRDATUM',
          DisplayLabel: 'Spärrdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Övrigt',
        },
        AVSLUTDATUM: {
          AttributeName: 'AVSLUTDATUM',
          DisplayLabel: 'Avslutad datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        SPRAK_ID: {
          AttributeName: 'SPRAK_ID',
          DisplayLabel: 'Språk',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTURERINGSAVGIFT: {
          AttributeName: 'FAKTURERINGSAVGIFT',
          DisplayLabel: 'Administrationsavgift',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        SAMFAKTURERAS: {
          AttributeName: 'SAMFAKTURERAS',
          DisplayLabel: 'Samfaktureras',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Fakturakund',
        },
        BETALNINGSVILLKOR_ID: {
          AttributeName: 'BETALNINGSVILLKOR_ID',
          DisplayLabel: 'Betalningsvillkor',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KREDITGRANS: {
          AttributeName: 'KREDITGRANS',
          DisplayLabel: 'Kreditgräns',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          FormatterValidateParams: 'MinValue="0"',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        DROJSMALSRANTEFAKT: {
          AttributeName: 'DROJSMALSRANTEFAKT',
          DisplayLabel: 'Dröjsmålsränta (J/N)',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        REFERENS: {
          AttributeName: 'REFERENS',
          DisplayLabel: 'Referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Övrigt',
        },
        BETALARE_ID: {
          AttributeName: 'BETALARE_ID',
          DisplayLabel: 'Betalare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LEVERANTORSNUMMER: {
          AttributeName: 'LEVERANTORSNUMMER',
          DisplayLabel: 'Leverantörsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Övrigt',
        },
        RANTEFAKTURERAS: {
          AttributeName: 'RANTEFAKTURERAS',
          DisplayLabel: 'Skuldränta',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Avräkningsavtal',
        },
        RANTEBERAKNAS: {
          AttributeName: 'RANTEBERAKNAS',
          DisplayLabel: 'Tillgodoränta',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Avräkningsavtal',
        },
        UPPLAGGNINGS_DATUM: {
          AttributeName: 'UPPLAGGNINGS_DATUM',
          DisplayLabel: 'Uppläggningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Övrigt',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Borttagen',
        },
        AUTOGIRO_VAG: {
          AttributeName: 'AUTOGIRO_VAG',
          DisplayLabel: 'Autogiro, skickas till',
          Hint: 'Bankgirot/PlusGirot',
          DataType: 'Enum',
          EnumValues: new Map([['BANKGIROT', 'Bankgirot'], ['PLUSGIROT', 'PlusGirot']]),
          EnumSortValues: new Map([['BANKGIROT', 'B'], ['PLUSGIROT', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BANKGIROT=Bankgirot;PLUSGIROT=PlusGirot"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_STATUS: {
          AttributeName: 'AUTOGIRO_STATUS',
          DisplayLabel: 'Autogiro, status',
          Hint: 'Autogiro används ej/Autogiro används/Makulering av medgivande registrerat/Nytt medgivande registrerat/Byte av kontonr registrerat',
          DataType: 'Enum',
          EnumValues: new Map([['AUTOGIRO_ANVANDS_EJ', 'Autogiro används ej'], ['AUTOGIRO_ANVANDS', 'Autogiro används'], ['MAKULERING_AV_MEDGIVANDE_REGISTRERAT', 'Makulering av medgivande registrerat'], ['NYTT_MEDGIVANDE_REGISTRERAT', 'Nytt medgivande registrerat'], ['BYTE_AV_KONTONR_REGISTRERAT', 'Byte av kontonr registrerat']]),
          EnumSortValues: new Map([['AUTOGIRO_ANVANDS_EJ', 'E'], ['AUTOGIRO_ANVANDS', 'A'], ['MAKULERING_AV_MEDGIVANDE_REGISTRERAT', 'M'], ['NYTT_MEDGIVANDE_REGISTRERAT', 'N'], ['BYTE_AV_KONTONR_REGISTRERAT', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="AUTOGIRO_ANVANDS_EJ=Autogiro används ej;AUTOGIRO_ANVANDS=Autogiro används;MAKULERING_AV_MEDGIVANDE_REGISTRERAT=Makulering av medgivande registrerat;NYTT_MEDGIVANDE_REGISTRERAT=Nytt medgivande registrerat;BYTE_AV_KONTONR_REGISTRERAT=Byte av kontonr registrerat"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_FROM_DATUM: {
          AttributeName: 'AUTOGIRO_FROM_DATUM',
          DisplayLabel: 'Autogiro fr o m',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxRecommendedDate="+12m";MinRecommendedDate="-12m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_CLEARINGNR: {
          AttributeName: 'AUTOGIRO_CLEARINGNR',
          DisplayLabel: 'Autogiro, clearingnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_KONTONR: {
          AttributeName: 'AUTOGIRO_KONTONR',
          DisplayLabel: 'Autogiro, kontonr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 15,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_MAXBELOPP: {
          AttributeName: 'AUTOGIRO_MAXBELOPP',
          DisplayLabel: 'Autogiro, maxbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          AttributeGroup: 'Autogiro',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        AUTOGIRO_ID: {
          AttributeName: 'AUTOGIRO_ID',
          DisplayLabel: 'Autogiromall',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_ANTAL_DELBET: {
          AttributeName: 'AUTOGIRO_ANTAL_DELBET',
          DisplayLabel: 'Autogiro, antal delbetalningar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MaxValue="20"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_PERIODICITET: {
          AttributeName: 'AUTOGIRO_PERIODICITET',
          DisplayLabel: 'Autogiro, periodicitet',
          Hint: 'Varje månad/Varannan månad/Var tredje månad/Var fjärde månad/Var sjätte månad/Varje år',
          DataType: 'Enum',
          EnumValues: new Map([['VARJE_MANAD', 'Varje månad'], ['VARANNAN_MANAD', 'Varannan månad'], ['VAR_TREDJE_MANAD', 'Var tredje månad'], ['VAR_FJARDE_MANAD', 'Var fjärde månad'], ['VAR_SJATTE_MANAD', 'Var sjätte månad'], ['VARJE_AR', 'Varje år']]),
          EnumSortValues: new Map([['VARJE_MANAD', '1'], ['VARANNAN_MANAD', '2'], ['VAR_TREDJE_MANAD', '3'], ['VAR_FJARDE_MANAD', '4'], ['VAR_SJATTE_MANAD', '6'], ['VARJE_AR', '12']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="VARJE_MANAD=Varje månad;VARANNAN_MANAD=Varannan månad;VAR_TREDJE_MANAD=Var tredje månad;VAR_FJARDE_MANAD=Var fjärde månad;VAR_SJATTE_MANAD=Var sjätte månad;VARJE_AR=Varje år"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_BETALNINGSDAG: {
          AttributeName: 'AUTOGIRO_BETALNINGSDAG',
          DisplayLabel: 'Autogiro, betalningsdag',
          Hint: 'Sista bankdag/1/2/3/4/5/6/7/8/9/10/11/12/13/14/15/16/17/18/19/20/21/22/23/24/25/26/27/28/29/30/31',
          DataType: 'Enum',
          EnumValues: new Map([['ASISTA_BANKDAG', 'Sista bankdag'], ['A1', '1'], ['A2', '2'], ['A3', '3'], ['A4', '4'], ['A5', '5'], ['A6', '6'], ['A7', '7'], ['A8', '8'], ['A9', '9'], ['A10', '10'], ['A11', '11'], ['A12', '12'], ['A13', '13'], ['A14', '14'], ['A15', '15'], ['A16', '16'], ['A17', '17'], ['A18', '18'], ['A19', '19'], ['A20', '20'], ['A21', '21'], ['A22', '22'], ['A23', '23'], ['A24', '24'], ['A25', '25'], ['A26', '26'], ['A27', '27'], ['A28', '28'], ['A29', '29'], ['A30', '30'], ['A31', '31']]),
          EnumSortValues: new Map([['ASISTA_BANKDAG', '0'], ['A1', '1'], ['A2', '2'], ['A3', '3'], ['A4', '4'], ['A5', '5'], ['A6', '6'], ['A7', '7'], ['A8', '8'], ['A9', '9'], ['A10', '10'], ['A11', '11'], ['A12', '12'], ['A13', '13'], ['A14', '14'], ['A15', '15'], ['A16', '16'], ['A17', '17'], ['A18', '18'], ['A19', '19'], ['A20', '20'], ['A21', '21'], ['A22', '22'], ['A23', '23'], ['A24', '24'], ['A25', '25'], ['A26', '26'], ['A27', '27'], ['A28', '28'], ['A29', '29'], ['A30', '30'], ['A31', '31']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ASISTA_BANKDAG=Sista bankdag;A1=1;A2=2;A3=3;A4=4;A5=5;A6=6;A7=7;A8=8;A9=9;A10=10;A11=11;A12=12;A13=13;A14=14;A15=15;A16=16;A17=17;A18=18;A19=19;A20=20;A21=21;A22=22;A23=23;A24=24;A25=25;A26=26;A27=27;A28=28;A29=29;A30=30;A31=31"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_SLUTBETALAS: {
          AttributeName: 'AUTOGIRO_SLUTBETALAS',
          DisplayLabel: 'Autogiro, slutbetald innev. år',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          AttributeGroup: 'Autogiro',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
          Required: true,
        },
        AUTOGIRO_FOREG_CLEARINGNR: {
          AttributeName: 'AUTOGIRO_FOREG_CLEARINGNR',
          DisplayLabel: 'Autogiro, föreg clearingnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_FOREG_KONTONR: {
          AttributeName: 'AUTOGIRO_FOREG_KONTONR',
          DisplayLabel: 'Autogiro, föreg kontonr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_BETMANAD_1: {
          AttributeName: 'AUTOGIRO_BETMANAD_1',
          DisplayLabel: 'Autogiro, dragning januari',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_BETMANAD_2: {
          AttributeName: 'AUTOGIRO_BETMANAD_2',
          DisplayLabel: 'Autogiro, dragning februari',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_BETMANAD_3: {
          AttributeName: 'AUTOGIRO_BETMANAD_3',
          DisplayLabel: 'Autogiro, dragning mars',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_BETMANAD_4: {
          AttributeName: 'AUTOGIRO_BETMANAD_4',
          DisplayLabel: 'Autogiro, dragning april',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_BETMANAD_5: {
          AttributeName: 'AUTOGIRO_BETMANAD_5',
          DisplayLabel: 'Autogiro, dragning maj',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_BETMANAD_6: {
          AttributeName: 'AUTOGIRO_BETMANAD_6',
          DisplayLabel: 'Autogiro, dragning juni',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_BETMANAD_7: {
          AttributeName: 'AUTOGIRO_BETMANAD_7',
          DisplayLabel: 'Autogiro, dragning juli',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_BETMANAD_8: {
          AttributeName: 'AUTOGIRO_BETMANAD_8',
          DisplayLabel: 'Autogiro, dragning augusti',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_BETMANAD_12: {
          AttributeName: 'AUTOGIRO_BETMANAD_12',
          DisplayLabel: 'Autogiro, dragning december',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_BETMANAD_9: {
          AttributeName: 'AUTOGIRO_BETMANAD_9',
          DisplayLabel: 'Autogiro, dragning september',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_BETMANAD_11: {
          AttributeName: 'AUTOGIRO_BETMANAD_11',
          DisplayLabel: 'Autogiro, dragning november',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_BETALARNR: {
          AttributeName: 'AUTOGIRO_BETALARNR',
          DisplayLabel: 'Autogiro, betalarnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
          AttributeGroup: 'Autogiro',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        AUTOGIRO_FOREG_BETALARNR: {
          AttributeName: 'AUTOGIRO_FOREG_BETALARNR',
          DisplayLabel: 'Autogiro, föreg betalarnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Autogiro',
        },
        AUTOGIRO_BETMANAD_10: {
          AttributeName: 'AUTOGIRO_BETMANAD_10',
          DisplayLabel: 'Autogiro, dragning oktober',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Autogiro',
        },
        Kundtyp: {
          AttributeName: 'Kundtyp',
          DisplayLabel: 'Typ av kund',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Namn: {
          AttributeName: 'Namn',
          DisplayLabel: 'Namn (efternamn, förnamn)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        NamnFE: {
          AttributeName: 'NamnFE',
          DisplayLabel: 'Namn (förnamn efternamn)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        NamnME: {
          AttributeName: 'NamnME',
          DisplayLabel: 'Namn (mellannamn efternamn)',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Fornamn: {
          AttributeName: 'Fornamn',
          DisplayLabel: 'Förnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NamnAdress: {
          AttributeName: 'NamnAdress',
          DisplayLabel: 'Namn och adress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AdressRad: {
          AttributeName: 'AdressRad',
          DisplayLabel: 'Adress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KompaktAdress: {
          AttributeName: 'KompaktAdress',
          DisplayLabel: 'KompaktAdress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        co: {
          AttributeName: 'co',
          DisplayLabel: 'CO',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Gatuadress: {
          AttributeName: 'Gatuadress',
          DisplayLabel: 'Gatuadress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        PostNr: {
          AttributeName: 'PostNr',
          DisplayLabel: 'Postnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Ort: {
          AttributeName: 'Ort',
          DisplayLabel: 'Ort',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Telefon: {
          AttributeName: 'Telefon',
          DisplayLabel: 'Telefon',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Telefon2: {
          AttributeName: 'Telefon2',
          DisplayLabel: 'Telefon2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        TelefonArb: {
          AttributeName: 'TelefonArb',
          DisplayLabel: 'Telefon arbete',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Mobiltelefon: {
          AttributeName: 'Mobiltelefon',
          DisplayLabel: 'Mobiltelefon',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SMTP: {
          AttributeName: 'SMTP',
          DisplayLabel: 'E-post',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Fax: {
          AttributeName: 'Fax',
          DisplayLabel: 'Fax',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kundkategoriben: {
          AttributeName: 'Kundkategoriben',
          DisplayLabel: 'Kundkategori benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundkategoriKod: {
          AttributeName: 'KundkategoriKod',
          DisplayLabel: 'Kundkategorins kod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundkategoriKodBen: {
          AttributeName: 'KundkategoriKodBen',
          DisplayLabel: 'Kundkategori',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Sorteringsnamn: {
          AttributeName: 'Sorteringsnamn',
          DisplayLabel: 'Sorteringsnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SaldoAktuellt: {
          AttributeName: 'SaldoAktuellt',
          DisplayLabel: 'Aktuellt saldo',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        KontosaldoIngaende: {
          AttributeName: 'KontosaldoIngaende',
          DisplayLabel: 'Ingående saldo för kontot',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeParams: {'iks_datum': {type: 'Date', defaultValue: ''}},
        },
        KontosaldoUtgaende: {
          AttributeName: 'KontosaldoUtgaende',
          DisplayLabel: 'Utgående saldo för kontot',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeParams: {'uks_datum': {type: 'Date', defaultValue: ''}},
        },
        KontosaldoAktuellt: {
          AttributeName: 'KontosaldoAktuellt',
          DisplayLabel: 'Kontosaldo',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Avtal',
        },
        ReskontraSaldoAktInt: {
          AttributeName: 'ReskontraSaldoAktInt',
          DisplayLabel: 'Reskontrasaldo (internt)',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'inkl_erbjudande': {type: 'String', defaultValue: ''}},
        },
        ReskontraSaldoAkt_Erb: {
          AttributeName: 'ReskontraSaldoAkt_Erb',
          DisplayLabel: 'Reskontrasaldo (inkl erbjudande)',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ReskontraSaldoAktuellt: {
          AttributeName: 'ReskontraSaldoAktuellt',
          DisplayLabel: 'Reskontrasaldo',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Leveransvillkor: {
          AttributeName: 'Leveransvillkor',
          DisplayLabel: 'Leveransvillkor',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Betalningstid: {
          AttributeName: 'Betalningstid',
          DisplayLabel: 'Genomsnittlig betalningstid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Övrigt',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KontoAntalAktuellt: {
          AttributeName: 'KontoAntalAktuellt',
          DisplayLabel: 'Antal insättningar/uttag',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Internal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Övrigt',
        },
        Antalfakturor: {
          AttributeName: 'Antalfakturor',
          DisplayLabel: 'Antal fakturor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Internal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
          AttributeGroup: 'Övrigt',
        },
        TillgodoPerdatum: {
          AttributeName: 'TillgodoPerdatum',
          DisplayLabel: 'Tillgodo per datum',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'tpd_datum': {type: 'Date', defaultValue: ''}},
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        TillgodoPerDatum2: {
          AttributeName: 'TillgodoPerDatum2',
          DisplayLabel: 'TillgodoPerDatum2',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'tpd_datum2': {type: 'Date', defaultValue: ''}},
        },
        SaldoEfterDatum: {
          AttributeName: 'SaldoEfterDatum',
          DisplayLabel: 'SaldoEfterDatum',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'reskontra_konto': {type: 'String', defaultValue: ''}, 'sed_datum': {type: 'Date', defaultValue: ''}, 'saldo_fakturor': {type: 'String', defaultValue: ''}, 'saldo_erbjudande': {type: 'String', defaultValue: ''}},
        },
        SaldoEfterDatum2: {
          AttributeName: 'SaldoEfterDatum2',
          DisplayLabel: 'SaldoEfterDatum2',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'reskontra_konto_2': {type: 'String', defaultValue: ''}, 'sed_datum': {type: 'Date', defaultValue: ''}, 'saldo_fakturor': {type: 'String', defaultValue: ''}, 'saldo_erbjudande': {type: 'String', defaultValue: ''}},
        },
        SaldoPerDatum: {
          AttributeName: 'SaldoPerDatum',
          DisplayLabel: 'SaldoPerDatum',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'reskontra_konto': {type: 'String', defaultValue: ''}, 'spd_datum': {type: 'Date', defaultValue: ''}, 'saldo_fakturor': {type: 'String', defaultValue: ''}, 'saldo_erbjudande': {type: 'String', defaultValue: ''}},
        },
        SaldoPerDatum2: {
          AttributeName: 'SaldoPerDatum2',
          DisplayLabel: 'SaldoPerDatum2',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'reskontra_konto_2': {type: 'String', defaultValue: ''}, 'spd_datum': {type: 'Date', defaultValue: ''}, 'saldo_fakturor': {type: 'String', defaultValue: ''}, 'saldo_erbjudande': {type: 'String', defaultValue: ''}},
        },
        FakturorPerTid: {
          AttributeName: 'FakturorPerTid',
          DisplayLabel: 'FakturorPerTid',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'fpt_frandatum': {type: 'Date', defaultValue: ''}, 'fpt_tilldatum': {type: 'Date', defaultValue: ''}, 'saldo_fakturor': {type: 'String', defaultValue: ''}, 'saldo_erbjudande': {type: 'String', defaultValue: ''}},
        },
        BetalningarPerTid: {
          AttributeName: 'BetalningarPerTid',
          DisplayLabel: 'BetalningarPerTid',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'bpt_frandatum': {type: 'Date', defaultValue: ''}, 'bpt_tilldatum': {type: 'Date', defaultValue: ''}, 'saldo_fakturor': {type: 'String', defaultValue: ''}, 'saldo_erbjudande': {type: 'String', defaultValue: ''}},
        },
        KontoUttagPerTid: {
          AttributeName: 'KontoUttagPerTid',
          DisplayLabel: 'KontoUttagPerTid',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'kupt_frandatum': {type: 'Date', defaultValue: ''}, 'kupt_tilldatum': {type: 'Date', defaultValue: ''}, 'saldo_fakturor': {type: 'String', defaultValue: ''}, 'saldo_erbjudande': {type: 'String', defaultValue: ''}},
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KontoInsattningPerTid: {
          AttributeName: 'KontoInsattningPerTid',
          DisplayLabel: 'KontoInsattningPerTid',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'kipt_frandatum': {type: 'Date', defaultValue: ''}, 'kipt_tilldatum': {type: 'Date', defaultValue: ''}, 'saldo_fakturor': {type: 'String', defaultValue: ''}, 'saldo_erbjudande': {type: 'String', defaultValue: ''}},
        },
        UpprakningPerTid: {
          AttributeName: 'UpprakningPerTid',
          DisplayLabel: 'UpprakningPerTid',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'uppr_pt_frandatum': {type: 'Date', defaultValue: ''}, 'uppr_pt_tilldatum': {type: 'Date', defaultValue: ''}},
        },
        KundkatBorttagen: {
          AttributeName: 'KundkatBorttagen',
          DisplayLabel: 'KundkatBorttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Optyp: {
          AttributeName: 'Optyp',
          DisplayLabel: 'Optyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OPTypNamn: {
          AttributeName: 'OPTypNamn',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OPLBorttagen: {
          AttributeName: 'OPLBorttagen',
          DisplayLabel: 'OPLBorttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OPOrgNrPersNr: {
          AttributeName: 'OPOrgNrPersNr',
          DisplayLabel: 'Org.nr/Pers.nr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatOrgNrPersNr',
        },
        OPLokalAdr: {
          AttributeName: 'OPLokalAdr',
          DisplayLabel: 'Lokal adress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
          AttributeGroup: 'Övrigt',
        },
        OPSamfallighetsID: {
          AttributeName: 'OPSamfallighetsID',
          DisplayLabel: 'OPSamfallighetsID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DebsattKod: {
          AttributeName: 'DebsattKod',
          DisplayLabel: 'Debiteringssätt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Debsatt: {
          AttributeName: 'Debsatt',
          DisplayLabel: 'Debiteringssätt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Debsatt2: {
          AttributeName: 'Debsatt2',
          DisplayLabel: 'Debiteringssätt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundDebsatt: {
          AttributeName: 'KundDebsatt',
          DisplayLabel: 'Kund',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Betalningsvillkor: {
          AttributeName: 'Betalningsvillkor',
          DisplayLabel: 'Betalningsvillkor (benämning)',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        BetalningsvillkorText2: {
          AttributeName: 'BetalningsvillkorText2',
          DisplayLabel: 'BetalningsvillkorText',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AutogiroBetalarnr: {
          AttributeName: 'AutogiroBetalarnr',
          DisplayLabel: 'Autogiro, betalarnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        WebLosen: {
          AttributeName: 'WebLosen',
          DisplayLabel: 'Weblösen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Prislista: {
          AttributeName: 'Prislista',
          DisplayLabel: 'Prislista - benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ForseningsTid: {
          AttributeName: 'ForseningsTid',
          DisplayLabel: 'Genomsnittlig försening',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Övrigt',
        },
        Intern: {
          AttributeName: 'Intern',
          DisplayLabel: 'Intern (J/N)',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Tillgodohavande: {
          AttributeName: 'Tillgodohavande',
          DisplayLabel: 'Tillgodohavande',
          Hint: 'Ej exporterbar, anv i manuell inbet. Anv KontosaldoAktuellt innan. Men vi blandar tillgodohavande och konto. Egentligen skulle inga insättningar på konto komma med. Här har vi filtrerat bort Autotamtiska insättningar',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        TypOrder: {
          AttributeName: 'TypOrder',
          DisplayLabel: 'Kundtyp',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'None',
        },
        xKundOPLBorttagen: {
          AttributeName: 'xKundOPLBorttagen',
          DisplayLabel: 'Borttagen adress (J/N)',
          Hint: 'Kunder vars adress är borttagen',
          DataType: 'Enum',
          EnumValues: new Map([['KUNDER_VARS_ADRESS_AR_BORTTAGEN', 'Kunder vars adress är borttagen']]),
          EnumSortValues: new Map([['KUNDER_VARS_ADRESS_AR_BORTTAGEN', 'Y']]),
          Attribute: 'None',
          Condition: 'Internal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KUNDER_VARS_ADRESS_AR_BORTTAGEN=Kunder vars adress är borttagen"',
          InterfaceType: 'ifChecklist',
        },
        FAKTUTSKRIFT_BANKKONTO: {
          AttributeName: 'FAKTUTSKRIFT_BANKKONTO',
          DisplayLabel: 'Skriv ut bankkontofaktura (J/N)',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['FakturaKund'],
          AttributeGroup: 'Bankkonto',
        },
        KREDITERA_TILLGODOH: {
          AttributeName: 'KREDITERA_TILLGODOH',
          DisplayLabel: 'Använd tillgodhavande',
          Hint: 'Anger om man vill kreditera tillgodohavande vid fakturering - Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['FakturaKund'],
          AttributeGroup: 'Övrigt',
        },
        BANKKONTONUMMER: {
          AttributeName: 'BANKKONTONUMMER',
          DisplayLabel: 'Bankkontonummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['FakturaKund'],
          AttributeGroup: 'Bankkonto',
        },
        BANK_ID: {
          AttributeName: 'BANK_ID',
          DisplayLabel: 'BankID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['FakturaKund'],
        },
        FAKTURERINGSSATT: {
          AttributeName: 'FAKTURERINGSSATT',
          DisplayLabel: 'Faktureringssätt',
          Hint: 'Faktura/Autogiro/Bankkonto/KOB',
          DataType: 'Enum',
          EnumValues: new Map([['FAKTURA', 'Faktura'], ['AUTOGIRO', 'Autogiro'], ['BANKKONTO', 'Bankkonto'], ['KOB', 'KOB']]),
          EnumSortValues: new Map([['FAKTURA', 'F'], ['AUTOGIRO', 'U'], ['BANKKONTO', 'B'], ['KOB', 'O']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAKTURA=Faktura;AUTOGIRO=Autogiro;BANKKONTO=Bankkonto;KOB=KOB"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          ValidInComps: ['FakturaKund'],
        },
        Clearingnummer: {
          AttributeName: 'Clearingnummer',
          DisplayLabel: 'Clearingnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['FakturaKund'],
        },
        Banknamn: {
          AttributeName: 'Banknamn',
          DisplayLabel: 'Banknamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCase',
          ValidInComps: ['FakturaKund'],
          AttributeGroup: 'Bankkonto',
        },
        BankkontonrTot: {
          AttributeName: 'BankkontonrTot',
          DisplayLabel: 'Bankkontonummer (inkl clearingnr)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['FakturaKund'],
          AttributeGroup: 'Bankkonto',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Banknamn2: {
          AttributeName: 'Banknamn2',
          DisplayLabel: 'Banknamn2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['FakturaKund'],
        },
        AVTAL_FR: {
          AttributeName: 'AVTAL_FR',
          DisplayLabel: 'Startmånad',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          FormatterParseParams: 'CenturyLimit=90',
          FormatterValidateParams: 'MaxDate="+720m";MinDate="-1200m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Avtal'],
          AttributeGroup: 'Avtal',
        },
        AVTAL_TI: {
          AttributeName: 'AVTAL_TI',
          DisplayLabel: 'Slutmånad',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          FormatterParseParams: 'CenturyLimit=90',
          FormatterValidateParams: 'MaxDate="+720m";MinDate="-1200m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Avtal'],
          AttributeGroup: 'Avtal',
        },
        AVTAL_MANADER: {
          AttributeName: 'AVTAL_MANADER',
          DisplayLabel: 'Antal månader',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Avtal'],
          AttributeGroup: 'Avtal',
        },
        BegrVerksamhet: {
          AttributeName: 'BegrVerksamhet',
          DisplayLabel: 'Begravningsverksamheten',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Avtal'],
          AttributeGroup: 'Avtal',
        },
        Avtalsperiod: {
          AttributeName: 'Avtalsperiod',
          DisplayLabel: 'Period',
          Hint: 'Periodintervall på formen "ÅÅMM - ÅÅMM"',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Avtal'],
          AttributeGroup: 'Avtal',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        InsattBelopp: {
          AttributeName: 'InsattBelopp',
          DisplayLabel: 'Insatt belopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          ValidInComps: ['Avtal'],
          AttributeGroup: 'Avtal',
        },
        VilandeAvtalPer: {
          AttributeName: 'VilandeAvtalPer',
          DisplayLabel: 'Vilande avtal per datum',
          DataType: 'Date',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Avtal'],
          AttributeGroup: 'Fasttidsavtal',
        },
        URSPRUNGS_BELOPP: {
          AttributeName: 'URSPRUNGS_BELOPP',
          DisplayLabel: 'Ursprungsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['KontoKund'],
          AttributeGroup: 'Avräkningsavtal',
        },
        MOMSPAKONTOFAKTURA: {
          AttributeName: 'MOMSPAKONTOFAKTURA',
          DisplayLabel: 'Moms på avräkning',
          Hint: 'Ingen/Faktura/Kontofakturor',
          DataType: 'Enum',
          EnumValues: new Map([['INGEN', 'Ingen'], ['FAKTURA', 'Faktura'], ['KONTOFAKTUROR', 'Kontofakturor']]),
          EnumSortValues: new Map([['INGEN', 'I'], ['FAKTURA', 'F'], ['KONTOFAKTUROR', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INGEN=Ingen;FAKTURA=Faktura;KONTOFAKTUROR=Kontofakturor"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          ValidInComps: ['KontoKund'],
          AttributeGroup: 'Avräkningsavtal',
        },
        ADMINAVGIFTKONTOFAKTURA: {
          AttributeName: 'ADMINAVGIFTKONTOFAKTURA',
          DisplayLabel: 'Administrationsavgift kontofaktura',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['KontoKund'],
          AttributeGroup: 'Avräkningsavtal',
        },
        FAKTUTSKRIFT_KONTOFAKTURA: {
          AttributeName: 'FAKTUTSKRIFT_KONTOFAKTURA',
          DisplayLabel: 'Skriv ut avräkningsfaktura (J/N)',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['KontoKund'],
          AttributeGroup: 'Avräkningsavtal',
        },
        AVTALSBELOPP: {
          AttributeName: 'AVTALSBELOPP',
          DisplayLabel: 'Avtalsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['AvtalKund'],
          AttributeGroup: 'Fasttidsavtal',
        },
        Restbelopp: {
          AttributeName: 'Restbelopp',
          DisplayLabel: 'Restbelopp',
          Hint: 'Avtalsbelopp inkl. avräkningar och uppräkningar',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notgreater,
          ValidInComps: ['AvtalKund'],
          AttributeGroup: 'Fasttidsavtal',
        },
        SenastAvraknat: {
          AttributeName: 'SenastAvraknat',
          DisplayLabel: 'Senast avräknat',
          Hint: 'Fasttidsavtal',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['AvtalKund'],
          AttributeGroup: 'Fasttidsavtal',
        },
        RestbeloppPerDatum: {
          AttributeName: 'RestbeloppPerDatum',
          DisplayLabel: 'RestbeloppPerDatum',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          ValidInComps: ['AvtalKund'],
          AttributeParams: {'rbpd_datum': {type: 'Date', defaultValue: ''}},
        },
        ForstaKGardId: {
          AttributeName: 'ForstaKGardId',
          DisplayLabel: 'ForstaKGardId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          ValidInComps: ['AvtalKund'],
        },
        FAKTURAFORMEDLARE_ID: {
          AttributeName: 'FAKTURAFORMEDLARE_ID',
          DisplayLabel: 'Fakturaförmedlare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontosaldoAktuellt2: {
          AttributeName: 'KontosaldoAktuellt2',
          DisplayLabel: 'Tillgodohavande',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Fakturakund',
        },
        DebsattKund: {
          AttributeName: 'DebsattKund',
          DisplayLabel: 'Kund',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTNAMN: {
          AttributeName: 'FAKTNAMN',
          DisplayLabel: 'Avvikande fakt.adress, namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Avvikande fakt.adress',
        },
        FAKTADRESS: {
          AttributeName: 'FAKTADRESS',
          DisplayLabel: 'Avvikande fakt.adress, gatuadress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Avvikande fakt.adress',
        },
        FAKTCO: {
          AttributeName: 'FAKTCO',
          DisplayLabel: 'Avvikande fakt.adress, co',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Avvikande fakt.adress',
        },
        FAKTPOSTNR: {
          AttributeName: 'FAKTPOSTNR',
          DisplayLabel: 'Avvikande fakt.adress, postnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Avvikande fakt.adress',
        },
        FAKTORT: {
          AttributeName: 'FAKTORT',
          DisplayLabel: 'Avvikande fakt.adress, ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Avvikande fakt.adress',
        },
        FAKTLAND_ID: {
          AttributeName: 'FAKTLAND_ID',
          DisplayLabel: 'Faktureringsadress, land',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REFERENS_KRAVS: {
          AttributeName: 'REFERENS_KRAVS',
          DisplayLabel: 'Referens krävs',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Övrigt',
        },
        REFERENS_MEDDELANDE: {
          AttributeName: 'REFERENS_MEDDELANDE',
          DisplayLabel: 'Referens meddelande',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Övrigt',
        },
        Faktureringsland: {
          AttributeName: 'Faktureringsland',
          DisplayLabel: 'Avvikande fakt.adress, land',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Avvikande fakt.adress',
        },
        VANLEV: {
          AttributeName: 'VANLEV',
          DisplayLabel: 'VAN-Leverantör',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SenastAvraknatAvr: {
          AttributeName: 'SenastAvraknatAvr',
          DisplayLabel: 'Senast avräknat',
          Hint: 'Avräkningsavtal',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsYear',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['KontoKund'],
          AttributeGroup: 'Fasttidsavtal',
        },
        SenasteAvtalsorder: {
          AttributeName: 'SenasteAvtalsorder',
          DisplayLabel: 'Avtalsorder skapad',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          ValidInComps: ['Avtal'],
          AttributeGroup: 'Avtal',
        },
        InsattningFinns: {
          AttributeName: 'InsattningFinns',
          DisplayLabel: 'Insättning finns',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Avtal',
        },
        GLNNR: {
          AttributeName: 'GLNNR',
          DisplayLabel: 'GLN-nr/Peppol-ID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Avtalsbelopp2: {
          AttributeName: 'Avtalsbelopp2',
          DisplayLabel: 'Avtalsbelopp/ursprungsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Avtal'],
          AttributeGroup: 'Avtal',
        },
        FORNYAD_FRAN_ID: {
          AttributeName: 'FORNYAD_FRAN_ID',
          DisplayLabel: 'Förnyad från',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Gravskötselavtal',
        },
        FORNYAD_SOM_ID: {
          AttributeName: 'FORNYAD_SOM_ID',
          DisplayLabel: 'Förnyad som',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Gravskötselavtal',
        },
        FORNYAD_DATUM: {
          AttributeName: 'FORNYAD_DATUM',
          DisplayLabel: 'Förnyad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Gravskötselavtal',
        },
        FORNYAD_SIGN: {
          AttributeName: 'FORNYAD_SIGN',
          DisplayLabel: 'Förnyad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Gravskötselavtal',
        },
        FORNYAD_MANUELLT: {
          AttributeName: 'FORNYAD_MANUELLT',
          DisplayLabel: 'Manuellt hanterad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Gravskötselavtal',
        },
        GravNrBetAnsv: {
          AttributeName: 'GravNrBetAnsv',
          DisplayLabel: 'Gravplats',
          Hint: 'Betalningsansvarig på gravplats(er)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Övrigt',
        },
        GravNrBetAnsvAntal: {
          AttributeName: 'GravNrBetAnsvAntal',
          DisplayLabel: 'Gravplatser, antal',
          Hint: 'Betalningsansvarig på gravplats(er)',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Övrigt',
        },
        ANVAND_EFAKT_FORETAG: {
          AttributeName: 'ANVAND_EFAKT_FORETAG',
          DisplayLabel: 'Använder E-fakturering företag',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EFAKT_ID: {
          AttributeName: 'EFAKT_ID',
          DisplayLabel: 'E-Faktura ID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FAKTMOTTAG_BANK: {
          AttributeName: 'FAKTMOTTAG_BANK',
          DisplayLabel: 'Fakturamottagarens bank',
          Hint: 'SEB/Handelsbanken/Danske Bank/Swedbank/Nordea/SkandiaBanken/Sparbanken Öresund/ICA-banken/Länsförsäkringar Bank/DNB Bank/Sparbanken Syd/SBAB Bank/Ålandsbanken',
          DataType: 'Enum',
          EnumValues: new Map([['SEB', 'SEB'], ['HANDELSBANKEN', 'Handelsbanken'], ['DANSKE_BANK', 'Danske Bank'], ['SWEDBANK', 'Swedbank'], ['NORDEA', 'Nordea'], ['SKANDIABANKEN', 'SkandiaBanken'], ['SPARBANKEN_ORESUND', 'Sparbanken Öresund'], ['ICA_BANKEN', 'ICA-banken'], ['LANSFORSAKRINGAR_BANK', 'Länsförsäkringar Bank'], ['DNB_BANK', 'DNB Bank'], ['SPARBANKEN_SYD', 'Sparbanken Syd'], ['SBAB_BANK', 'SBAB Bank'], ['ALANDSBANKEN', 'Ålandsbanken']]),
          EnumSortValues: new Map([['SEB', 'SEB'], ['HANDELSBANKEN', 'SHB'], ['DANSKE_BANK', 'OEB'], ['SWEDBANK', 'FSPA'], ['NORDEA', 'NB'], ['SKANDIABANKEN', 'SKB'], ['SPARBANKEN_ORESUND', 'FINN'], ['ICA_BANKEN', 'ICA'], ['LANSFORSAKRINGAR_BANK', 'LFB'], ['DNB_BANK', 'DNB'], ['SPARBANKEN_SYD', 'SYD'], ['SBAB_BANK', 'SBAB'], ['ALANDSBANKEN', 'AAB']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEB=SEB;HANDELSBANKEN=Handelsbanken;DANSKE_BANK=Danske Bank;SWEDBANK=Swedbank;NORDEA=Nordea;SKANDIABANKEN=SkandiaBanken;SPARBANKEN_ORESUND=Sparbanken Öresund;ICA_BANKEN=ICA-banken;LANSFORSAKRINGAR_BANK=Länsförsäkringar Bank;DNB_BANK=DNB Bank;SPARBANKEN_SYD=Sparbanken Syd;SBAB_BANK=SBAB Bank;ALANDSBANKEN=Ålandsbanken"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANVAND_EFAKT_PRIVAT: {
          AttributeName: 'ANVAND_EFAKT_PRIVAT',
          DisplayLabel: 'Använder E-fakturering privat',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EFAKT_KUNDNR: {
          AttributeName: 'EFAKT_KUNDNR',
          DisplayLabel: 'E-Faktura kundnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EFAKT_KONTROLLSIFFRA: {
          AttributeName: 'EFAKT_KONTROLLSIFFRA',
          DisplayLabel: 'E-Faktura kontrollsiffra',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MOTPART: {
          AttributeName: 'MOTPART',
          DisplayLabel: 'Motpart',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Agresso',
        },
        EXTERNT_KUNDNR: {
          AttributeName: 'EXTERNT_KUNDNR',
          DisplayLabel: 'Externt kundnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 25,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Agresso',
        },
        KundnrExt: {
          AttributeName: 'KundnrExt',
          DisplayLabel: 'Kundnummer',
          Hint: 'Kundnummer och externt kundnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Agresso',
        },
        EFAKTMOTTAG_PERSNR: {
          AttributeName: 'EFAKTMOTTAG_PERSNR',
          DisplayLabel: 'Efakturamottagarens persnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BERAKNAT_BELOPP: {
          AttributeName: 'BERAKNAT_BELOPP',
          DisplayLabel: 'Beräknat belopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IsBetalningsansvarig: {
          AttributeName: 'IsBetalningsansvarig',
          DisplayLabel: 'Är betalningsansvarig för grav',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        HarOfaktureradOrder: {
          AttributeName: 'HarOfaktureradOrder',
          DisplayLabel: 'Har ofakturerad order',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        HarOppnaFakturor: {
          AttributeName: 'HarOppnaFakturor',
          DisplayLabel: 'Har ej slutbetalda fakturor',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        HarOppnaJournaler: {
          AttributeName: 'HarOppnaJournaler',
          DisplayLabel: 'Har öppna journaler',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        GDPRReferensdatum: {
          AttributeName: 'GDPRReferensdatum',
          DisplayLabel: 'Referensdatum GDPR',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notgreater,
          AttributeGroup: 'Övrigt',
        },
        ANVAND_KUNDFAKTBUNT_XML: {
          AttributeName: 'ANVAND_KUNDFAKTBUNT_XML',
          DisplayLabel: 'Kundfakturor som XML',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EFAKT_ANMAL_DATUM: {
          AttributeName: 'EFAKT_ANMAL_DATUM',
          DisplayLabel: 'Datum, efakturaanmälan',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PEPPOL: {
          AttributeName: 'PEPPOL',
          DisplayLabel: 'Använder Peppol',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        HarAktivUtanordning: {
          AttributeName: 'HarAktivUtanordning',
          DisplayLabel: 'Har aktiv utanordning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Övrigt',
        },
        AktivUABeloppSum: {
          AttributeName: 'AktivUABeloppSum',
          DisplayLabel: 'Summa aktiva utanordningar',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNone',
          AttributeGroup: 'Övrigt',
        },
        AktivUABeloppSumText: {
          AttributeName: 'AktivUABeloppSumText',
          DisplayLabel: 'Summa aktiva utanordningar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TillgodoMinusAktivaUAs: {
          AttributeName: 'TillgodoMinusAktivaUAs',
          DisplayLabel: 'Tillgodo minus utanordningar',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        KontoSaldoMinusAktivaUAs: {
          AttributeName: 'KontoSaldoMinusAktivaUAs',
          DisplayLabel: 'Kontosaldo minus utanordningar',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KIVRA: {
          AttributeName: 'KIVRA',
          DisplayLabel: 'Kivra',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FAKTUROR_VIA_EPOST: {
          AttributeName: 'FAKTUROR_VIA_EPOST',
          DisplayLabel: 'Fakturor via epost',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        KundKategori: {
          AssociationName: 'KundKategori',
          DisplayLabel: 'Kundkategori',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKundkategori',
          AssociatedComponentName: 'KundKategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        OrgPers: {
          AssociationName: 'OrgPers',
          DisplayLabel: 'Adress',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPers',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Valuta: {
          AssociationName: 'Valuta',
          DisplayLabel: 'Valuta',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSValuta',
          AssociatedComponentName: 'Valuta',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Prislista: {
          AssociationName: 'Prislista',
          DisplayLabel: 'Prislista',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAPrislista',
          AssociatedComponentName: 'Prislista',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Sprak: {
          AssociationName: 'Sprak',
          DisplayLabel: 'Språk',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSSprak',
          AssociatedComponentName: 'Sprak',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Leveransvillkor: {
          AssociationName: 'Leveransvillkor',
          DisplayLabel: 'Leveransvillkor',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSLeveransvillkor',
          AssociatedComponentName: 'Leveransvillkor',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Betalningsvillkor: {
          AssociationName: 'Betalningsvillkor',
          DisplayLabel: 'Betalningsvillkor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSBetalningsvillkor',
          AssociatedComponentName: 'Betalningsvillkor',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Autogiromall: {
          AssociationName: 'Autogiromall',
          DisplayLabel: 'Autogiromall',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSAutogiroMall',
          AssociatedComponentName: 'Autogiromall',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bank: {
          AssociationName: 'Bank',
          DisplayLabel: 'Bank',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSBank',
          AssociatedComponentName: 'Bank',
          JoinAssociation: true,
          ValidInComps: ['FakturaKund'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturaformedlare: {
          AssociationName: 'Fakturaformedlare',
          DisplayLabel: 'Fakturaförmedlare',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSFakturaformedlare',
          AssociatedComponentName: 'Fakturaformedlare',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FaktureringsLand: {
          AssociationName: 'FaktureringsLand',
          DisplayLabel: 'Faktureringsland',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSLand',
          AssociatedComponentName: 'Land',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FornyadFran: {
          AssociationName: 'FornyadFran',
          DisplayLabel: 'Förnyad från',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: true,
          ValidInComps: ['Kund'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FornyadSom: {
          AssociationName: 'FornyadSom',
          DisplayLabel: 'Förnyad som',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: true,
          ValidInComps: ['Kund'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Handelse: {
          AssociationName: 'Handelse',
          DisplayLabel: 'Händelser',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKFakturahandelse',
          AssociatedComponentName: 'Fakturahandelse',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'True']]),
        },
        Fakturor: {
          AssociationName: 'Fakturor',
          DisplayLabel: 'Fakturor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRFaktura',
          AssociatedComponentName: 'Faktura',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokfhandelse: {
          AssociationName: 'Bokfhandelse',
          DisplayLabel: 'Bokföringshändelse',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKFakturahandelse',
          AssociatedComponentName: 'BokfHandelse',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Licenser: {
          AssociationName: 'Licenser',
          DisplayLabel: 'Licenser',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRLicenser',
          AssociatedComponentName: 'Licenser',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        FindBetalningsansvarig: {
          AssociationName: 'FindBetalningsansvarig',
          DisplayLabel: 'Betalningsansvarig för grav',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAKontakt',
          AssociatedComponentName: 'Betalningsansvarig',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['PROPERTY_OPL', 'Y'], ['PROPERTY_KUND', 'Y']]),
        },
        GravKontakt: {
          AssociationName: 'GravKontakt',
          DisplayLabel: 'Betalningsansvarig på gravplats',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAKontakt',
          AssociatedComponentName: 'Betalningsansvarig',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Medgivande: {
          AssociationName: 'Medgivande',
          DisplayLabel: 'Medgivande',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRMedgivande',
          AssociatedComponentName: 'Medgivande',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Extrakund: {
          AssociationName: 'Extrakund',
          DisplayLabel: 'Extra kund',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRAndrahand',
          AssociatedComponentName: 'Andrahandskund',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        PrisavtalKund: {
          AssociationName: 'PrisavtalKund',
          DisplayLabel: 'PrisavtalKund',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OFTEDOFPrisavtalKund',
          AssociatedComponentName: 'PrisavtalKund',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        OrderEjFakt: {
          AssociationName: 'OrderEjFakt',
          DisplayLabel: 'Ordrar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OFOrder',
          AssociatedComponentName: 'Order',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Arbetsuppgift: {
          AssociationName: 'Arbetsuppgift',
          DisplayLabel: 'Arbetsuppgift',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'TIArbetsuppgift',
          AssociatedComponentName: 'Arbetsuppgift',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anslutning: {
          AssociationName: 'Anslutning',
          DisplayLabel: 'Anslutningar',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRAnslutning',
          AssociatedComponentName: 'Anslutning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    KRKundfakturabunt: {
      CollectionName: 'KRKundfakturabunt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['GroupAssociation', 'Faktureringsgrupp']]),
      RootType: {
        TypeValue: 'Kundfakturabunt',
        Abstract: false,
        SOLabel: 'Kundfakturabunt',
        SOGLabel: 'Kundfakturabunt',
        SBLabel: 'Kundfakturabunten',
        SBGLabel: 'Kundfakturabunten',
        POLabel: 'Kundfakturabuntar',
        POGLabel: 'Kundfakturabuntar',
        PBLabel: 'Kundfakturabuntarna',
        PBGLabel: 'Kundfakturabuntarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kundfakturabunten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kundfakturabunten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kundfakturabunten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kundfakturabunten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        KLOCKSLAG: {
          AttributeName: 'KLOCKSLAG',
          DisplayLabel: 'Klockslag',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        FILNAMN: {
          AttributeName: 'FILNAMN',
          DisplayLabel: 'Filnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Skickad/Backad/Hanterad/Delvis hanterad/Ej Hanterad/Skickad, ej kvitterad/Fel, kontakta Eniac',
          DataType: 'Enum',
          EnumValues: new Map([['SKICKAD', 'Skickad'], ['BACKAD', 'Backad'], ['HANTERAD', 'Hanterad'], ['DELVIS_HANTERAD', 'Delvis hanterad'], ['EJ_HANTERAD', 'Ej Hanterad'], ['SKICKAD__EJ_KVITTERAD', 'Skickad, ej kvitterad'], ['FEL__KONTAKTA_ENIAC', 'Fel, kontakta Eniac']]),
          EnumSortValues: new Map([['SKICKAD', 'S'], ['BACKAD', 'B'], ['HANTERAD', 'H'], ['DELVIS_HANTERAD', 'D'], ['EJ_HANTERAD', 'E'], ['SKICKAD__EJ_KVITTERAD', 'K'], ['FEL__KONTAKTA_ENIAC', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKICKAD=Skickad;BACKAD=Backad;HANTERAD=Hanterad;DELVIS_HANTERAD=Delvis hanterad;EJ_HANTERAD=Ej Hanterad;SKICKAD__EJ_KVITTERAD=Skickad, ej kvitterad;FEL__KONTAKTA_ENIAC=Fel, kontakta Eniac"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        FAKTURAFORMEDLARE_ID: {
          AttributeName: 'FAKTURAFORMEDLARE_ID',
          DisplayLabel: 'FAKTURAFORMEDLARE_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        FAKTURAFIL: {
          AttributeName: 'FAKTURAFIL',
          DisplayLabel: 'Fakturafil',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        BOKF_GRUPP_ID: {
          AttributeName: 'BOKF_GRUPP_ID',
          DisplayLabel: 'Bokföringsgrupp',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KVITTENSFIL: {
          AttributeName: 'KVITTENSFIL',
          DisplayLabel: 'Kvittensfil',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        STATUS_TEXT: {
          AttributeName: 'STATUS_TEXT',
          DisplayLabel: 'Statustext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 500,
        },
        fakturaformedlareBenamning: {
          AttributeName: 'fakturaformedlareBenamning',
          DisplayLabel: 'Fakturaförmedlare',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        faktureringsgruppBenamning: {
          AttributeName: 'faktureringsgruppBenamning',
          DisplayLabel: 'Faktureringsgrupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Faktureringsgrupp: {
          AssociationName: 'Faktureringsgrupp',
          DisplayLabel: 'Faktureringsgrupp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'BokfgruppFakt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        fakturaformedlare: {
          AssociationName: 'fakturaformedlare',
          DisplayLabel: 'Fakturaförmedlare',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSFakturaformedlare',
          AssociatedComponentName: 'Fakturaformedlare',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        fakturor: {
          AssociationName: 'fakturor',
          DisplayLabel: 'Fakturor',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRFaktura',
          AssociatedComponentName: 'Faktura',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    KRKundkategori: {
      CollectionName: 'KRKundkategori',
      UDAEnabled: true,
      UDNEnabled: true,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KundKategori',
        Abstract: true,
        SOLabel: 'Kundkategori',
        SOGLabel: 'Kundkategori',
        SBLabel: 'Kundkategorin',
        SBGLabel: 'Kundkategorin',
        POLabel: 'Kundkategorier',
        POGLabel: 'Kundkategorier',
        PBLabel: 'Kundkategorierna',
        PBGLabel: 'Kundkategorierna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'FakturaKundKategori',
            Abstract: false,
            SOLabel: 'Fakturakundkategori',
            SOGLabel: 'Fakturakundkategori',
            SBLabel: 'Fakturakundkategorin',
            SBGLabel: 'Fakturakundkategorin',
            POLabel: 'Fakturakundkategorier',
            POGLabel: 'Fakturakundkategorier',
            PBLabel: 'Fakturakundkategorierna',
            PBGLabel: 'Fakturakundkategorierna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'AvtalKategori',
            Abstract: true,
            SOLabel: 'Avtalskategori',
            SOGLabel: 'Avtalskategori',
            SBLabel: 'Avtalskategorin',
            SBGLabel: 'Avtalskategorin',
            POLabel: 'Avtalskategorier',
            POGLabel: 'Avtalskategorier',
            PBLabel: 'Avtalskategorierna',
            PBGLabel: 'Avtalskategorierna',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'KontoKundKategori',
                Abstract: false,
                SOLabel: 'Avräkningsavtalskategori',
                SOGLabel: 'Avräkningsavtalskategori',
                SBLabel: 'Avräkningsavtalskategorin',
                SBGLabel: 'Avräkningsavtalskategorin',
                POLabel: 'Avräkningsavtalskategorier',
                POGLabel: 'Avräkningsavtalskategorier',
                PBLabel: 'Avräkningsavtalskategorierna',
                PBGLabel: 'Avräkningsavtalskategorierna',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'AvtalKundKategori',
                Abstract: false,
                SOLabel: 'Fasttidsavtalskategori',
                SOGLabel: 'Fasttidsavtalskategori',
                SBLabel: 'Fasttidsavtalskategorin',
                SBGLabel: 'Fasttidsavtalskategorin',
                POLabel: 'Fasttidsavtalskategorier',
                POGLabel: 'Fasttidsavtalskategorier',
                PBLabel: 'Fasttidsavtalskategorierna',
                PBGLabel: 'Fasttidsavtalskategorierna',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kundkategorin primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kundkategorin versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Kundkategorityp',
          DataType: 'Enum',
          EnumValues: new Map([['FAKTURAKUNDKATEGORI', 'Fakturakundkategori'], ['KONTOKUNDKATEGORI', 'Avräkningsavtalskategori'], ['AVTALKUNDKATEGORI', 'Fasttidsavtalskategori']]),
          EnumSortValues: new Map([['FAKTURAKUNDKATEGORI', 'F'], ['KONTOKUNDKATEGORI', 'K'], ['AVTALKUNDKATEGORI', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAKTURAKUNDKATEGORI=Fakturakundkategori;KONTOKUNDKATEGORI=Avräkningsavtalskategori;AVTALKUNDKATEGORI=Fasttidsavtalskategori"',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kundkategorin id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kundkategorin fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KUNDKAT_KOD: {
          AttributeName: 'KUNDKAT_KOD',
          DisplayLabel: 'Kundkategori',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesHintAttribute', 'BENAMNING;'], ['ConditionShowValuesFilter', '{TYP} in (#../ValidTypes#)']]),
        },
        INTERN: {
          AttributeName: 'INTERN',
          DisplayLabel: 'Intern (J/N)',
          Hint: 'Intern/Extern',
          DataType: 'Enum',
          EnumValues: new Map([['INTERN', 'Intern'], ['EXTERN', 'Extern']]),
          EnumSortValues: new Map([['INTERN', 'Y'], ['EXTERN', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INTERN=Intern;EXTERN=Extern"',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesFilter', '{TYP} in (#../ValidTypes#)']]),
        },
        MOMS_ID: {
          AttributeName: 'MOMS_ID',
          DisplayLabel: 'Moms',
          Hint: 'Denna används inte i programmet längre/Arno',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RANTETABELLDROJSMAL_ID: {
          AttributeName: 'RANTETABELLDROJSMAL_ID',
          DisplayLabel: 'Räntetabell dröjsmålsränta',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RANTETABELLDEBITERING_ID: {
          AttributeName: 'RANTETABELLDEBITERING_ID',
          DisplayLabel: 'Skuldränta fond',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RANTETABELLKREDIT_ID: {
          AttributeName: 'RANTETABELLKREDIT_ID',
          DisplayLabel: 'Tillgodoränta fond',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RANTEBERAKNMETOD: {
          AttributeName: 'RANTEBERAKNMETOD',
          DisplayLabel: 'Ränteberäkningsmetod',
          Hint: 'Ränta per ingående saldo/Ränta per utgående saldo/Dag för dag ränta/Ingen ränteberäkning',
          DataType: 'Enum',
          EnumValues: new Map([['RANTA_PER_INGAENDE_SALDO', 'Ränta per ingående saldo'], ['RANTA_PER_UTGAENDE_SALDO', 'Ränta per utgående saldo'], ['DAG_FOR_DAG_RANTA', 'Dag för dag ränta'], ['INGEN_RANTEBERAKNING', 'Ingen ränteberäkning']]),
          EnumSortValues: new Map([['RANTA_PER_INGAENDE_SALDO', 'I'], ['RANTA_PER_UTGAENDE_SALDO', 'U'], ['DAG_FOR_DAG_RANTA', 'D'], ['INGEN_RANTEBERAKNING', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="RANTA_PER_INGAENDE_SALDO=Ränta per ingående saldo;RANTA_PER_UTGAENDE_SALDO=Ränta per utgående saldo;DAG_FOR_DAG_RANTA=Dag för dag ränta;INGEN_RANTEBERAKNING=Ingen ränteberäkning"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        BANK_ID: {
          AttributeName: 'BANK_ID',
          DisplayLabel: 'Clearingnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KUND_KONTONRSERIE_ID: {
          AttributeName: 'KUND_KONTONRSERIE_ID',
          DisplayLabel: 'Kund/Avtalsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STANDARD: {
          AttributeName: 'STANDARD',
          DisplayLabel: 'Standard',
          Hint: 'Standardkundkategori föreslås alltid vid nyregistrering av kund - Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          Required: true,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBInktaktskonto: {
          AttributeName: 'KBInktaktskonto',
          DisplayLabel: 'KBInktaktskonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBKundfordrkonto: {
          AttributeName: 'KBKundfordrkonto',
          DisplayLabel: 'KBKundfordrkonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBDrojsmalintaktkonto: {
          AttributeName: 'KBDrojsmalintaktkonto',
          DisplayLabel: 'KBDrojsmalintaktkonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBDiffInbetkonto: {
          AttributeName: 'KBDiffInbetkonto',
          DisplayLabel: 'KBDiffInbetkonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBKontoskuld: {
          AttributeName: 'KBKontoskuld',
          DisplayLabel: 'KBKontoskuld',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBKontorantaKredit: {
          AttributeName: 'KBKontorantaKredit',
          DisplayLabel: 'KBKontorantaKredit',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBKontorantaDebet: {
          AttributeName: 'KBKontorantaDebet',
          DisplayLabel: 'KBKontorantaDebet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Typben: {
          AttributeName: 'Typben',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Mallkund: {
          AttributeName: 'Mallkund',
          DisplayLabel: 'Mallkund finns',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Momsrantetabell: {
          AttributeName: 'Momsrantetabell',
          DisplayLabel: 'Momsräntetabell',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Drojsmalsrantetabell: {
          AttributeName: 'Drojsmalsrantetabell',
          DisplayLabel: 'Dröjmålsräntetabell',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KBKontouppr: {
          AttributeName: 'KBKontouppr',
          DisplayLabel: 'KBKontouppr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KodBen: {
          AttributeName: 'KodBen',
          DisplayLabel: 'KodBen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Begravningsverk: {
          AttributeName: 'Begravningsverk',
          DisplayLabel: 'Begravningsverksamhet',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          ValidInComps: ['AvtalKategori'],
        },
        KBNollaSaldo: {
          AttributeName: 'KBNollaSaldo',
          DisplayLabel: 'KBNollaSaldo',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UTGSKOT_KUNDKAT_KOD: {
          AttributeName: 'UTGSKOT_KUNDKAT_KOD',
          DisplayLabel: 'Utgående skötsel, kundkategori',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Gravskötselavtal',
        },
        UTGSKOT_AVTALSLANGD: {
          AttributeName: 'UTGSKOT_AVTALSLANGD',
          DisplayLabel: 'Utgående skötsel, avtalslängd år',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="1"',
          AttributeGroup: 'Gravskötselavtal',
        },
        UTGSKOT_PRISMETOD: {
          AttributeName: 'UTGSKOT_PRISMETOD',
          DisplayLabel: 'Gravskötselavtal, prisberäkningsmetod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Gravskötselavtal',
        },
        UTGSKOT_PRISMETOD_PARAM: {
          AttributeName: 'UTGSKOT_PRISMETOD_PARAM',
          DisplayLabel: 'Gravskötselavtal, prisberäkningsparametrar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Gravskötselavtal',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Moms: {
          AssociationName: 'Moms',
          DisplayLabel: 'Momsräntetabell',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSMoms',
          AssociatedComponentName: 'Moms',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Intaktskonto: {
          AssociationName: 'Intaktskonto',
          DisplayLabel: 'Intäktskonto',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Kundfordrkonto: {
          AssociationName: 'Kundfordrkonto',
          DisplayLabel: 'Kundfordringars konto',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Drojsmalintaktkonto: {
          AssociationName: 'Drojsmalintaktkonto',
          DisplayLabel: 'Intäktskonto för dröjsmålsränta',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        DiffInbetkonto: {
          AssociationName: 'DiffInbetkonto',
          DisplayLabel: 'Konto för differens vid inbetalning',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        KundSkuldkonto: {
          AssociationName: 'KundSkuldkonto',
          DisplayLabel: 'Kundkonto',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        KundrantaKredit: {
          AssociationName: 'KundrantaKredit',
          DisplayLabel: 'Tillgodoränta',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        KundrantaDebet: {
          AssociationName: 'KundrantaDebet',
          DisplayLabel: 'Skuldränta',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Bank: {
          AssociationName: 'Bank',
          DisplayLabel: 'Bank',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSBank',
          AssociatedComponentName: 'Bank',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        RantetabellDrojsmal: {
          AssociationName: 'RantetabellDrojsmal',
          DisplayLabel: 'Dröjsmålsräntetabell',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSRanteTabell',
          AssociatedComponentName: 'Rantetabell',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kundnrserie: {
          AssociationName: 'Kundnrserie',
          DisplayLabel: 'Kund- och avtalsnrserier',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSNummerserie',
          AssociatedComponentName: 'StandigNummerserie',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        RantetabellDebitering: {
          AssociationName: 'RantetabellDebitering',
          DisplayLabel: 'Skuldränta fond',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSRanteTabell',
          AssociatedComponentName: 'Rantetabell',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        RantetabellKreditering: {
          AssociationName: 'RantetabellKreditering',
          DisplayLabel: 'Tillgodoränta fond',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSRanteTabell',
          AssociatedComponentName: 'Rantetabell',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontouppr: {
          AssociationName: 'Kontouppr',
          DisplayLabel: 'Kontouppr',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        NollaSaldo: {
          AssociationName: 'NollaSaldo',
          DisplayLabel: 'Konto för att justera saldo',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Kund: {
          AssociationName: 'Kund',
          DisplayLabel: 'Kund',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        KundkategoriFaktGrupp: {
          AssociationName: 'KundkategoriFaktGrupp',
          DisplayLabel: 'KundkategoriFaktGrupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRKundkatFaktGrupp',
          AssociatedComponentName: 'KundkatFaktGrupp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        GravAvtalArtiklar: {
          AssociationName: 'GravAvtalArtiklar',
          DisplayLabel: 'Fakturera gravskötselavtal, prisberäkningsartiklar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKundkategoriGravAvtalArtikel',
          AssociatedComponentName: 'KundkategoriGravAvtalArtikel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        UtgSkotSparrArtiklar: {
          AssociationName: 'UtgSkotSparrArtiklar',
          DisplayLabel: 'Utgående skötsel, artiklar som spärrar förnyelse',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKundkategoriUtgSkotSparrArtikel',
          AssociatedComponentName: 'KundkategoriUtgSkotSparrArtikel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    KRKundkatFaktGrupp: {
      CollectionName: 'KRKundkatFaktGrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KundkatFaktGrupp',
        Abstract: false,
        SOLabel: 'Kundkategorins faktureringsgrupp',
        SOGLabel: 'Kundkategorins faktureringsgrupp',
        SBLabel: 'Kundkategorins faktureringsgrupp',
        SBGLabel: 'Kundkategorins faktureringsgrupp',
        POLabel: 'Kundkategorins faktureringsgrupp',
        POGLabel: 'Kundkategorins faktureringsgrupp',
        PBLabel: 'Kundkategorins faktureringsgrupp',
        PBGLabel: 'Kundkategorins faktureringsgrupp',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kundkategorins faktureringsgrupp primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kundkategorins faktureringsgrupp versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kundkategorins faktureringsgrupp id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kundkategorins faktureringsgrupp fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Normal/Avvikande',
          DataType: 'Enum',
          EnumValues: new Map([['NORMAL', 'Normal'], ['AVVIKANDE', 'Avvikande']]),
          EnumSortValues: new Map([['NORMAL', 'N'], ['AVVIKANDE', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NORMAL=Normal;AVVIKANDE=Avvikande"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        Kundkategori: {
          AttributeName: 'Kundkategori',
          DisplayLabel: 'Kundkategori',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KundkategoriTyp: {
          AttributeName: 'KundkategoriTyp',
          DisplayLabel: 'Kundkategorityp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Faktureringsgrupp: {
          AttributeName: 'Faktureringsgrupp',
          DisplayLabel: 'Faktureringsgrupp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KundkatBorttagen: {
          AttributeName: 'KundkatBorttagen',
          DisplayLabel: 'KundkatBorttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kundkategori: {
          AssociationName: 'Kundkategori',
          DisplayLabel: 'Kundkategori',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKundkategori',
          AssociatedComponentName: 'KundKategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Faktureringsgrupp: {
          AssociationName: 'Faktureringsgrupp',
          DisplayLabel: 'Faktureringsgrupp',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'BokfgruppFakt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    KRLicenser: {
      CollectionName: 'KRLicenser',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '6024']]),
      RootType: {
        TypeValue: 'Licenser',
        Abstract: true,
        SOLabel: 'Licens',
        SOGLabel: 'Licens',
        SBLabel: 'Licensen',
        SBGLabel: 'Licensen',
        POLabel: 'Licenser',
        POGLabel: 'Licenser',
        PBLabel: 'Licenserna',
        PBGLabel: 'Licenserna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'Avenylicens',
            Abstract: true,
            SOLabel: 'Avenylicens',
            SOGLabel: 'Avenylicens',
            SBLabel: 'Avenylicensen',
            SBGLabel: 'Avenylicensen',
            POLabel: 'Avenylicenser',
            POGLabel: 'Avenylicenser',
            PBLabel: 'Avenylicenserna',
            PBGLabel: 'Avenylicenserna',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'Klient',
                Abstract: false,
                SOLabel: 'Klientlicens',
                SOGLabel: 'Klientlicens',
                SBLabel: 'Klientlicensen',
                SBGLabel: 'Klientlicensen',
                POLabel: 'Klientlicenser',
                POGLabel: 'Klientlicenser',
                PBLabel: 'Klientlicenserna',
                PBGLabel: 'Klientlicenserna',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'Paket',
                Abstract: false,
                SOLabel: 'Paketlicens',
                SOGLabel: 'Paketlicens',
                SBLabel: 'Paketlicensen',
                SBGLabel: 'Paketlicensen',
                POLabel: 'Paketlicenser',
                POGLabel: 'Paketlicenser',
                PBLabel: 'Paketlicenserna',
                PBGLabel: 'Paketlicenserna',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'OptionsLicens',
                Abstract: false,
                SOLabel: 'Optionslicens',
                SOGLabel: 'Optionslicens',
                SBLabel: 'Optionslicensen',
                SBGLabel: 'Optionslicensen',
                POLabel: 'Optionslicenser',
                POGLabel: 'Optionslicenser',
                PBLabel: 'Optionslicenserna',
                PBGLabel: 'Optionslicenserna',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'MenySparLicens',
            Abstract: false,
            SOLabel: 'Meny/Spar-licens',
            SOGLabel: 'Meny/Spar-licens',
            SBLabel: 'Meny/Spar-licensen',
            SBGLabel: 'Meny/Spar-licensen',
            POLabel: 'Meny/Spar-licenser',
            POGLabel: 'Meny/Spar-licenser',
            PBLabel: 'Meny/Spar-licenserna',
            PBGLabel: 'Meny/Spar-licenserna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'InkoptLicens',
            Abstract: false,
            SOLabel: 'Inköpt licens',
            SOGLabel: 'Inköpt licens',
            SBLabel: 'Inköpta licensen',
            SBGLabel: 'Inköpta licensen',
            POLabel: 'Inköpta licenser',
            POGLabel: 'Inköpta licenser',
            PBLabel: 'Inköpta licenserna',
            PBGLabel: 'Inköpta licenserna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'OvrigLicens',
            Abstract: false,
            SOLabel: 'Övrig licens',
            SOGLabel: 'Övrig licens',
            SBLabel: 'Övriga licensen',
            SBGLabel: 'Övriga licensen',
            POLabel: 'Övriga licenser',
            POGLabel: 'Övriga licenser',
            PBLabel: 'Övriga licenserna',
            PBGLabel: 'Övriga licenserna',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Licensen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Licensen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Licenstyp',
          DataType: 'Enum',
          EnumValues: new Map([['KLIENT', 'Klientlicens'], ['PAKET', 'Paketlicens'], ['OPTIONSLICENS', 'Optionslicens'], ['MENYSPARLICENS', 'Meny/Spar-licens'], ['INKOPTLICENS', 'Inköpt licens'], ['OVRIGLICENS', 'Övrig licens']]),
          EnumSortValues: new Map([['KLIENT', 'K'], ['PAKET', 'P'], ['OPTIONSLICENS', 'T'], ['MENYSPARLICENS', 'M'], ['INKOPTLICENS', 'I'], ['OVRIGLICENS', 'O']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Licensen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Licensen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KUND_ID: {
          AttributeName: 'KUND_ID',
          DisplayLabel: 'Kund ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARTIKEL_ID: {
          AttributeName: 'ARTIKEL_ID',
          DisplayLabel: 'Artikel ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LICENSHAVARE: {
          AttributeName: 'LICENSHAVARE',
          DisplayLabel: 'Licenshavare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DATUMLIMIT: {
          AttributeName: 'DATUMLIMIT',
          DisplayLabel: 'Datumgräns',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateMonth',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        LICENS_ORDER_ID: {
          AttributeName: 'LICENS_ORDER_ID',
          DisplayLabel: 'Licensorder ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Fri text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv (J/N)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Internal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        STARTDATUM: {
          AttributeName: 'STARTDATUM',
          DisplayLabel: 'Gäller från datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        LICENSNUMMER: {
          AttributeName: 'LICENSNUMMER',
          DisplayLabel: 'Licensnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 16,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        DEMO: {
          AttributeName: 'DEMO',
          DisplayLabel: 'Demo (J/N)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ArtBen: {
          AttributeName: 'ArtBen',
          DisplayLabel: 'Artikel benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        TypNamn: {
          AttributeName: 'TypNamn',
          DisplayLabel: 'Licenstypnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        OrderInfo: {
          AttributeName: 'OrderInfo',
          DisplayLabel: 'Orderinfo',
          Hint: 'Lista över kundens order med vald artikel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        ArtNR: {
          AttributeName: 'ArtNR',
          DisplayLabel: 'Artikel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen sign.',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        MAX_PALOGGADE: {
          AttributeName: 'MAX_PALOGGADE',
          DisplayLabel: 'Antal användare',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Licenstyp: {
          AttributeName: 'Licenstyp',
          DisplayLabel: 'Licenstyp',
          Hint: 'Fullvärdig/Begränsad/Grupp/Grund/Utökad/Klient',
          DataType: 'Enum',
          EnumValues: new Map([['FULLVARDIG', 'Fullvärdig'], ['BEGRANSAD', 'Begränsad'], ['GRUPP', 'Grupp'], ['GRUND', 'Grund'], ['UTOKAD', 'Utökad'], ['KLIENT', 'Klient']]),
          EnumSortValues: new Map([['FULLVARDIG', 'P'], ['BEGRANSAD', 'B'], ['GRUPP', 'G'], ['GRUND', 'W'], ['UTOKAD', 'U'], ['KLIENT', 'C']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FULLVARDIG=Fullvärdig;BEGRANSAD=Begränsad;GRUPP=Grupp;GRUND=Grund;UTOKAD=Utökad;KLIENT=Klient"',
          InterfaceType: 'ifChecklist',
        },
        MAXVERSION: {
          AttributeName: 'MAXVERSION',
          DisplayLabel: 'Max version',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Avenylicens'],
        },
        LICENSNYCKEL: {
          AttributeName: 'LICENSNYCKEL',
          DisplayLabel: 'Licensnyckel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 15,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Avenylicens'],
        },
        SENAST_UPPD_VERSION: {
          AttributeName: 'SENAST_UPPD_VERSION',
          DisplayLabel: 'Senast uppdaterade version',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Avenylicens'],
        },
        SENAST_UPPD_DATUM: {
          AttributeName: 'SENAST_UPPD_DATUM',
          DisplayLabel: 'Senast uppdaterad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Avenylicens'],
        },
        ANTAL_KLIENTER: {
          AttributeName: 'ANTAL_KLIENTER',
          DisplayLabel: 'Antal klienter',
          Hint: 'Används inte längre, kan tas bort efter v 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          ValidInComps: ['Paket'],
        },
        ANTAL_BEGRANSADE: {
          AttributeName: 'ANTAL_BEGRANSADE',
          DisplayLabel: 'Antal begränsade klienter',
          Hint: 'Används inte längre, kan tas bort efter v 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          ValidInComps: ['Paket'],
        },
        ANTAL_ANV: {
          AttributeName: 'ANTAL_ANV',
          DisplayLabel: 'Antal användare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['MenySparLicens'],
        },
        LEVERANTOR_ID: {
          AttributeName: 'LEVERANTOR_ID',
          DisplayLabel: 'LeverantörsID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['InkoptLicens'],
        },
        LEVFAKTURA_ID: {
          AttributeName: 'LEVFAKTURA_ID',
          DisplayLabel: 'Faktura ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['InkoptLicens'],
        },
        MAXANVANDARE: {
          AttributeName: 'MAXANVANDARE',
          DisplayLabel: 'Max antal användare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['InkoptLicens'],
        },
        LeverNamn: {
          AttributeName: 'LeverNamn',
          DisplayLabel: 'Leverantörsnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['InkoptLicens'],
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kund: {
          AssociationName: 'Kund',
          DisplayLabel: 'Kund',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'True']]),
        },
        Artikel: {
          AssociationName: 'Artikel',
          DisplayLabel: 'Artikel',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Artikel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Leverantor: {
          AssociationName: 'Leverantor',
          DisplayLabel: 'Leverantör',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRLeverantor',
          AssociatedComponentName: 'Leverantor',
          JoinAssociation: true,
          ValidInComps: ['InkoptLicens'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        LicensOrder: {
          AssociationName: 'LicensOrder',
          DisplayLabel: 'Licensens order',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRLicensorder',
          AssociatedComponentName: 'Licensorder',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Andrahandskund: {
          AssociationName: 'Andrahandskund',
          DisplayLabel: 'Andrahandskund',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRAndrahand',
          AssociatedComponentName: 'Andrahandskund',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    KRLicensorder: {
      CollectionName: 'KRLicensorder',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'Licensorder',
        Abstract: false,
        SOLabel: 'Licensorder',
        SOGLabel: 'Licensorder',
        SBLabel: 'Licensordern',
        SBGLabel: 'Licensordern',
        POLabel: 'Licensordrar',
        POGLabel: 'Licensordrar',
        PBLabel: 'Licensordrarna',
        PBGLabel: 'Licensordrarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Licensordern primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Licensordern versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Licensordern id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Licensordern fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OrderEnd: {
          AttributeName: 'OrderEnd',
          DisplayLabel: 'Orderns slutdatum',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Ordern: {
          AssociationName: 'Ordern',
          DisplayLabel: 'Order',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OFOrder',
          AssociatedComponentName: 'ORDER',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Orderrad: {
          AssociationName: 'Orderrad',
          DisplayLabel: 'Orderrad',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OFOrderrad',
          AssociatedComponentName: 'ORDERRAD',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    KRMedgivande: {
      CollectionName: 'KRMedgivande',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Medgivande',
        Abstract: false,
        SOLabel: 'Medgivande',
        SOGLabel: 'Medgivande',
        SBLabel: 'Medgivandet',
        SBGLabel: 'Medgivandet',
        POLabel: 'Medgivanden',
        POGLabel: 'Medgivanden',
        PBLabel: 'Medgivandena',
        PBGLabel: 'Medgivandena',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Medgivandet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Medgivandet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Medgivandet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Medgivandet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AUTOGIRO_VAG: {
          AttributeName: 'AUTOGIRO_VAG',
          DisplayLabel: 'Autogiro, skickas till',
          Hint: 'Bankgirot/PlusGirot',
          DataType: 'Enum',
          EnumValues: new Map([['BANKGIROT', 'Bankgirot'], ['PLUSGIROT', 'PlusGirot']]),
          EnumSortValues: new Map([['BANKGIROT', 'B'], ['PLUSGIROT', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BANKGIROT=Bankgirot;PLUSGIROT=PlusGirot"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        MEDDELANDEKOD: {
          AttributeName: 'MEDDELANDEKOD',
          DisplayLabel: 'Aviseringstyp',
          Hint: 'E-medgivande från Bankgirot/Nytt medgivande per blankett/Godkänn e-medgivande från Bankgirot/Avvisa e-medgivande från Bankgirot/Makulera medgivande/Byte av betalarkonto/Byte av betalarnummer/Nytt medgivande avvisat av Bankgirot/PlusGirot',
          DataType: 'Enum',
          EnumValues: new Map([['E_MEDGIVANDE_FRAN_BANKGIROT', 'E-medgivande från Bankgirot'], ['NYTT_MEDGIVANDE_PER_BLANKETT', 'Nytt medgivande per blankett'], ['GODKANN_E_MEDGIVANDE_FRAN_BANKGIROT', 'Godkänn e-medgivande från Bankgirot'], ['AVVISA_E_MEDGIVANDE_FRAN_BANKGIROT', 'Avvisa e-medgivande från Bankgirot'], ['MAKULERA_MEDGIVANDE', 'Makulera medgivande'], ['BYTE_AV_BETALARKONTO', 'Byte av betalarkonto'], ['BYTE_AV_BETALARNUMMER', 'Byte av betalarnummer'], ['NYTT_MEDGIVANDE_AVVISAT_AV_BANKGIROT_PLUSGIROT', 'Nytt medgivande avvisat av Bankgirot/PlusGirot']]),
          EnumSortValues: new Map([['E_MEDGIVANDE_FRAN_BANKGIROT', 'EM'], ['NYTT_MEDGIVANDE_PER_BLANKETT', 'NM'], ['GODKANN_E_MEDGIVANDE_FRAN_BANKGIROT', 'GE'], ['AVVISA_E_MEDGIVANDE_FRAN_BANKGIROT', 'AE'], ['MAKULERA_MEDGIVANDE', 'MM'], ['BYTE_AV_BETALARKONTO', 'BK'], ['BYTE_AV_BETALARNUMMER', 'BN'], ['NYTT_MEDGIVANDE_AVVISAT_AV_BANKGIROT_PLUSGIROT', 'AM']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="E_MEDGIVANDE_FRAN_BANKGIROT=E-medgivande från Bankgirot;NYTT_MEDGIVANDE_PER_BLANKETT=Nytt medgivande per blankett;GODKANN_E_MEDGIVANDE_FRAN_BANKGIROT=Godkänn e-medgivande från Bankgirot;AVVISA_E_MEDGIVANDE_FRAN_BANKGIROT=Avvisa e-medgivande från Bankgirot;MAKULERA_MEDGIVANDE=Makulera medgivande;BYTE_AV_BETALARKONTO=Byte av betalarkonto;BYTE_AV_BETALARNUMMER=Byte av betalarnummer;NYTT_MEDGIVANDE_AVVISAT_AV_BANKGIROT_PLUSGIROT=Nytt medgivande avvisat av Bankgirot/PlusGirot"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        SKAPAD_DATUM: {
          AttributeName: 'SKAPAD_DATUM',
          DisplayLabel: 'Skapad, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        SKICKAD_DATUM: {
          AttributeName: 'SKICKAD_DATUM',
          DisplayLabel: 'Skickad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        FELKOD: {
          AttributeName: 'FELKOD',
          DisplayLabel: 'Felkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifChecklist',
        },
        MAXBELOPP: {
          AttributeName: 'MAXBELOPP',
          DisplayLabel: 'Maxbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        AUTOGIRO_GILTIGT_FROM: {
          AttributeName: 'AUTOGIRO_GILTIGT_FROM',
          DisplayLabel: 'Autogiro, giltigt fr o m',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Kundnr: {
          AttributeName: 'Kundnr',
          DisplayLabel: 'Kundnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Namn: {
          AttributeName: 'Namn',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Clearingnr: {
          AttributeName: 'Clearingnr',
          DisplayLabel: 'Clearingnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Kontonr: {
          AttributeName: 'Kontonr',
          DisplayLabel: 'Kontonr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Autogirostatus: {
          AttributeName: 'Autogirostatus',
          DisplayLabel: 'Autogiro, status',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        OPOrgNrPersNr: {
          AttributeName: 'OPOrgNrPersNr',
          DisplayLabel: 'OPOrgNrPersNr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        OPTyp: {
          AttributeName: 'OPTyp',
          DisplayLabel: 'OPTyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        ForegClearingnr: {
          AttributeName: 'ForegClearingnr',
          DisplayLabel: 'ForegClearingnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ForegKontonr: {
          AttributeName: 'ForegKontonr',
          DisplayLabel: 'ForegKontonr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Betalarnr: {
          AttributeName: 'Betalarnr',
          DisplayLabel: 'Betalarnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        ForegBetalarnr: {
          AttributeName: 'ForegBetalarnr',
          DisplayLabel: 'Foreg betalarnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kund: {
          AssociationName: 'Kund',
          DisplayLabel: 'Kund',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'True']]),
        },
      },
    },
    KRMotpartskoder: {
      CollectionName: 'KRMotpartskoder',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'MotpartskoderSaml',
        Abstract: false,
        SOLabel: 'Motpartskod',
        SOGLabel: 'Motpartskods',
        SBLabel: 'Motpartskoden',
        SBGLabel: 'Motpartskodens',
        POLabel: 'Motpartskoder',
        POGLabel: 'Motpartskoders',
        PBLabel: 'Motpartskoderna',
        PBGLabel: 'Motpartskodernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Motpartskodens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Motpartskodens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Motpartskodens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'Id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOTPARTSKOD: {
          AttributeName: 'MOTPARTSKOD',
          DisplayLabel: 'Motpartskod',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    KRProgramOption: {
      CollectionName: 'KRProgramOption',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'ProgramOption',
        Abstract: false,
        SOLabel: 'Option',
        SOGLabel: 'Option',
        SBLabel: 'Optionen',
        SBGLabel: 'Optionen',
        POLabel: 'Optioner',
        POGLabel: 'Optioner',
        PBLabel: 'Optionerna',
        PBGLabel: 'Optionerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Optionen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Optionen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Optionen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Optionen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PROGRAMOPTION: {
          AttributeName: 'PROGRAMOPTION',
          DisplayLabel: 'Option',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    KRBetfilTransRelated: {
      CollectionName: 'KRBetfilTransRelated',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BetfilTransRelated',
        Abstract: false,
        SOLabel: 'Transaktion',
        SOGLabel: 'Transaktions',
        SBLabel: 'Transaktionen',
        SBGLabel: 'Transaktionens',
        POLabel: 'Transaktioner',
        POGLabel: 'Transaktioners',
        PBLabel: 'Transaktionerna',
        PBGLabel: 'Transaktionernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Transaktionens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Transaktionens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Transaktionens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NM: {
          AttributeName: 'NM',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        CTRY: {
          AttributeName: 'CTRY',
          DisplayLabel: 'Land',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STRTNM: {
          AttributeName: 'STRTNM',
          DisplayLabel: 'Gatunamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PSTCD: {
          AttributeName: 'PSTCD',
          DisplayLabel: 'Postnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TWNNM: {
          AttributeName: 'TWNNM',
          DisplayLabel: 'Ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IBAN: {
          AttributeName: 'IBAN',
          DisplayLabel: 'IBAN',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BIC: {
          AttributeName: 'BIC',
          DisplayLabel: 'BIC',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        OTHRID: {
          AttributeName: 'OTHRID',
          DisplayLabel: 'Other Id',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        CD: {
          AttributeName: 'CD',
          DisplayLabel: 'CD',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    KRBetfilTrans: {
      CollectionName: 'KRBetfilTrans',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BetfilTrans',
        Abstract: false,
        SOLabel: 'Transaktion',
        SOGLabel: 'Transaktions',
        SBLabel: 'Transaktionen',
        SBGLabel: 'Transaktionens',
        POLabel: 'Transaktioner',
        POGLabel: 'Transaktioners',
        PBLabel: 'Transaktionerna',
        PBGLabel: 'Transaktionernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Transaktionens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Transaktionens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Transaktionens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BGI_TRANSKOD: {
          AttributeName: 'BGI_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="20=Betalningspost;21=Avdragspost"',
        },
        BGI_AVSANDAR_BANKGIRONR: {
          AttributeName: 'BGI_AVSANDAR_BANKGIRONR',
          DisplayLabel: 'Avsändarbankgironummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 10,
        },
        BGI_REFERENS: {
          AttributeName: 'BGI_REFERENS',
          DisplayLabel: 'Referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 25,
        },
        BGI_BELOPP: {
          AttributeName: 'BGI_BELOPP',
          DisplayLabel: 'Betalningsbelopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 18,
        },
        BGI_REFERENSKOD: {
          AttributeName: 'BGI_REFERENSKOD',
          DisplayLabel: 'Referenskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="0=Referens ej angiven;1=Referens ej angiven (blankettbetalning);2=OCR-referens, korrekt enligt avtal om OCR-referenskontroll;3=Manuell referens;4=Korrekt referens (utökad blankettregistrering);5=Felaktig referens (utökad blankettregistrering);6=Okänd referenskod;7=Okänd referenskod;8=Okänd referenskod;9=Okänd referenskod"',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        BGI_KANALKOD: {
          AttributeName: 'BGI_KANALKOD',
          DisplayLabel: 'Betalningskanalkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        BGI_BGC_LOPNR: {
          AttributeName: 'BGI_BGC_LOPNR',
          DisplayLabel: 'BGC-löpnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 12,
        },
        BGI_AVBILDSMARKERING: {
          AttributeName: 'BGI_AVBILDSMARKERING',
          DisplayLabel: 'Avi-bild finns',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', '1'], ['NEJ', '0']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BGI_AVDRAGSKOD: {
          AttributeName: 'BGI_AVDRAGSKOD',
          DisplayLabel: 'Avdragskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        BGI_NAMN_TRANSKOD: {
          AttributeName: 'BGI_NAMN_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BGI_NAMN_NAMN: {
          AttributeName: 'BGI_NAMN_NAMN',
          DisplayLabel: 'Betalarens namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        BGI_NAMN_EXTRA: {
          AttributeName: 'BGI_NAMN_EXTRA',
          DisplayLabel: 'Extra namnfält',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        BGI_ADRESS_TRANSKOD: {
          AttributeName: 'BGI_ADRESS_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BGI_ADRESS_ADRESS: {
          AttributeName: 'BGI_ADRESS_ADRESS',
          DisplayLabel: 'Betalarens adress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        BGI_ADRESS_POSTNR: {
          AttributeName: 'BGI_ADRESS_POSTNR',
          DisplayLabel: 'Betalarens postnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 9,
          AttributeGroup: 'Betalarens Adress',
        },
        BGI_ADRESS2_TRANSKOD: {
          AttributeName: 'BGI_ADRESS2_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BGI_ADRESS2_ORTSADRESS: {
          AttributeName: 'BGI_ADRESS2_ORTSADRESS',
          DisplayLabel: 'Betalarens ortsadress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        BGI_ADRESS2_LAND: {
          AttributeName: 'BGI_ADRESS2_LAND',
          DisplayLabel: 'Betalarens land',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
          AttributeGroup: 'Betalarens Adress',
        },
        BGI_ADRESS2_LANDKOD: {
          AttributeName: 'BGI_ADRESS2_LANDKOD',
          DisplayLabel: 'Betalarens landkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 2,
        },
        BGI_ORGNR_TRANSKOD: {
          AttributeName: 'BGI_ORGNR_TRANSKOD',
          DisplayLabel: 'Transaktionskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BGI_ORGNR_ORGNR: {
          AttributeName: 'BGI_ORGNR_ORGNR',
          DisplayLabel: 'Betalarens organisationsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatOrgNr',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Betalarens Adress',
        },
        TI_POSTTYP: {
          AttributeName: 'TI_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="20=Betalningspost;25=Avdragspost"',
        },
        TI_KUNDREF: {
          AttributeName: 'TI_KUNDREF',
          DisplayLabel: 'Kundreferens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        TI_BELOPP: {
          AttributeName: 'TI_BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 15,
        },
        TI_TRANSLOPNR: {
          AttributeName: 'TI_TRANSLOPNR',
          DisplayLabel: 'Transaktionslöpnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 17,
        },
        TI_MOTTAGAR_BANKGIRONR: {
          AttributeName: 'TI_MOTTAGAR_BANKGIRONR',
          DisplayLabel: 'Bankgironummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        TI_AVDRAGSKOD: {
          AttributeName: 'TI_AVDRAGSKOD',
          DisplayLabel: 'Avdragskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        TI_NAMN_POSTTYP: {
          AttributeName: 'TI_NAMN_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TI_NAMN_NAMN1: {
          AttributeName: 'TI_NAMN_NAMN1',
          DisplayLabel: 'Namn 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        TI_NAMN_NAMN2: {
          AttributeName: 'TI_NAMN_NAMN2',
          DisplayLabel: 'Namn 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        TI_ADRESS_POSTTYP: {
          AttributeName: 'TI_ADRESS_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TI_ADRESS_ADRESS1: {
          AttributeName: 'TI_ADRESS_ADRESS1',
          DisplayLabel: 'Adress 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        TI_ADRESS_ADRESS2: {
          AttributeName: 'TI_ADRESS_ADRESS2',
          DisplayLabel: 'Adress 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        TI_POST_POSTTYP: {
          AttributeName: 'TI_POST_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TI_POST_POSTNR: {
          AttributeName: 'TI_POST_POSTNR',
          DisplayLabel: 'Postnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 9,
        },
        TI_POST_ORT: {
          AttributeName: 'TI_POST_ORT',
          DisplayLabel: 'Ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        TI_POST_LANDKOD: {
          AttributeName: 'TI_POST_LANDKOD',
          DisplayLabel: 'Landkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 2,
        },
        TI_KONTO_POSTTYP: {
          AttributeName: 'TI_KONTO_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TI_KONTO_BANKGIRONR: {
          AttributeName: 'TI_KONTO_BANKGIRONR',
          DisplayLabel: 'Bankgironummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 36,
        },
        TI_KONTO_URSPRUNGSKOD: {
          AttributeName: 'TI_KONTO_URSPRUNGSKOD',
          DisplayLabel: 'Ursprungskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        TI_KONTO_ORGNR: {
          AttributeName: 'TI_KONTO_ORGNR',
          DisplayLabel: 'Organisationsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        TI_NAMN2_POSTTYP: {
          AttributeName: 'TI_NAMN2_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TI_NAMN2_NAMN1: {
          AttributeName: 'TI_NAMN2_NAMN1',
          DisplayLabel: 'Namn 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        TI_NAMN2_NAMN2: {
          AttributeName: 'TI_NAMN2_NAMN2',
          DisplayLabel: 'Namn 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        TI_ADRESS2_POSTTYP: {
          AttributeName: 'TI_ADRESS2_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TI_ADRESS2_ADRESS1: {
          AttributeName: 'TI_ADRESS2_ADRESS1',
          DisplayLabel: 'Adress 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        TI_ADRESS2_ADRESS2: {
          AttributeName: 'TI_ADRESS2_ADRESS2',
          DisplayLabel: 'Adress 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        TI_POST2_POSTTYP: {
          AttributeName: 'TI_POST2_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TI_POST2_POSTNR: {
          AttributeName: 'TI_POST2_POSTNR',
          DisplayLabel: 'Postnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 9,
        },
        TI_POST2_ORT: {
          AttributeName: 'TI_POST2_ORT',
          DisplayLabel: 'Ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        TI_POST2_LANDKOD: {
          AttributeName: 'TI_POST2_LANDKOD',
          DisplayLabel: 'Landkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 2,
        },
        TI_UTLAND_POSTTYP: {
          AttributeName: 'TI_UTLAND_POSTTYP',
          DisplayLabel: 'Posttyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TI_UTLAND_KOSTNADER: {
          AttributeName: 'TI_UTLAND_KOSTNADER',
          DisplayLabel: 'Kostnader',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 15,
        },
        TI_UTLAND_VALUTAKOD: {
          AttributeName: 'TI_UTLAND_VALUTAKOD',
          DisplayLabel: 'Valutakod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 3,
        },
        TI_UTLAND_NORDEAKOSTNADER: {
          AttributeName: 'TI_UTLAND_NORDEAKOSTNADER',
          DisplayLabel: 'Kostnader, Nordea',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 15,
        },
        TI_UTLAND_NORDEAVALUTAKOD: {
          AttributeName: 'TI_UTLAND_NORDEAVALUTAKOD',
          DisplayLabel: 'Valutakod, Nordea',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 3,
        },
        TI_UTLAND_BELOPP: {
          AttributeName: 'TI_UTLAND_BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 15,
        },
        TI_UTLAND_BELOPPVALUTAKOD: {
          AttributeName: 'TI_UTLAND_BELOPPVALUTAKOD',
          DisplayLabel: 'Valutakod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 3,
        },
        TI_UTLAND_KURS: {
          AttributeName: 'TI_UTLAND_KURS',
          DisplayLabel: 'Växlingskurs',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 12,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Betalning/Avdrag',
          DataType: 'Enum',
          EnumValues: new Map([['BETALNING', 'Betalning'], ['AVDRAG', 'Avdrag']]),
          EnumSortValues: new Map([['BETALNING', 'B'], ['AVDRAG', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BETALNING=Betalning;AVDRAG=Avdrag"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FakturaOCR: {
          AttributeName: 'FakturaOCR',
          DisplayLabel: 'Betalningsreferens',
          Hint: 'Betalningsmottagarens referens, ex Faktura/OCR',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Belopp: {
          AttributeName: 'Belopp',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        xStatus: {
          AttributeName: 'xStatus',
          DisplayLabel: 'Status',
          Hint: 'Ska bort - Ny/Manuell/Automatisk',
          DataType: 'Enum',
          EnumValues: new Map([['NY', 'Ny'], ['MANUELL', 'Manuell'], ['AUTOMATISK', 'Automatisk']]),
          EnumSortValues: new Map([['NY', 'N'], ['MANUELL', 'M'], ['AUTOMATISK', 'A']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NY=Ny;MANUELL=Manuell;AUTOMATISK=Automatisk"',
        },
        xAvp: {
          AttributeName: 'xAvp',
          DisplayLabel: 'Avp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
        },
        Namn: {
          AttributeName: 'Namn',
          DisplayLabel: 'Betalarens namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Adress: {
          AttributeName: 'Adress',
          DisplayLabel: 'Betalarens postadress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Betalarens Adress',
        },
        PostNr: {
          AttributeName: 'PostNr',
          DisplayLabel: 'Betalarens postnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatPostNr',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Betalarens Adress',
        },
        Ort: {
          AttributeName: 'Ort',
          DisplayLabel: 'Betalarens ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Betalarens Adress',
        },
        Landkod: {
          AttributeName: 'Landkod',
          DisplayLabel: 'Betalarens landkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Betalarens Adress',
        },
        AvsBankgiroNr: {
          AttributeName: 'AvsBankgiroNr',
          DisplayLabel: 'Betalarens bankgironummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.equals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Betalningskanal: {
          AttributeName: 'Betalningskanal',
          DisplayLabel: 'Betalningskanal',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="1=Bank;2=Levbet;3=Blankett;4=Autogiro;5=Okänd;6=Okänd;7=Okänd;8=Okänd;9=Okänd"',
          InterfaceType: 'ifChecklist',
        },
        ExtraReferensNummer: {
          AttributeName: 'ExtraReferensNummer',
          DisplayLabel: 'Extra referensnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        UTSKRIVEN: {
          AttributeName: 'UTSKRIVEN',
          DisplayLabel: 'Utskriven',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
        },
        Namn_Extra: {
          AttributeName: 'Namn_Extra',
          DisplayLabel: 'Betalarens extra namnfält',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Betalarens Adress',
        },
        PostAdress: {
          AttributeName: 'PostAdress',
          DisplayLabel: 'Betalarens postadress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Betalarens Adress',
        },
        HAR_AVDRAGSPOST: {
          AttributeName: 'HAR_AVDRAGSPOST',
          DisplayLabel: 'Har avdragspost',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
        },
        FakturaNr: {
          AttributeName: 'FakturaNr',
          DisplayLabel: 'Fakturanummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Betalningskanal2: {
          AttributeName: 'Betalningskanal2',
          DisplayLabel: 'Betalningskanal',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        KORRIGERAD_BETREF: {
          AttributeName: 'KORRIGERAD_BETREF',
          DisplayLabel: 'Betalningsreferens',
          Hint: 'Betalningsmottagarens referens, ex Faktura/OCR',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        ChangedFakturaOCR: {
          AttributeName: 'ChangedFakturaOCR',
          DisplayLabel: 'Betalningsreferens',
          Hint: 'Betalningsmottagarens referens, ex Faktura/OCR',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ChangedFakturaOCRRapport: {
          AttributeName: 'ChangedFakturaOCRRapport',
          DisplayLabel: 'Betalningsreferens',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ISO_NTRYREF: {
          AttributeName: 'ISO_NTRYREF',
          DisplayLabel: 'NtryRef',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_AMT: {
          AttributeName: 'ISO_AMT',
          DisplayLabel: 'Amt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_CDTDBTIND: {
          AttributeName: 'ISO_CDTDBTIND',
          DisplayLabel: 'CdtDbtInd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_STS: {
          AttributeName: 'ISO_STS',
          DisplayLabel: 'Sts',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_BOOKGDT: {
          AttributeName: 'ISO_BOOKGDT',
          DisplayLabel: 'BookgDt_Dt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_VALDT: {
          AttributeName: 'ISO_VALDT',
          DisplayLabel: 'ValDt_Dt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_BKTXCD_DOMN_CD: {
          AttributeName: 'ISO_BKTXCD_DOMN_CD',
          DisplayLabel: 'Ntry_BkTxCd_Domn_Cd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_BKTXCD_FMLY_CD: {
          AttributeName: 'ISO_BKTXCD_FMLY_CD',
          DisplayLabel: 'Ntry_BkTxCd_Domn_Fmly_Cd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_BKTXCD_FMLY_SUBFMLYCD: {
          AttributeName: 'ISO_BKTXCD_FMLY_SUBFMLYCD',
          DisplayLabel: 'Ntry_BkTxCd_Domn_Fmly_SubFmlyCd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_REFS_MSGID: {
          AttributeName: 'ISO_DETAILS_REFS_MSGID',
          DisplayLabel: 'NtryDtls_TxDtls_Refs_MsgId',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_REFS_PMTINFID: {
          AttributeName: 'ISO_DETAILS_REFS_PMTINFID',
          DisplayLabel: 'NtryDtls_TxDtls_Refs_PmtInfId',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_REFS_INSTRID: {
          AttributeName: 'ISO_DETAILS_REFS_INSTRID',
          DisplayLabel: 'NtryDtls_TxDtls_Refs_InstId',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_REFS_ENDTOENDID: {
          AttributeName: 'ISO_DETAILS_REFS_ENDTOENDID',
          DisplayLabel: 'NtryDtls_TxDtls_Refs_EndToEndId',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_REFS_ACCTSVCRREF: {
          AttributeName: 'ISO_DETAILS_REFS_ACCTSVCRREF',
          DisplayLabel: 'NtryDtls_TxDtls_Refs_AcctSvcrRef',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_REFS_TXID: {
          AttributeName: 'ISO_DETAILS_REFS_TXID',
          DisplayLabel: 'NtryDtls_TxDtls_Refs_TxId',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_AMTDTLS_INSTDAMT_AMT: {
          AttributeName: 'ISO_DETAILS_AMTDTLS_INSTDAMT_AMT',
          DisplayLabel: 'NtryDtls_TxDtls_AmtDtls_InstdAmt_Amt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_AMTDTLS_TXAMT_AMT: {
          AttributeName: 'ISO_DETAILS_AMTDTLS_TXAMT_AMT',
          DisplayLabel: 'NtryDtls_TxDtls_AmtDtls_TxAmt_Amt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_RMTINF_CDTRREFINF_CD: {
          AttributeName: 'ISO_DETAILS_RMTINF_CDTRREFINF_CD',
          DisplayLabel: 'NtryDtls_TxDtls_RmtInf_Strd_CdtrRefInf_Tp_CdOrPrtry_Cd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_RMTINF_CDTRREFINF_ISSR: {
          AttributeName: 'ISO_DETAILS_RMTINF_CDTRREFINF_ISSR',
          DisplayLabel: 'NtryDtls_TxDtls_RmtInf_Strd_CdtrRefInf_Tp_Issr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_RMTINF_CDTRREFINF_REF: {
          AttributeName: 'ISO_DETAILS_RMTINF_CDTRREFINF_REF',
          DisplayLabel: 'NtryDtls_TxDtls_RmtInf_Strd_CdtrRefInf_Ref',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_RMTINF_RFRDDOCINF_CD: {
          AttributeName: 'ISO_DETAILS_RMTINF_RFRDDOCINF_CD',
          DisplayLabel: 'NtryDtls_TxDtls_RmtInf_Strd_RfrdDocInf_Tp_CdOrPrtry_Cd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_RMTINF_RFRDDOCINF_NB: {
          AttributeName: 'ISO_DETAILS_RMTINF_RFRDDOCINF_NB',
          DisplayLabel: 'NtryDtls_TxDtls_RmtInf_Strd_RfrdDocInf_Nb',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_RMTINF_RFRDDOCAMT: {
          AttributeName: 'ISO_DETAILS_RMTINF_RFRDDOCAMT',
          DisplayLabel: 'NtryDtls_TxDtls_RmtInf_Strd_RfrdDocAmt_RmtdAmt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_RMTINF_CDTNOTEAMT: {
          AttributeName: 'ISO_DETAILS_RMTINF_CDTNOTEAMT',
          DisplayLabel: 'NtryDtls_TxDtls_RmtInf_Strd_RfrdDocAmt_CdtNoteAmt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_AMTDTLS_TXAMT_SRCCCY: {
          AttributeName: 'ISO_DETAILS_AMTDTLS_TXAMT_SRCCCY',
          DisplayLabel: 'NtryDtls_TxDtls_AmtDtls_TxAmt_CcyXchg_SrcCcy',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_AMTDTLS_TXAMT_TRGTCCY: {
          AttributeName: 'ISO_DETAILS_AMTDTLS_TXAMT_TRGTCCY',
          DisplayLabel: 'NtryDtls_TxDtls_AmtDtls_TxAmt_CcyXchg_TrgtCcy',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_AMTDTLS_TXAMT_XCHGRATE: {
          AttributeName: 'ISO_DETAILS_AMTDTLS_TXAMT_XCHGRATE',
          DisplayLabel: 'NtryDtls_TxDtls_AmtDtls_TxAmt_CcyXchg_XchgRate',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_RMTINF_USTRD: {
          AttributeName: 'ISO_DETAILS_RMTINF_USTRD',
          DisplayLabel: 'NtryDtls_TxDtls_RmtInf_UStrd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_DETAILS_CDTR_ID: {
          AttributeName: 'ISO_DETAILS_CDTR_ID',
          DisplayLabel: 'Related creditor id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        ISO_DETAILS_DBTR_ID: {
          AttributeName: 'ISO_DETAILS_DBTR_ID',
          DisplayLabel: 'Related debtor id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        ISO_DETAILS_CDTRACCT_ID: {
          AttributeName: 'ISO_DETAILS_CDTRACCT_ID',
          DisplayLabel: 'Related creditoraccount id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        ISO_DETAILS_DBTRACCT_ID: {
          AttributeName: 'ISO_DETAILS_DBTRACCT_ID',
          DisplayLabel: 'Related debtoraccount id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        ISO_DETAILS_ULTMTCDTR_ID: {
          AttributeName: 'ISO_DETAILS_ULTMTCDTR_ID',
          DisplayLabel: 'Related ultimate creditor id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        ISO_DETAILS_ULTMTDBTR_ID: {
          AttributeName: 'ISO_DETAILS_ULTMTDBTR_ID',
          DisplayLabel: 'Related ultimate debtor id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        ISO_DETAILS_CDTRAGT_ID: {
          AttributeName: 'ISO_DETAILS_CDTRAGT_ID',
          DisplayLabel: 'Related creditor agent id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        ISO_DETAILS_DBTRAGT_ID: {
          AttributeName: 'ISO_DETAILS_DBTRAGT_ID',
          DisplayLabel: 'Related debtor agent id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Transaktionsbilder: {
          AssociationName: 'Transaktionsbilder',
          DisplayLabel: 'Transaktionsbilder',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRBetfilTransBild',
          AssociatedComponentName: 'BetfilTransBild',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Avsnitt: {
          AssociationName: 'Avsnitt',
          DisplayLabel: 'Avsnitt',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRBetfilAvsnitt',
          AssociatedComponentName: 'BetfilAvsnitt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Creditor: {
          AssociationName: 'Creditor',
          DisplayLabel: 'Creditor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRBetfilTransRelated',
          AssociatedComponentName: 'BetfilTransRelated',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Debtor: {
          AssociationName: 'Debtor',
          DisplayLabel: 'Debtor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRBetfilTransRelated',
          AssociatedComponentName: 'BetfilTransRelated',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        CreditorAccount: {
          AssociationName: 'CreditorAccount',
          DisplayLabel: 'Creditor account',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRBetfilTransRelated',
          AssociatedComponentName: 'BetfilTransRelated',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        DebtorAccount: {
          AssociationName: 'DebtorAccount',
          DisplayLabel: 'Debtor account',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRBetfilTransRelated',
          AssociatedComponentName: 'BetfilTransRelated',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        UltimateCreditor: {
          AssociationName: 'UltimateCreditor',
          DisplayLabel: 'Ultimate creditor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRBetfilTransRelated',
          AssociatedComponentName: 'BetfilTransRelated',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        UltimateDebtor: {
          AssociationName: 'UltimateDebtor',
          DisplayLabel: 'Ultimate debtor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRBetfilTransRelated',
          AssociatedComponentName: 'BetfilTransRelated',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        CreditorAgent: {
          AssociationName: 'CreditorAgent',
          DisplayLabel: 'Creditor agent',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRBetfilTransRelated',
          AssociatedComponentName: 'BetfilTransRelated',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        DebtorAgent: {
          AssociationName: 'DebtorAgent',
          DisplayLabel: 'Debtor agent',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRBetfilTransRelated',
          AssociatedComponentName: 'BetfilTransRelated',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Referenser: {
          AssociationName: 'Referenser',
          DisplayLabel: 'Extra referenser',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRBetfilExtraRef',
          AssociatedComponentName: 'BetfilExtraRef',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Informationsposter: {
          AssociationName: 'Informationsposter',
          DisplayLabel: 'Informationsposter',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRBetfilInfo',
          AssociatedComponentName: 'BetfilInfo',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        VerTrans: {
          AssociationName: 'VerTrans',
          DisplayLabel: 'Verifikationer',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRBokfverTrans',
          AssociatedComponentName: 'BokfverTrans',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    KRBetfilTransBild: {
      CollectionName: 'KRBetfilTransBild',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BetfilTransBild',
        Abstract: false,
        SOLabel: 'Transaktionsbild',
        SOGLabel: 'Transaktionsbilds',
        SBLabel: 'Transaktionsbilden',
        SBGLabel: 'Transaktionsbildens',
        POLabel: 'Transaktionsbilder',
        POGLabel: 'Transaktionsbilders',
        PBLabel: 'Transaktionsbilderna',
        PBGLabel: 'Transaktionsbildernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Transaktionsbildens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Transaktionsbildens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Transaktionsbildens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILD: {
          AttributeName: 'BILD',
          DisplayLabel: 'Bild',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    KRBokfverTrans: {
      CollectionName: 'KRBokfverTrans',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BokfverTrans',
        Abstract: false,
        SOLabel: 'Verifikations Transaktioner',
        SOGLabel: 'Verifikations Transaktioner',
        SBLabel: 'Verifikationens Transaktioner',
        SBGLabel: 'Verifikationens Transaktioner',
        POLabel: 'Verifikationers Transaktioner',
        POGLabel: 'Verifikationers Transaktioner',
        PBLabel: 'Verifikationernas Transaktioner',
        PBGLabel: 'Verifikationernas Transaktioner',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Verifikationens Transaktioner primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Verifikationens Transaktioner versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Verifikationens Transaktioner id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Verifikationens Transaktioner fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TRANS_BETFIL_ID: {
          AttributeName: 'TRANS_BETFIL_ID',
          DisplayLabel: 'Id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TRANS_AVSNITT_LOPNR: {
          AttributeName: 'TRANS_AVSNITT_LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TRANS_LOPNR: {
          AttributeName: 'TRANS_LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VER_BOKF_AR: {
          AttributeName: 'VER_BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
        },
        VER_VER_NR: {
          AttributeName: 'VER_VER_NR',
          DisplayLabel: 'Verifikationsnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EXTRAREF_LOPNR: {
          AttributeName: 'EXTRAREF_LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        SIGN: {
          AttributeName: 'SIGN',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 30,
        },
        ANTECKNING: {
          AttributeName: 'ANTECKNING',
          DisplayLabel: 'Anteckningar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Verifikation: {
          AssociationName: 'Verifikation',
          DisplayLabel: 'Verifikation',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKBokfver',
          AssociatedComponentName: 'Bokfver',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
          Required: true,
        },
        Transaktion: {
          AssociationName: 'Transaktion',
          DisplayLabel: 'Transaktion',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRBetfilTrans',
          AssociatedComponentName: 'BetfilTrans',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    KRAterrapKundfakt: {
      CollectionName: 'KRAterrapKundfakt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AterrapKundfakt',
        Abstract: false,
        SOLabel: 'Återredovisningsavsnitt',
        SOGLabel: 'Återredovisningsavsnitts',
        SBLabel: 'Återredovisningsavsnittet',
        SBGLabel: 'Återredovisningsavsnittets',
        POLabel: 'Återredovisningsavsnitt',
        POGLabel: 'Återredovisningsavsnitts',
        PBLabel: 'Återredovisningsavsnitten',
        PBGLabel: 'Återredovisningsavsnittens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Återredovisningsavsnittets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Återredovisningsavsnittets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Återredovisningsavsnittets id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        START_POSTTYP: {
          AttributeName: 'START_POSTTYP',
          DisplayLabel: 'Posttyp',
          Hint: 'Startpost',
          DataType: 'Enum',
          EnumValues: new Map([['STARTPOST', 'Startpost']]),
          EnumSortValues: new Map([['STARTPOST', '01']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="STARTPOST=Startpost"',
        },
        START_PROD_DATUM: {
          AttributeName: 'START_PROD_DATUM',
          DisplayLabel: 'Produktionsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        START_PROD_NR: {
          AttributeName: 'START_PROD_NR',
          DisplayLabel: 'Produktionsnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        START_FORSYSTEM: {
          AttributeName: 'START_FORSYSTEM',
          DisplayLabel: 'Försystem',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FIL_ID: {
          AttributeName: 'FIL_ID',
          DisplayLabel: 'Id, fil',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SLUT_POSTTYP: {
          AttributeName: 'SLUT_POSTTYP',
          DisplayLabel: 'Posttyp',
          Hint: 'Slutpost',
          DataType: 'Enum',
          EnumValues: new Map([['SLUTPOST', 'Slutpost']]),
          EnumSortValues: new Map([['SLUTPOST', '99']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SLUTPOST=Slutpost"',
        },
        SLUT_PROD_DATUM: {
          AttributeName: 'SLUT_PROD_DATUM',
          DisplayLabel: 'Produktionsdatum',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SLUT_PROD_NR: {
          AttributeName: 'SLUT_PROD_NR',
          DisplayLabel: 'Produktionsnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SLUT_FORSYSTEM: {
          AttributeName: 'SLUT_FORSYSTEM',
          DisplayLabel: 'Försystem',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SLUT_ANTAL_FAKT: {
          AttributeName: 'SLUT_ANTAL_FAKT',
          DisplayLabel: 'Antal fakturor',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Proddatum: {
          AttributeName: 'Proddatum',
          DisplayLabel: 'Produktionsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AntalTransaktioner: {
          AttributeName: 'AntalTransaktioner',
          DisplayLabel: 'Antal poster',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        HANTERAD: {
          AttributeName: 'HANTERAD',
          DisplayLabel: 'Hanterad',
          Hint: 'Hanterad/Ej hanterad/Fel vid hantering',
          DataType: 'Enum',
          EnumValues: new Map([['HANTERAD', 'Hanterad'], ['EJ_HANTERAD', 'Ej hanterad'], ['FEL_VID_HANTERING', 'Fel vid hantering']]),
          EnumSortValues: new Map([['HANTERAD', 'Y'], ['EJ_HANTERAD', 'N'], ['FEL_VID_HANTERING', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="HANTERAD=Hanterad;EJ_HANTERAD=Ej hanterad;FEL_VID_HANTERING=Fel vid hantering"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        HANTERAD_DATUM: {
          AttributeName: 'HANTERAD_DATUM',
          DisplayLabel: 'Hanterad, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        HANTERAD_SIGN: {
          AttributeName: 'HANTERAD_SIGN',
          DisplayLabel: 'Hanterad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Hanterad_Text: {
          AttributeName: 'Hanterad_Text',
          DisplayLabel: 'Hanterad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        LOPNR_PER_AR: {
          AttributeName: 'LOPNR_PER_AR',
          DisplayLabel: 'Löpnummer per år',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kommunikationsfil: {
          AssociationName: 'Kommunikationsfil',
          DisplayLabel: 'Kommunikationsfil',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSKommunikationsfil',
          AssociatedComponentName: 'Kommunikationsfil',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Transaktioner: {
          AssociationName: 'Transaktioner',
          DisplayLabel: 'Återredovisningsrader',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRAterrapKundfaktPost',
          AssociatedComponentName: 'AterrapKundfaktPost',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    KRAterrappBokfver: {
      CollectionName: 'KRAterrappBokfver',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AterrappBokfver',
        Abstract: false,
        SOLabel: 'Återredovisningsrad, verifikationsref',
        SOGLabel: 'Återredovisningsrad, verifikationsref',
        SBLabel: 'Återredovisningsrad, verifikationsref',
        SBGLabel: 'Återredovisningsrad, verifikationsref',
        POLabel: 'Återredovisningsrad, verifikationsref',
        POGLabel: 'Återredovisningsrad, verifikationsref',
        PBLabel: 'Återredovisningsrad, verifikationsref',
        PBGLabel: 'Återredovisningsrad, verifikationsref',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Återredovisningsrad, verifikationsref primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Återredovisningsrad, verifikationsref versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Återredovisningsrad, verifikationsref fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATERRAPFIL_ID: {
          AttributeName: 'ATERRAPFIL_ID',
          DisplayLabel: 'Återrapp fil, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATERRAPP_LOPNR: {
          AttributeName: 'ATERRAPP_LOPNR',
          DisplayLabel: 'Återrapporteringspost, löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VER_NR: {
          AttributeName: 'VER_NR',
          DisplayLabel: 'Vernr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SIGN: {
          AttributeName: 'SIGN',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    KRAterrapKundfaktPost: {
      CollectionName: 'KRAterrapKundfaktPost',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AterrapKundfaktPost',
        Abstract: false,
        SOLabel: 'Återredovisningsrad',
        SOGLabel: 'Återredovisningsrads',
        SBLabel: 'Återredovisningsraden',
        SBGLabel: 'Återredovisningsradens',
        POLabel: 'Återredovisningsrader',
        POGLabel: 'Återredovisningsraders',
        PBLabel: 'Återredovisningsraderna',
        PBGLabel: 'Återredovisningsradernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Återredovisningsradens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Återredovisningsradens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Återredovisningsradens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        POSTTYP: {
          AttributeName: 'POSTTYP',
          DisplayLabel: 'Posttyp',
          Hint: 'Fakturapost/Kvittopost',
          DataType: 'Enum',
          EnumValues: new Map([['FAKTURAPOST', 'Fakturapost'], ['KVITTOPOST', 'Kvittopost']]),
          EnumSortValues: new Map([['FAKTURAPOST', '10'], ['KVITTOPOST', '15']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAKTURAPOST=Fakturapost;KVITTOPOST=Kvittopost"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        FORETAG: {
          AttributeName: 'FORETAG',
          DisplayLabel: 'Företag',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 25,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BOLAG_NR: {
          AttributeName: 'BOLAG_NR',
          DisplayLabel: 'Förvaltningsnr/Bolagsnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FAKTURA_NR: {
          AttributeName: 'FAKTURA_NR',
          DisplayLabel: 'Fakturanr i Agresso',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FAKTURADATUM: {
          AttributeName: 'FAKTURADATUM',
          DisplayLabel: 'Fakturadatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        FORFALLODATUM: {
          AttributeName: 'FORFALLODATUM',
          DisplayLabel: 'Förfallodatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        BETALDATUM: {
          AttributeName: 'BETALDATUM',
          DisplayLabel: 'Betaldatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 8,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Fakturans status',
          Hint: 'Normal/Parkerad/Faktura finns på remitteringsförslag/Fakturan finns på betalningsuppdrag/Spärrad/Obetald faktura har reverserats/Fakturan finns på påminnelseförslag',
          DataType: 'Enum',
          EnumValues: new Map([['NORMAL', 'Normal'], ['PARKERAD', 'Parkerad'], ['FAKTURA_FINNS_PA_REMITTERINGSFORSLAG', 'Faktura finns på remitteringsförslag'], ['FAKTURAN_FINNS_PA_BETALNINGSUPPDRAG', 'Fakturan finns på betalningsuppdrag'], ['SPARRAD', 'Spärrad'], ['OBETALD_FAKTURA_HAR_REVERSERATS', 'Obetald faktura har reverserats'], ['FAKTURAN_FINNS_PA_PAMINNELSEFORSLAG', 'Fakturan finns på påminnelseförslag']]),
          EnumSortValues: new Map([['NORMAL', 'N'], ['PARKERAD', 'P'], ['FAKTURA_FINNS_PA_REMITTERINGSFORSLAG', 'R'], ['FAKTURAN_FINNS_PA_BETALNINGSUPPDRAG', 'I'], ['SPARRAD', 'C'], ['OBETALD_FAKTURA_HAR_REVERSERATS', 'H'], ['FAKTURAN_FINNS_PA_PAMINNELSEFORSLAG', 'L']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NORMAL=Normal;PARKERAD=Parkerad;FAKTURA_FINNS_PA_REMITTERINGSFORSLAG=Faktura finns på remitteringsförslag;FAKTURAN_FINNS_PA_BETALNINGSUPPDRAG=Fakturan finns på betalningsuppdrag;SPARRAD=Spärrad;OBETALD_FAKTURA_HAR_REVERSERATS=Obetald faktura har reverserats;FAKTURAN_FINNS_PA_PAMINNELSEFORSLAG=Fakturan finns på påminnelseförslag"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANSTANDSDATUM: {
          AttributeName: 'ANSTANDSDATUM',
          DisplayLabel: 'Anståndsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        REKLAMATIONSKOD: {
          AttributeName: 'REKLAMATIONSKOD',
          DisplayLabel: 'Reklamationskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 25,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BETMOTTAGARE: {
          AttributeName: 'BETMOTTAGARE',
          DisplayLabel: 'Betmottagare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 25,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        REFERENS: {
          AttributeName: 'REFERENS',
          DisplayLabel: 'Referensnr i Aveny',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERIOD: {
          AttributeName: 'PERIOD',
          DisplayLabel: 'Period',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VERTYP: {
          AttributeName: 'VERTYP',
          DisplayLabel: 'Verifikationstyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 25,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VERNR: {
          AttributeName: 'VERNR',
          DisplayLabel: 'Verifikationsnr i Agresso',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORDERNR: {
          AttributeName: 'ORDERNR',
          DisplayLabel: 'Ordernr i Agreso',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        RANTESTATUS: {
          AttributeName: 'RANTESTATUS',
          DisplayLabel: 'Räntestatus',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PAMINNELSENIVA: {
          AttributeName: 'PAMINNELSENIVA',
          DisplayLabel: 'Påminnelsenivå',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PAMINNELSEDATUM: {
          AttributeName: 'PAMINNELSEDATUM',
          DisplayLabel: 'Påminnelsedatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KUNDNR: {
          AttributeName: 'KUNDNR',
          DisplayLabel: 'Kundnr i Agresso',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 25,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        URSPR_FAKTBELOPP: {
          AttributeName: 'URSPR_FAKTBELOPP',
          DisplayLabel: 'Inläst - Ursprungligt fakturabelopp/Kvitteringsbelopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 30,
        },
        VALUTAKOD: {
          AttributeName: 'VALUTAKOD',
          DisplayLabel: 'Valutakod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 25,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FAKT_RESTBELOPP: {
          AttributeName: 'FAKT_RESTBELOPP',
          DisplayLabel: 'Inläst - Fakturans restbelopp/Kvitteringsbelopp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 30,
        },
        BET_MARKERING: {
          AttributeName: 'BET_MARKERING',
          DisplayLabel: 'Betalningsmarkering',
          Hint: 'Inbetalning manuell/Reversering kundreskontra/Delmakulerad faktura/Bortbokat erbjudande/Faktura KundUtbetalningar/Faktura integrerad LOIS Kreditavi/Faktura integrerad LOIS Kreditfaktura/Inbetalning Autogiro/Inbetalning från fellista/Inbetalning inkasso (manuell)/Nollställning internfakturor/kundreskontran/Återredovisat inkasso/Inbetalning Total IN/Manuell kvittering kundfaktura/Manuell inbetalning / avräkning autogiro (CP04)/Kundförlust/Faktura div.deb Enhet 1',
          DataType: 'Enum',
          EnumValues: new Map([['INBETALNING_MANUELL', 'Inbetalning manuell'], ['REVERSERING_KUNDRESKONTRA', 'Reversering kundreskontra'], ['DELMAKULERAD_FAKTURA', 'Delmakulerad faktura'], ['BORTBOKAT_ERBJUDANDE', 'Bortbokat erbjudande'], ['FAKTURA_INTEGRERAD_LOIS_KREDITFAKTURA', 'Faktura integrerad LOIS Kreditfaktura'], ['INBETALNING_AUTOGIRO', 'Inbetalning Autogiro'], ['INBETALNING_FRAN_FELLISTA', 'Inbetalning från fellista'], ['INBETALNING_INKASSO__MANUELL_', 'Inbetalning inkasso (manuell)'], ['NOLLSTALLNING_INTERNFAKTUROR_KUNDRESKONTRAN', 'Nollställning internfakturor/kundreskontran'], ['ATERREDOVISAT_INKASSO', 'Återredovisat inkasso'], ['INBETALNING_TOTAL_IN', 'Inbetalning Total IN'], ['MANUELL_KVITTERING_KUNDFAKTURA', 'Manuell kvittering kundfaktura'], ['MANUELL_INBETALNING___AVRAKNING_AUTOGIRO__CP04_', 'Manuell inbetalning / avräkning autogiro (CP04)'], ['KUNDFORLUST', 'Kundförlust'], ['FAKTURA_DIV_DEB_ENHET_1', 'Faktura div.deb Enhet 1']]),
          EnumSortValues: new Map([['INBETALNING_MANUELL', 'IM'], ['REVERSERING_KUNDRESKONTRA', 'KR'], ['DELMAKULERAD_FAKTURA', 'KQ'], ['BORTBOKAT_ERBJUDANDE', 'G3'], ['FAKTURA_INTEGRERAD_LOIS_KREDITFAKTURA', 'EN'], ['INBETALNING_AUTOGIRO', 'IA'], ['INBETALNING_FRAN_FELLISTA', 'IF'], ['INBETALNING_INKASSO__MANUELL_', 'II'], ['NOLLSTALLNING_INTERNFAKTUROR_KUNDRESKONTRAN', 'IJ'], ['ATERREDOVISAT_INKASSO', 'IK'], ['INBETALNING_TOTAL_IN', 'IN'], ['MANUELL_KVITTERING_KUNDFAKTURA', 'IQ'], ['MANUELL_INBETALNING___AVRAKNING_AUTOGIRO__CP04_', 'IV'], ['KUNDFORLUST', 'KF'], ['FAKTURA_DIV_DEB_ENHET_1', 'D1']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INBETALNING_MANUELL=Inbetalning manuell;REVERSERING_KUNDRESKONTRA=Reversering kundreskontra;DELMAKULERAD_FAKTURA=Delmakulerad faktura;BORTBOKAT_ERBJUDANDE=Bortbokat erbjudande;FAKTURA_INTEGRERAD_LOIS_KREDITFAKTURA=Faktura integrerad LOIS Kreditfaktura;INBETALNING_AUTOGIRO=Inbetalning Autogiro;INBETALNING_FRAN_FELLISTA=Inbetalning från fellista;INBETALNING_INKASSO__MANUELL_=Inbetalning inkasso (manuell);NOLLSTALLNING_INTERNFAKTUROR_KUNDRESKONTRAN=Nollställning internfakturor/kundreskontran;ATERREDOVISAT_INKASSO=Återredovisat inkasso;INBETALNING_TOTAL_IN=Inbetalning Total IN;MANUELL_KVITTERING_KUNDFAKTURA=Manuell kvittering kundfaktura;MANUELL_INBETALNING___AVRAKNING_AUTOGIRO__CP04_=Manuell inbetalning / avräkning autogiro (CP04);KUNDFORLUST=Kundförlust;FAKTURA_DIV_DEB_ENHET_1=Faktura div.deb Enhet 1"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BET_MARKERING_TEXT: {
          AttributeName: 'BET_MARKERING_TEXT',
          DisplayLabel: 'Betalningsmarkering i klartext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KUNDNAMN: {
          AttributeName: 'KUNDNAMN',
          DisplayLabel: 'Kundnamn i Agresso',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORG_NR: {
          AttributeName: 'ORG_NR',
          DisplayLabel: 'Orgnr/Personnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 25,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SOKNAMN: {
          AttributeName: 'SOKNAMN',
          DisplayLabel: 'Söknamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KRAVSTATUS: {
          AttributeName: 'KRAVSTATUS',
          DisplayLabel: 'Kravstatus',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FORSK_AMOUNT: {
          AttributeName: 'FORSK_AMOUNT',
          DisplayLabel: 'Forsk_amount',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        CURR_FAKT_RESTBELOPP: {
          AttributeName: 'CURR_FAKT_RESTBELOPP',
          DisplayLabel: 'Restbelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        CURR_URSPR_FAKTBELOPP: {
          AttributeName: 'CURR_URSPR_FAKTBELOPP',
          DisplayLabel: 'Fakturabelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        Date_Betaldatum: {
          AttributeName: 'Date_Betaldatum',
          DisplayLabel: 'Kvittodatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        HANTERAD: {
          AttributeName: 'HANTERAD',
          DisplayLabel: 'Hanterad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Date_Fakturadatum: {
          AttributeName: 'Date_Fakturadatum',
          DisplayLabel: 'Fakturadatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        Date_Forfallodatum: {
          AttributeName: 'Date_Forfallodatum',
          DisplayLabel: 'Förfallodatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue],
        },
        CURR_KVITTERINGSBELOPP: {
          AttributeName: 'CURR_KVITTERINGSBELOPP',
          DisplayLabel: 'Kvitteringsbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AvprickStatus: {
          AttributeName: 'AvprickStatus',
          DisplayLabel: 'Status, avprickning',
          Hint: 'Hanterad/Faktura skickad till kund/Faktura parkerad/Faktura spärrad/Faktura finns på påminnelseförslag/Obetald faktura reverserad/Slutinbetalning/Makulering/Bortbokning av erbjudande/Hittar inte fakturaunderlag/Saldo stämmer inte med fakturaunderlag/Faktura, övriga ändringar/Ej hanterad situation - kontakta Eniac/Slutbetald/Delinbetalning/Avslutad inbetalning/Delbortbokning av erbjudande',
          DataType: 'Enum',
          EnumValues: new Map([['HANTERAD', 'Hanterad'], ['FAKTURA_SKICKAD_TILL_KUND', 'Faktura skickad till kund'], ['FAKTURA_PARKERAD', 'Faktura parkerad'], ['FAKTURA_SPARRAD', 'Faktura spärrad'], ['FAKTURA_FINNS_PA_PAMINNELSEFORSLAG', 'Faktura finns på påminnelseförslag'], ['OBETALD_FAKTURA_REVERSERAD', 'Obetald faktura reverserad'], ['SLUTINBETALNING', 'Slutinbetalning'], ['MAKULERING', 'Makulering'], ['BORTBOKNING_AV_ERBJUDANDE', 'Bortbokning av erbjudande'], ['HITTAR_INTE_FAKTURAUNDERLAG', 'Hittar inte fakturaunderlag'], ['SALDO_STAMMER_INTE_MED_FAKTURAUNDERLAG', 'Saldo stämmer inte med fakturaunderlag'], ['FAKTURA__OVRIGA_ANDRINGAR', 'Faktura, övriga ändringar'], ['EJ_HANTERAD_SITUATION___KONTAKTA_ENIAC', 'Ej hanterad situation - kontakta Eniac'], ['SLUTBETALD', 'Slutbetald'], ['DELINBETALNING', 'Delinbetalning'], ['AVSLUTAD_INBETALNING', 'Avslutad inbetalning'], ['DELBORTBOKNING_AV_ERBJUDANDE', 'Delbortbokning av erbjudande']]),
          EnumSortValues: new Map([['HANTERAD', 'H'], ['FAKTURA_SKICKAD_TILL_KUND', 'N'], ['FAKTURA_PARKERAD', 'P'], ['FAKTURA_SPARRAD', 'S'], ['FAKTURA_FINNS_PA_PAMINNELSEFORSLAG', 'Å'], ['OBETALD_FAKTURA_REVERSERAD', 'O'], ['SLUTINBETALNING', 'I'], ['MAKULERING', 'M'], ['BORTBOKNING_AV_ERBJUDANDE', 'B'], ['HITTAR_INTE_FAKTURAUNDERLAG', 'R'], ['SALDO_STAMMER_INTE_MED_FAKTURAUNDERLAG', 'D'], ['FAKTURA__OVRIGA_ANDRINGAR', 'Ö'], ['EJ_HANTERAD_SITUATION___KONTAKTA_ENIAC', 'X'], ['SLUTBETALD', 'U'], ['DELINBETALNING', '1'], ['AVSLUTAD_INBETALNING', '2'], ['DELBORTBOKNING_AV_ERBJUDANDE', '3']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="HANTERAD=Hanterad;FAKTURA_SKICKAD_TILL_KUND=Faktura skickad till kund;FAKTURA_PARKERAD=Faktura parkerad;FAKTURA_SPARRAD=Faktura spärrad;FAKTURA_FINNS_PA_PAMINNELSEFORSLAG=Faktura finns på påminnelseförslag;OBETALD_FAKTURA_REVERSERAD=Obetald faktura reverserad;SLUTINBETALNING=Slutinbetalning;MAKULERING=Makulering;BORTBOKNING_AV_ERBJUDANDE=Bortbokning av erbjudande;HITTAR_INTE_FAKTURAUNDERLAG=Hittar inte fakturaunderlag;SALDO_STAMMER_INTE_MED_FAKTURAUNDERLAG=Saldo stämmer inte med fakturaunderlag;FAKTURA__OVRIGA_ANDRINGAR=Faktura, övriga ändringar;EJ_HANTERAD_SITUATION___KONTAKTA_ENIAC=Ej hanterad situation - kontakta Eniac;SLUTBETALD=Slutbetald;DELINBETALNING=Delinbetalning;AVSLUTAD_INBETALNING=Avslutad inbetalning;DELBORTBOKNING_AV_ERBJUDANDE=Delbortbokning av erbjudande"',
          InterfaceType: 'ifNone',
        },
        AvprickDatum: {
          AttributeName: 'AvprickDatum',
          DisplayLabel: 'AvprickDatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BeloppDiff: {
          AttributeName: 'BeloppDiff',
          DisplayLabel: 'BeloppDiff',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        AvprickStatusDatum: {
          AttributeName: 'AvprickStatusDatum',
          DisplayLabel: 'AvprickStatusDatum',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SortAvprickStatus: {
          AttributeName: 'SortAvprickStatus',
          DisplayLabel: 'SortAvprickStatus',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Fakturabelopp: {
          AttributeName: 'Fakturabelopp',
          DisplayLabel: 'Fakturabelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        Restbelopp: {
          AttributeName: 'Restbelopp',
          DisplayLabel: 'Restbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        BI_STATUS_ELEKTRONISKFAKTURA: {
          AttributeName: 'BI_STATUS_ELEKTRONISKFAKTURA',
          DisplayLabel: 'Backningsinfo, Fakturastatus',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BI_EXTERNT_FAKTURANR: {
          AttributeName: 'BI_EXTERNT_FAKTURANR',
          DisplayLabel: 'Backningsinfo, externt fakturanr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BI_EXTERNT_VERNR: {
          AttributeName: 'BI_EXTERNT_VERNR',
          DisplayLabel: 'Backningsinfo, externt vernr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BI_EXTERNT_ORDERNR: {
          AttributeName: 'BI_EXTERNT_ORDERNR',
          DisplayLabel: 'Backningsinfo, externt ordernr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BI_EXTERN_PAMINNELSENIVA: {
          AttributeName: 'BI_EXTERN_PAMINNELSENIVA',
          DisplayLabel: 'Backningsinfo, paminnelseniva',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BI_EXTERNT_PAMINNELSEDATUM: {
          AttributeName: 'BI_EXTERNT_PAMINNELSEDATUM',
          DisplayLabel: 'Backningsinfo, påminnelsedatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BI_EXTERN_KRAVSTATUS: {
          AttributeName: 'BI_EXTERN_KRAVSTATUS',
          DisplayLabel: 'Backningsinfo, kravstatus',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BI_EXTERNT_KUNDNR: {
          AttributeName: 'BI_EXTERNT_KUNDNR',
          DisplayLabel: 'Backningsinfo, externt kundnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BI_HANDELSE_BOKFGRUPP_ID: {
          AttributeName: 'BI_HANDELSE_BOKFGRUPP_ID',
          DisplayLabel: 'Backningsinfo, bokfgrupp',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BI_HANDELSE_ID: {
          AttributeName: 'BI_HANDELSE_ID',
          DisplayLabel: 'Backningsinfo, händelse id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BI_FAKTURADATUM: {
          AttributeName: 'BI_FAKTURADATUM',
          DisplayLabel: 'Backningsinfo, fakturadatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BI_FORFALLO_DATUM: {
          AttributeName: 'BI_FORFALLO_DATUM',
          DisplayLabel: 'Backningsinfo, förfallodatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        AVPRICKAD_ENLIGT_STATUS: {
          AttributeName: 'AVPRICKAD_ENLIGT_STATUS',
          DisplayLabel: 'Avprickad enligt status',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="H=Hanterad;N=Faktura skickad till kund;P=Faktura parkerad;S=Faktura spärrad;Å=Faktura finns på påminnelseförslag;O=Obetald faktura reverserad;I=Slutinbetalning;M=Makulering;B=Bortbokning av erbjudande;R=Hittar inte fakturaunderlag;D=Saldo stämmer inte med fakturaunderlag;Ö=Faktura, övriga ändringar;X=Ej hanterad situation - kontakta Eniac;U=Slutbetald;1=Delinbetalning;2=Avslutad inbetalning;3=Delbortbokning av erbjudande"',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SortFelrapportStatus: {
          AttributeName: 'SortFelrapportStatus',
          DisplayLabel: 'SortFelrapportStatus',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BeraknatSaldo: {
          AttributeName: 'BeraknatSaldo',
          DisplayLabel: 'Beräknat saldo',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        AterrappFil: {
          AssociationName: 'AterrappFil',
          DisplayLabel: 'Återrapportering fil',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRAterrapKundfakt',
          AssociatedComponentName: 'AterrapKundfakt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        BokfverRef: {
          AssociationName: 'BokfverRef',
          DisplayLabel: 'Referens till verifikation',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRAterrappBokfver',
          AssociatedComponentName: 'AterrappBokfver',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
  },
};

export default KR;
